import { BorderOutlined, BuildFilled, HomeOutlined, ImportOutlined, QuestionCircleOutlined, ToolOutlined, UserOutlined } from "@ant-design/icons"

const Language = {
    pms: {
        'zh-tw': "生產管理系統",
        en: "Production Management System",
        children: {
            production_scheduling_management: {
                'zh-tw': "生產管理排程模組",
                en: "Production Scheduling Management",
                children: {
                    schedule_plan_order: {
                        'zh-tw': '生產排程計畫單',
                        en: 'Schedule Plan Order',
                        children: {
                            "schedule_plan_order": {
                                'zh-tw': '生產排程計畫單',
                                en: 'Schedule Plan Order',
                            },
                            "editing": {
                                'zh-tw': '編輯',
                                en: 'Edit',
                            },
                            "create": {
                                'zh-tw': '新增',
                                en: 'create',
                            },
                            "read": {
                                'zh-tw': '瀏覽',
                                en: 'read',
                            },
                            "edit": {
                                'zh-tw': '資料編輯',
                                en: 'Edit',
                            },
                            "copy": {
                                'zh-tw': '資料複製',
                                en: 'Copy',
                            },
                            "delete": {
                                'zh-tw': '資料刪除',
                                en: 'Delete',
                            },
                            "operate": {
                                'zh-tw': '操作',
                                en: 'Operate',
                            },
                            schedule_date: {
                                'zh-tw': '排程日期',
                                en: 'Schedule Date',
                            },
                            schedule_order_maker_employee_name: {
                                'zh-tw': "製單人員",
                                en: "Schedule Order Number"
                            },
                            reviewer_id: {
                                'zh-tw': "覆核人員",
                                en: "Schedule Order Number"
                            },
                            controller: {
                                'zh-tw': '控管人員',
                                en: 'controller',
                            },
                            delivery_time: {
                                'zh-tw': '交貨區間',
                                en: 'Delivery Time',
                            },
                            warehouse_area_id: {
                                'zh-tw': '倉庫區間',
                                en: 'Warehouse Area',
                            },
                            schedule_order_number: {
                                'zh-tw': "排程單號",
                                en: "Schedule Order Number"
                            },
                            serial_number: {
                                'zh-tw': "序號",
                                en: "Serial Number"
                            },
                            source_type: {
                                'zh-tw': "來源別",
                                en: "Source Type"
                            },
                            source_number: {
                                'zh-tw': "來源單號",
                                en: "Source Number"
                            },
                            product_number: {
                                'zh-tw': "產品編號",
                                en: "Product Number"
                            },
                            product_name: {
                                'zh-tw': "品名",
                                en: "Product Name"
                            },
                            actual_production_quantity: {
                                'zh-tw': "實際生產數量",
                                en: "Actual Production Quantity"
                            },
                            unit: {
                                'zh-tw': "單位名稱",
                                en: "Unit"
                            },
                            order_required_production_quantity: {
                                'zh-tw': "原訂單需生產數量",
                                en: "Order required production quantity"
                            },
                            scheduled_delivery_date: {
                                'zh-tw': "預交貨日",
                                en: "Scheduled Delivery Date"
                            },
                            estimated_completion_date: {
                                'zh-tw': "預完工日",
                                en: "Estimated Completion Date"
                            },
                            scheduled: {
                                'zh-tw': "已排程",
                                en: "scheduled"
                            },
                        },
                    },
                    material_requirements_estimation: {
                        'zh-tw': '物料需求估算',
                        en: 'Material Requirements Estimation',
                        children: {
                            product_number: {
                                'zh-tw': "產品編號",
                                en: "Product Number"
                            },
                            product_name: {
                                'zh-tw': "產品名稱",
                                en: "Product Name"
                            },
                            production_details: {
                                'zh-tw': "生產明細",
                                en: "Production Details"
                            },
                            manufacture_order_type: {
                                'zh-tw': "製令類別",
                                en: "Manufacture Order Type"
                            },
                            order_number: {
                                'zh-tw': "單號",
                                en: "Order Number"
                            },
                            estimated_start_date: {
                                'zh-tw': "預定開工日",
                                en: "Estimated Start Date"
                            },
                            estimated_complete_date: {
                                'zh-tw': "預定完工日",
                                en: "Estimated Complete Date"
                            },
                            production_quantity: {
                                'zh-tw': "生產數量",
                                en: "Production Quantity"
                            },
                            source_type: {
                                'zh-tw': "來源別",
                                en: "Source Type"
                            },
                            source_number: {
                                'zh-tw': "來源單號",
                                en: "Source Number"
                            },
                            estimated_range: {
                                'zh-tw': "估算範圍",
                                en: "Estimated Range"
                            },
                            mps_order_number: {
                                'zh-tw': "MPS 單號",
                                en: "MPS Order Number"
                            },
                            simulation_manufacture_order: {
                                'zh-tw': "模擬製令",
                                en: "Simulation Manufacture Order"
                            },
                            formal_manufacture_order: {
                                'zh-tw': "正式製令",
                                en: "Formal Manufacture Order"
                            },
                            included_implemented_mpr_manufacture_order: {
                                'zh-tw': "納入已執行 MPR 製令",
                                en: "Included Implemented MPR  Manufacture Order"
                            },
                            included_implemented_mpr_manufacture_order: {
                                'zh-tw': "納入已執行 MPR 製令",
                                en: "Included Implemented MPR  Manufacture Order"
                            },
                            simulation_field_manufacture_order: {
                                'zh-tw': "模擬廠內製令",
                                en: "Simulation Field Manufacture Order"
                            },
                            simulation_outsourcing_manufacture_order: {
                                'zh-tw': "模擬委外製令",
                                en: "Simulation Outsourcing Manufacture Order"
                            },
                            simulation_multiple_processing: {
                                'zh-tw': "模擬多次加工",
                                en: "Simulation Multiple Processing"
                            },
                            estimated_start_date: {
                                'zh-tw': "預定開工區間",
                                en: "Estimated Start Date"
                            },

                            formal_field_manufacture_order: {
                                'zh-tw': "正式廠內製令",
                                en: "Formal Field Manufacture Order"
                            },
                            formal_outsourcing_manufacture_order: {
                                'zh-tw': "正式委外製令",
                                en: "Formal Outsourcing Manufacture Order"
                            },
                            formal_multiple_processing: {
                                'zh-tw': "模擬多次加工",
                                en: "Formal Multiple Processing"
                            },
                            warehouse_area_id: {
                                'zh-tw': "倉庫區間",
                                en: "Warehouse Area"
                            }
                        },
                    },
                    online_production_schedule: {
                        'zh-tw': '線上生產排程',
                        en: 'online_production_schedule',
                        children: {
                            order_process_list_id: {
                                'zh-tw': '製令單號',
                                en: 'order process list number',

                            },
                            list: {
                                'zh-tw': '製令單列表',
                                en: 'Order list',
                                children: {
                                }
                            },
                            content: {
                                'zh-tw': '排程資訊',
                                en: 'Process Infomation',
                                children: {
                                }
                            },
                            create_time: {
                                'zh-tw': '建立時間',
                                en: 'Create Time',
                            },
                            order_code: {
                                'zh-tw': '單據編號',
                                en: 'Order Code',
                            },
                            order_process_list_status_name: {
                                'zh-tw': '製程清單狀態',
                                en: 'Order Process List Status',
                            },
                            process_status_name: {
                                'zh-tw': '製程狀態',
                                en: 'Process Status',
                            },
                            product_code: {
                                'zh-tw': '產品編號',
                                en: 'Product Code',
                            },
                            product_name: {
                                'zh-tw': '產品名稱',
                                en: 'Product Name',
                            },
                            product_quantity: {
                                'zh-tw': '產品數量',
                                en: 'Product Quantity',
                            },
                            print: {
                                'zh-tw': '列印',
                                en: 'Print'
                            },
                            export: {
                                'zh-tw': '匯出資料',
                                en: 'Export Data'
                            },
                            import: {
                                'zh-tw': '匯入資料',
                                en: 'Import Data',
                                children: {
                                    sample: {
                                        'zh-tw': '下載範例',
                                        en: 'Download Sample'
                                    },
                                    upload: {
                                        'zh-tw': '上傳Excel檔案',
                                        en: 'Upload Excel File'
                                    },
                                    preview: {
                                        'zh-tw': '預覽檔案',
                                        en: 'Preview File'
                                    },
                                    finish: {
                                        'zh-tw': '確認匯入',
                                        en: 'Confirm'
                                    },
                                    close: {
                                        'zh-tw': '關閉',
                                        en: 'Close'
                                    },
                                    table_column_name: {
                                        'zh-tw': '名稱',
                                        en: 'Name'
                                    },
                                    table_column_process_codes: {
                                        'zh-tw': '製程代號',
                                        en: 'Process Code'
                                    },
                                    table_column_durations: {
                                        'zh-tw': '標準工時',
                                        en: 'Standard Process Duration'
                                    },
                                    table_column_minutes: {
                                        'zh-tw': '分',
                                        en: 'Minutes'
                                    },
                                }
                            },
                            edit: {
                                'zh-tw': '資料編輯',
                                en: 'Edit Data'
                            },
                            copy: {
                                'zh-tw': '資料複製',
                                en: 'Copy Data'
                            },
                            delete: {
                                'zh-tw': '資料刪除',
                                en: 'Delete Data'
                            },
                            table_form_number: {
                                'zh-tw': '筆數',
                                en: 'Size'
                            },
                            table_form_number_suffix: {
                                'zh-tw': '筆',
                                en: ''
                            },
                            table_form_search_placeholder: {
                                'zh-tw': '智慧搜尋',
                                en: 'Search'
                            },
                            table_column_operation: {
                                'zh-tw': '操作',
                                en: 'Functions'
                            },
                            table_column_order_code: {
                                'zh-tw': '訂單編號',
                                en: 'Order Code'
                            },
                            table_column_product_code: {
                                'zh-tw': '產品編號',
                                en: 'Product Code'
                            },
                            table_column_product_name: {
                                'zh-tw': '產品名稱',
                                en: 'Product Name'
                            },
                            table_column_description: {
                                'zh-tw': '備註',
                                en: 'Description'
                            },
                            table_column_serial: {
                                'zh-tw': '加工順序',
                                en: '#'
                            },
                            table_column_process_names: {
                                'zh-tw': '已排定製程',
                                en: 'Planned Process'
                            },
                            table_column_process_code: {
                                'zh-tw': '製程代號',
                                en: 'Process Code'
                            },
                            table_column_process_name: {
                                'zh-tw': '製程名稱',
                                en: 'Process Name'
                            },
                            table_column_process_description: {
                                'zh-tw': '製程敘述',
                                en: 'Process Description'
                            },
                            table_column_process_status: {
                                'zh-tw': '性質',
                                en: 'Process Class'
                            },
                            table_column_item_code: {
                                'zh-tw': '材料編號',
                                en: 'Item Code'
                            },
                            table_column_item_name: {
                                'zh-tw': '材料品名',
                                en: 'Item Name'
                            },
                            table_column_item_count: {
                                'zh-tw': '應領用量',
                                en: 'Item Count'
                            },
                            table_column_item_unit: {
                                'zh-tw': '用量單位',
                                en: 'Item Unit'
                            },
                            table_column_item_description: {
                                'zh-tw': '備註',
                                en: 'Item Description'
                            },
                            operation: {
                                'zh-tw': '操作',
                                en: 'Functions'
                            },
                            // order_process_id 製令單製程id
                            // order_process_list_id 製令單id
                            // serial 製程序號
                            // process_name 製程名稱
                            // process_status_name 廠內or委外
                            // start_time 預計開始時間
                            // end_time 預計結束時間
                            order_process_list_id: {
                                'zh-tw': '製令單號',
                                en: 'order process list number'
                            },
                            order_process_id: {
                                'zh-tw': '製程代號',
                                en: 'order_process_id'
                            },
                            serial: {
                                'zh-tw': '製程序號',
                                en: 'serial'
                            },
                            process_name: {
                                'zh-tw': '製程名稱',
                                en: 'process_name'
                            },
                            process_status_name: {
                                'zh-tw': '製令類型',
                                en: 'process_status_name'
                            },
                            start_time: {
                                'zh-tw': '預計開始時間',
                                en: 'start_time'
                            },
                            end_time: {
                                'zh-tw': '預計結束時間',
                                en: 'end time'
                            },
                            outsourcing: {
                                'zh-tw': '產生外包',
                                en: 'Outsourcing'
                            },
                        }
                    },
                    planned_production_order: {
                        'zh-tw': '計畫生產單',
                        en: '',
                        children: {

                        }
                    },
                    production_processes_adjustment: {
                        'zh-tw': '生產排程調整',
                        en: 'production_processes_adjustment',
                        children: {
                            operation: {
                                "zh-tw": "操作",
                                en: "operation",
                                children: {
                                    search: {
                                        "zh-tw": "搜尋",
                                        en: "search",
                                        children: {
                                            select_searching_time: {
                                                "zh-tw": "選擇查詢時間",
                                                en: "Select Searching Time"
                                            },
                                            search_button: {
                                                "zh-tw": "查詢",
                                                en: "Search"
                                            }
                                        }
                                    }
                                }
                            },
                            calendar_timeline: {
                                "zh-tw": "排程時程表",
                                en: "Calendar Timeline",
                                children: {
                                    pms_popconfirm: {
                                        "zh-tw": "顯示框",
                                        en: "Process Popconfirm",
                                        children: {
                                            popconfirm_title: {
                                                "zh-tw": "製程資訊",
                                                en: "Process Information"
                                            },
                                            card_title: {
                                                "zh-tw": "製程名稱",
                                                en: "Process Name"
                                            },
                                            card_process_start_time: {
                                                "zh-tw": "製程開始時間",
                                                en: "Process Start Time"
                                            },
                                            card_process_end_time: {
                                                "zh-tw": "製程結束時間",
                                                en: "Process End Time"
                                            },
                                            card_selection: {
                                                "zh-tw": "選擇欲排入製程之機台",
                                                en: "Please select the machine that you willing to arrange process loading"
                                            },
                                            card_input_addonAfter: {
                                                "zh-tw": "小時",
                                                en: "hour(s)"
                                            },
                                            card_input_placeholder: {
                                                "zh-tw": "欲排入幾小時？",
                                                en: "Hour(s) willing to arrange for machine"
                                            },
                                            card_remark: {
                                                "zh-tw": "＊＊按下確認將製程排入所選機台",
                                                en: "＊＊Press confirm button to arrange process for machine"
                                            },
                                            ok_text: {
                                                "zh-tw": "確認",
                                                en: "Confirm"
                                            },
                                            cancel_text: {
                                                "zh-tw": "取消",
                                                en: "Cancel"
                                            }
                                        }
                                    }
                                }
                            },
                            schedule_timeline: {
                                "zh-tw": "排程總攬",
                                en: "Schedule Timeline",
                                children: {
                                    pms_machine_carousel: {
                                        "zh-tw": "機台資訊跑馬燈",
                                        en: "Information Carousel For Machine",
                                        children: {
                                            card_title: {
                                                "zh-tw": "機台派工",
                                                en: "Machine Dispatching"
                                            },
                                            card_descriptions_title_crew: {
                                                "zh-tw": "機台組員：",
                                                en: "Machine Crew："
                                            },
                                            card_descriptions_title_loading: {
                                                "zh-tw": "機台負載：",
                                                en: "Loading："
                                            },
                                            card_descriptions_title_team_leader: {
                                                "zh-tw": "組長名稱：",
                                                en: "Team Leader："
                                            },
                                            three_day: {
                                                "zh-tw": "三天",
                                                en: "Three Day"
                                            },
                                            five_day: {
                                                "zh-tw": "五天",
                                                en: "Five Day"
                                            },
                                            a_week: {
                                                "zh-tw": "一週",
                                                en: "A Week"
                                            },
                                            loading_chart_time_display: {
                                                "zh-tw": "機台 Loading chart 時間呈現",
                                                en: "Time Display For Loading Chart"
                                            },
                                        }
                                    },
                                    pms_notification: {
                                        "zh-tw": "通知",
                                        en: "Notification",
                                        children: {
                                            message: {
                                                "zh-tw": "修改完成",
                                                en: "Update Finished"
                                            },
                                            description: {
                                                "zh-tw": "組長可進行機台派工或是重新排程！",
                                                en: "Team leader can dispatch or rearrange process for machine now！"
                                            }
                                        }
                                    },
                                    timeline_dragging: {
                                        "zh-tw": "當前拖曳時間點(方框之開始時間點)",
                                        en: "Current Dragging Time (Item's Start Time)",
                                        children: {
                                        }
                                    },
                                    timeline_that_has_most_items_group: {
                                        "zh-tw": "時間區段內擁有最多排程之組別",
                                        en: "Group(s) that has(have) the most items in timeline",
                                        children: {
                                        }
                                    },
                                    timeline_that_has_most_items_group_description: {
                                        "zh-tw": "總排程數",
                                        en: "Total items amount",
                                        children: {
                                        }
                                    },
                                    confirm_update_button: {
                                        "zh-tw": "確定完成排程",
                                        en: "Confirm Finishing Process arrangement",
                                        children: {
                                        }
                                    },
                                    badge_ribbon: {
                                        "zh-tw": "說明框",
                                        en: "Explanation Card",
                                        children: {
                                            manual: {
                                                "zh-tw": "使用說明",
                                                en: "Manual",
                                                children: {
                                                    title: {
                                                        "zh-tw": "使用說明",
                                                        en: "Manual"
                                                    },
                                                    card_title: {
                                                        "zh-tw": "排程工具",
                                                        en: "Schedule Arrange Tool"
                                                    },
                                                    card_descriptions_item: {
                                                        "zh-tw": "詳細說明",
                                                        en: "Description Detail",
                                                        children: {
                                                            time_zooming_label: {
                                                                "zh-tw": "-時間縮放",
                                                                en: "-Time Zooming"
                                                            },
                                                            time_zooming_content: {
                                                                "zh-tw": "滑鼠滾輪滑動以做縮放",
                                                                en: "Scroll the mouse for time zooming"
                                                            },
                                                            time_checking_label: {
                                                                "zh-tw": "-時間查看",
                                                                en: "-Time Checking"
                                                            },
                                                            time_checking_content: {
                                                                "zh-tw": "滑鼠按住空白處並且左右滑動",
                                                                en: "Click the empty space and slide left or right the mouse"
                                                            },
                                                            process_adjustment_label: {
                                                                "zh-tw": "-製程調整",
                                                                en: "-Process Adjustment"
                                                            },
                                                            process_adjustment_content: {
                                                                "zh-tw": "點擊製程，滑鼠按住製程方框右方邊界並左右滑動",
                                                                en: "Click the process item, and then click down item right side and slide left or right the mouse"
                                                            },
                                                            process_order_label: {
                                                                "zh-tw": "-製程順序",
                                                                en: "-Process Order"
                                                            },
                                                            process_order_content: {
                                                                "zh-tw": "點擊製程，滑鼠按住製程方框並左右滑動",
                                                                en: "Click the process item, and then click down item and slide left or right the mouse"
                                                            },
                                                            process_detail_label: {
                                                                "zh-tw": "-製程詳細資訊",
                                                                en: "-Process Detail"
                                                            },
                                                            process_detail_content: {
                                                                "zh-tw": "點擊製程名稱",
                                                                en: "Click the process item tilt"
                                                            },
                                                            machine_loading_searching_label: {
                                                                "zh-tw": "-機台 Loading 查詢",
                                                                en: "-Process Detail"
                                                            },
                                                            machine_loading_searching_content: {
                                                                "zh-tw": "雙擊製程方框",
                                                                en: "Double click the process item"
                                                            }
                                                        }
                                                    }
                                                }
                                            },
                                            team_leader_dispatching: {
                                                "zh-tw": "組長派工",
                                                en: "Team Leader Dispatching",
                                                children: {
                                                    title: {
                                                        "zh-tw": "組長派工",
                                                        en: "Team Leader Dispatching"
                                                    },
                                                    card_title: {
                                                        "zh-tw": "今日欲完成製程",
                                                        en: "Today's processes waiting to finish"
                                                    },
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    },

                }

            },
            basic_data_maintain_management: {
                'zh-tw': "基本資料維護模組",
                en: "Basic Data Maintain Management",
                children: {
                    assembly_line_setting: {
                        'zh-tw': "生產線資料建立作業",
                        en: "Assembly Line Setting",
                        children: {
                            /* Basic functional setting */
                            go_back: {
                                "zh-tw": "返回",
                                en: "Go Back"
                            },
                            print: {
                                'zh-tw': '列印',
                                en: 'Print'
                            },
                            export: {
                                'zh-tw': '匯出資料',
                                en: 'Export Data'
                            },
                            import: {
                                'zh-tw': '匯入資料',
                                en: 'Import Data',
                                children: {
                                    sample: {
                                        'zh-tw': '下載範例',
                                        en: 'Download Sample'
                                    },
                                    upload: {
                                        'zh-tw': '上傳Excel檔案',
                                        en: 'Upload Excel File'
                                    },
                                    preview: {
                                        'zh-tw': '預覽檔案',
                                        en: 'Preview File'
                                    },
                                    finish: {
                                        'zh-tw': '確認匯入',
                                        en: 'Confirm'
                                    },
                                    close: {
                                        'zh-tw': '關閉',
                                        en: 'Close'
                                    },
                                }
                            },
                            edit: {
                                'zh-tw': '資料編輯',
                                en: 'Edit Data'
                            },
                            copy: {
                                'zh-tw': '資料複製',
                                en: 'Copy Data'
                            },
                            delete: {
                                'zh-tw': '資料刪除',
                                en: 'Delete Data'
                            },
                            /* Basic functional setting */
                            assembly_line_id: {
                                'zh-tw': "生產線編號",
                                en: "Assembly Line ID"
                            },
                            assembly_line_code: {
                                'zh-tw': "生產線代號",
                                en: "Assembly Line Code"
                            },
                            assembly_line_name: {
                                'zh-tw': "生產線名稱",
                                en: "Assembly Line Name"
                            },
                            contact_person: {
                                "zh-tw": "聯絡人員",
                                en: "Contact Person"
                            },
                            phone: {
                                "zh-tw": "現場電話",
                                en: "Phone"
                            },
                            responsible_person: {
                                "zh-tw": "負責人員",
                                en: "Responsible Person"
                            },
                            a_branch: {
                                'zh-tw': "廠別名稱",
                                en: "Assembly Line Branch"
                            },
                            daily_labor_productivity: {
                                'zh-tw': "每日人工產能",
                                en: "Daily Labor Productivity"
                            },
                            daily_mach_productivity: {
                                'zh-tw': "每日機器產能",
                                en: "Daily Machine Productivity"
                            },
                            std_labor_efficiency: {
                                'zh-tw': "標準人工效率",
                                en: "Standard Labor Efficiency"
                            },
                            std_mach_loading: {
                                'zh-tw': "標準機器負荷",
                                en: "Standard Machine Loading"
                            },
                            std_labor_cost: {
                                'zh-tw': "標準人工成本",
                                en: "Standard Labor Cost"
                            },
                            std_production_overhead: {
                                'zh-tw': "標準製造費用",
                                en: "Standard Production Overhead"
                            },
                            remark: {
                                'zh-tw': "備註",
                                en: "remark"
                            },
                            manufactoring_overhead_basis_id: {
                                'zh-tw': "製費分攤依據",
                                en: "Manufactoring Overhead Basis ID"
                            },
                            manufactoring_overhead_basis_name: {
                                'zh-tw': "製費分攤依據",
                                en: "Manufactoring Overhead Basis Name"
                            },
                            linked_machine: {
                                "zh-tw": "綁定機台",
                                en: "Linked Machine"
                            },
                            table_column_operation: {
                                'zh-tw': '操作',
                                en: 'Functions'
                            },
                            table_column_machine_id: {
                                "zh-tw": "機台編號",
                                en: "Machine ID"
                            },
                            table_column_machine_code: {
                                "zh-tw": "機台代號",
                                en: "Machine Code"
                            },
                            table_column_machine_name: {
                                "zh-tw": "機台名稱",
                                en: "Machine Name"
                            },
                            table_column_machine_productivity: {
                                "zh-tw": "機器產能",
                                en: "Machine Productivity"
                            },
                            table_column_machine_load_ratio: {
                                "zh-tw": "負荷率",
                                en: "Machine Load Ratio"
                            },
                            button_edit_permission_title: {
                                'zh-tw': '修改人員權限',
                                en: 'Edit Permission'
                            },
                            button_edit_permission_subtitle: {
                                'zh-tw': '您正在修改{X} {Y}的權限',
                                en: 'You are modifying permissions for {X} {Y}'
                            }
                        }
                    },
                    process_setting: {
                        "zh-tw": "製程代號建立作業",
                        en: "Process Setting",
                        children: {
                            /* Basic functional setting */
                            add_staff: {
                                'zh-tw': '新增製程',
                                en: 'Add Staff'
                            },
                            go_back: {
                                "zh-tw": "返回",
                                en: "Go Back"
                            },
                            print: {
                                'zh-tw': '列印',
                                en: 'Print'
                            },
                            export: {
                                'zh-tw': '匯出資料',
                                en: 'Export Data'
                            },
                            import: {
                                'zh-tw': '匯入資料',
                                en: 'Import Data',
                                children: {
                                    sample: {
                                        'zh-tw': '下載範例',
                                        en: 'Download Sample'
                                    },
                                    upload: {
                                        'zh-tw': '上傳Excel檔案',
                                        en: 'Upload Excel File'
                                    },
                                    preview: {
                                        'zh-tw': '預覽檔案',
                                        en: 'Preview File'
                                    },
                                    finish: {
                                        'zh-tw': '確認匯入',
                                        en: 'Confirm'
                                    },
                                    close: {
                                        'zh-tw': '關閉',
                                        en: 'Close'
                                    },
                                }
                            },
                            edit: {
                                'zh-tw': '資料編輯',
                                en: 'Edit Data'
                            },
                            copy: {
                                'zh-tw': '資料複製',
                                en: 'Copy Data'
                            },
                            delete: {
                                'zh-tw': '資料刪除',
                                en: 'Delete Data'
                            },
                            table_column_operation: {
                                'zh-tw': '操作',
                                en: 'Functions'
                            },
                            /* Basic functional setting */
                            process_id: {
                                "zh-tw": "製程編號",
                                en: "Process ID"
                            },
                            process_code: {
                                "zh-tw": "製程代號",
                                en: "Process Code"
                            },
                            process_name: {
                                "zh-tw": "製程名稱",
                                en: "Process Name"
                            },
                            process_description: {
                                "zh-tw": "製程敘述",
                                en: "Process Description"
                            },
                            process_status: {
                                "zh-tw": "性質",
                                en: "Process status"
                            },
                            assembly_line_id_or_company_id: {
                                "zh-tw": "線別/廠商代號",
                                en: "Assembly/Company ID"
                            },
                            assembly_line_name_or_company_name: {
                                "zh-tw": "線別/廠商名稱",
                                en: "Assembly/Company Name"
                            },
                            responsible_person: {
                                "zh-tw": "發包人員",
                                en: "Responsible Preson"
                            },
                            remark: {
                                "zh-tw": "備註",
                                en: "remark"
                            },
                            button_edit_permission_title: {
                                'zh-tw': '修改人員權限',
                                en: 'Edit Permission'
                            },
                            button_edit_permission_subtitle: {
                                'zh-tw': '您正在修改{X} {Y}的權限',
                                en: 'You are modifying permissions for {X} {Y}'
                            }
                        }
                    },
                    company_setting: {
                        "zh-tw": "廠商資料建立",
                        en: "Company Setting",
                        children: {
                            /* Basic functional setting */
                            add_staff: {
                                'zh-tw': '新增成員',
                                en: 'Add Staff'
                            },
                            print: {
                                'zh-tw': '列印',
                                en: 'Print'
                            },
                            export: {
                                'zh-tw': '匯出資料',
                                en: 'Export Data'
                            },
                            import: {
                                'zh-tw': '匯入資料',
                                en: 'Import Data',
                                children: {
                                    sample: {
                                        'zh-tw': '下載範例',
                                        en: 'Download Sample'
                                    },
                                    upload: {
                                        'zh-tw': '上傳Excel檔案',
                                        en: 'Upload Excel File'
                                    },
                                    preview: {
                                        'zh-tw': '預覽檔案',
                                        en: 'Preview File'
                                    },
                                    finish: {
                                        'zh-tw': '確認匯入',
                                        en: 'Confirm'
                                    },
                                    close: {
                                        'zh-tw': '關閉',
                                        en: 'Close'
                                    },
                                }
                            },
                            edit: {
                                'zh-tw': '資料編輯',
                                en: 'Edit Data'
                            },
                            copy: {
                                'zh-tw': '資料複製',
                                en: 'Copy Data'
                            },
                            delete: {
                                'zh-tw': '資料刪除',
                                en: 'Delete Data'
                            },
                            table_column_operation: {
                                'zh-tw': '操作',
                                en: 'Functions'
                            },
                            /* Basic functional setting */
                            company_id: {
                                "zh-tw": "廠商編號",
                                en: "Company ID"
                            },
                            company_code: {
                                "zh-tw": "廠商代號",
                                en: "Company Code"
                            },
                            company_short_name: {
                                "zh-tw": "廠商簡稱",
                                en: "Company Short Name"
                            },
                            company_long_name: {
                                "zh-tw": "廠商全名",
                                en: "Company Long Name"
                            },
                            account_attribution: {
                                "zh-tw": "帳款歸屬",
                                en: "Account Attribution"
                            },
                            is_international: {
                                "zh-tw": "國外廠商",
                                en: "Is International"
                            },
                            tax_id_number: {
                                "zh-tw": "統一編號",
                                en: "Tax ID Nnumber"
                            },
                            company_class: {
                                "zh-tw": "廠商類型",
                                en: "Company Class"
                            },
                            c_category: {
                                "zh-tw": "廠商類別",
                                en: "Company Category"
                            },
                            c_area: {
                                "zh-tw": "區域",
                                en: "Area"
                            },
                            c_currency: {
                                "zh-tw": "幣別",
                                en: "Currency"
                            },
                            c_type: {
                                "zh-tw": "廠商種類",
                                en: "Type"
                            },
                            is_failed: {
                                "zh-tw": "失效",
                                en: "Is Failed"
                            },
                            responsible_person: {
                                "zh-tw": "負責人",
                                en: "Responsible Person"
                            },
                            responsible_person_mobile_phone: {
                                "zh-tw": "負責人手機",
                                en: "Responsible Person Mobile Phone"
                            },
                            contact_person: {
                                "zh-tw": "聯絡人",
                                en: "Contact Person"
                            },
                            contact_person_mobile_phone: {
                                "zh-tw": "聯絡人手機",
                                en: "Contact Person Mobile Phone"
                            },
                            contact_person_phone: {
                                "zh-tw": "聯絡人電話",
                                en: "Contact Person Phone"
                            },
                            accountant: {
                                "zh-tw": "會計",
                                en: "Accountant"
                            },
                            accountant_mobile_phone: {
                                "zh-tw": "會計手機",
                                en: "Accountant Mobile Phone"
                            },
                            accountant_phone: {
                                "zh-tw": "會計電話",
                                en: "Accountant Phone"
                            },
                            purchase_person: {
                                "zh-tw": "採購人",
                                en: "Purchase Person"
                            },
                            tel: {
                                "zh-tw": "傳真電話",
                                en: "Tel"
                            },
                            e_mail: {
                                "zh-tw": "E-Mail",
                                en: "E-Mail"
                            },
                            url: {
                                "zh-tw": "網址",
                                en: "URL"
                            },
                            business_address: {
                                "zh-tw": "營業地址",
                                en: "Business Address"
                            },
                            billing_address: {
                                "zh-tw": "帳單地址",
                                en: "Billing Address"
                            },
                            remark: {
                                "zh-tw": "備註",
                                en: "Remark"
                            },
                            /* Tabs */
                            basic_data: {
                                "zh-tw": "基本資料",
                                en: "Basic Data"
                            },
                            address: {
                                "zh-tw": "英文地址",
                                en: "Addresss"
                            },
                            transactional_data: {
                                "zh-tw": "交易資料",
                                en: "Transactional Data"
                            },
                            data_browsing: {
                                'zh-tw': "資料瀏覽",
                                en: "Data Browsing"
                            },
                            /* Tabs */
                            button_edit_permission_title: {
                                'zh-tw': '修改人員權限',
                                en: 'Edit Permission'
                            },
                            button_edit_permission_subtitle: {
                                'zh-tw': '您正在修改{X} {Y}的權限',
                                en: 'You are modifying permissions for {X} {Y}'
                            }
                        }
                    },
                    machine_setting: {
                        "zh-tw": "加工機台資料維護",
                        en: "Machine Setting",
                        children: {
                            /* Basic functional setting */
                            add_staff: {
                                'zh-tw': '新增成員',
                                en: 'Add Staff'
                            },
                            print: {
                                'zh-tw': '列印',
                                en: 'Print'
                            },
                            export: {
                                'zh-tw': '匯出資料',
                                en: 'Export Data'
                            },
                            import: {
                                'zh-tw': '匯入資料',
                                en: 'Import Data',
                                children: {
                                    sample: {
                                        'zh-tw': '下載範例',
                                        en: 'Download Sample'
                                    },
                                    upload: {
                                        'zh-tw': '上傳Excel檔案',
                                        en: 'Upload Excel File'
                                    },
                                    preview: {
                                        'zh-tw': '預覽檔案',
                                        en: 'Preview File'
                                    },
                                    finish: {
                                        'zh-tw': '確認匯入',
                                        en: 'Confirm'
                                    },
                                    close: {
                                        'zh-tw': '關閉',
                                        en: 'Close'
                                    },
                                }
                            },
                            edit: {
                                'zh-tw': '資料編輯',
                                en: 'Edit Data'
                            },
                            copy: {
                                'zh-tw': '資料複製',
                                en: 'Copy Data'
                            },
                            delete: {
                                'zh-tw': '資料刪除',
                                en: 'Delete Data'
                            },
                            table_column_operation: {
                                'zh-tw': '操作',
                                en: 'Functions'
                            },
                            /* Basic functional setting */
                            machine_code: {
                                "zh-tw": "機台代號",
                                en: "Machine Code"
                            },
                            machine_name: {
                                "zh-tw": "機台名稱",
                                en: "Machine Name"
                            },
                            machine_status: {
                                "zh-tw": "機台狀態",
                                en: "Machine Status"
                            },
                            max_batch_number: {
                                "zh-tw": "最大批數",
                                en: "Max Batch Number"
                            },
                            responsible_person: {
                                "zh-tw": "負責人",
                                en: "Responsible Person"
                            },
                            direction: {
                                "zh-tw": "說明",
                                en: "Direction"
                            },
                            being_used: {
                                "zh-tw": "啟用狀態",
                                en: "Being Used"
                            },
                            max_quantity: {
                                "zh-tw": "最大數量",
                                en: "Max Quantity"
                            },
                            max_batch: {
                                "zh-tw": "最大容納批次",
                                en: "Max Batch"
                            },
                            machine_module: {
                                "zh-tw": "部門",
                                en: "Module"
                            },
                            m_type: {
                                "zh-tw": "機台型態",
                                en: "Machine Type"
                            },
                            max_number_of_batch: {
                                "zh-tw": "批次最大容納批數",
                                en: "Max Number Of Batch"
                            },
                            std_working_time: {
                                "zh-tw": "標準作業時間",
                                en: "Standard Working Time"
                            },
                            is_connected: {
                                "zh-tw": "連線能力",
                                en: "Is Connected"
                            },
                            button_edit_permission_title: {
                                'zh-tw': '修改人員權限',
                                en: 'Edit Permission'
                            },
                            button_edit_permission_subtitle: {
                                'zh-tw': '您正在修改{X} {Y}的權限',
                                en: 'You are modifying permissions for {X} {Y}'
                            }
                        }
                    },
                    transfer_order_setting: {
                        "zh-tw": "加工移轉類別資料維護",
                        en: "Transfer Order Setting",
                        children: {
                            /* Basic functional setting */
                            add_staff: {
                                'zh-tw': '新增成員',
                                en: 'Add Staff'
                            },
                            print: {
                                'zh-tw': '列印',
                                en: 'Print'
                            },
                            export: {
                                'zh-tw': '匯出資料',
                                en: 'Export Data'
                            },
                            import: {
                                'zh-tw': '匯入資料',
                                en: 'Import Data',
                                children: {
                                    sample: {
                                        'zh-tw': '下載範例',
                                        en: 'Download Sample'
                                    },
                                    upload: {
                                        'zh-tw': '上傳Excel檔案',
                                        en: 'Upload Excel File'
                                    },
                                    preview: {
                                        'zh-tw': '預覽檔案',
                                        en: 'Preview File'
                                    },
                                    finish: {
                                        'zh-tw': '確認匯入',
                                        en: 'Confirm'
                                    },
                                    close: {
                                        'zh-tw': '關閉',
                                        en: 'Close'
                                    },
                                }
                            },
                            edit: {
                                'zh-tw': '資料編輯',
                                en: 'Edit Data'
                            },
                            copy: {
                                'zh-tw': '資料複製',
                                en: 'Copy Data'
                            },
                            delete: {
                                'zh-tw': '資料刪除',
                                en: 'Delete Data'
                            },
                            table_column_operation: {
                                'zh-tw': '操作',
                                en: 'Functions'
                            },
                            /* Basic functional setting */
                            transfer_order_id: {
                                "zh-tw": "單別",
                                en: "Transfer Order ID"
                            },
                            transfer_order_name: {
                                "zh-tw": "單據名稱",
                                en: "Transfer Order Name"
                            },
                            process_status: {
                                "zh-tw": "單據性質",
                                en: "Order Status"
                            },
                            transfer_order_kind: {
                                "zh-tw": "單據類別",
                                en: "Transfer Order Kind"
                            },
                            button_edit_permission_title: {
                                'zh-tw': '修改人員權限',
                                en: 'Edit Permission'
                            },
                            button_edit_permission_subtitle: {
                                'zh-tw': '您正在修改{X} {Y}的權限',
                                en: 'You are modifying permissions for {X} {Y}'
                            }
                        }
                    },
                    outsourcing_return_setting: {
                        "zh-tw": "委外退貨類別資料維護",
                        en: "Oursourcing Return Setting",
                        children: {
                            /* Basic functional setting */
                            add_staff: {
                                'zh-tw': '新增成員',
                                en: 'Add Staff'
                            },
                            print: {
                                'zh-tw': '列印',
                                en: 'Print'
                            },
                            export: {
                                'zh-tw': '匯出資料',
                                en: 'Export Data'
                            },
                            import: {
                                'zh-tw': '匯入資料',
                                en: 'Import Data'
                            },
                            edit: {
                                'zh-tw': '資料編輯',
                                en: 'Edit Data'
                            },
                            copy: {
                                'zh-tw': '資料複製',
                                en: 'Copy Data'
                            },
                            delete: {
                                'zh-tw': '資料刪除',
                                en: 'Delete Data'
                            },
                            /* Basic functional setting */
                            process_status: {
                                "zh-tw": "加工狀態",
                                en: "Process Status"
                            },
                            process_status_setting: {
                                "zh-tw": "加工狀態設定",
                                en: "Process Status Setting"
                            },
                            process_status_id: {
                                "zh-tw": "加工狀態編號",
                                en: "Process Status Id"
                            },
                            process_status_name: {
                                "zh-tw": "加工狀態名稱",
                                en: "Process Status Name"
                            },
                            purchase_order: {
                                "zh-tw": "採購單",
                                en: "Purchase Order"
                            },
                            purchase_order_id: {
                                "zh-tw": "採購單編號",
                                en: "Purchase Order Id"
                            },
                            process_type: {
                                "zh-tw": "加工處理方式",
                                en: "Process Type"
                            },
                            process_type_setting: {
                                "zh-tw": "加工處理方式設定",
                                en: "Process Type Setting"
                            },
                            process_type_id: {
                                "zh-tw": "加工處理方式編號",
                                en: "Process Type Id"
                            },
                            process_type_name: {
                                "zh-tw": "加工處理方式名稱",
                                en: "Process Type Name"
                            },
                            process_type_code: {
                                "zh-tw": "加工處理方式代號",
                                en: "Process Type Code"
                            }
                        }
                    },
                    excess_picking_list_setting: {
                        "zh-tw": "超領(送)單設定",
                        en: "Excess Picking List Setting",
                        children: {
                            /* Basic functional setting */
                            add_staff: {
                                'zh-tw': '新增成員',
                                en: 'Add Staff'
                            },
                            print: {
                                'zh-tw': '列印',
                                en: 'Print'
                            },
                            export: {
                                'zh-tw': '匯出資料',
                                en: 'Export Data'
                            },
                            import: {
                                'zh-tw': '匯入資料',
                                en: 'Import Data'
                            },
                            edit: {
                                'zh-tw': '資料編輯',
                                en: 'Edit Data'
                            },
                            copy: {
                                'zh-tw': '資料複製',
                                en: 'Copy Data'
                            },
                            delete: {
                                'zh-tw': '資料刪除',
                                en: 'Delete Data'
                            },
                            /* Basic functional setting */
                            /* Tabs */
                            other_setting: {
                                "zh-tw": "其他設定",
                                en: "Other Setting"
                            },
                            /* Tabs */
                            save_picking_over_unpicking: {
                                "zh-tw": "領送料量大於未領量可否存檔",
                                en: "Save Setting When Picking Over Unpicking"
                            },
                            utilize_excess_picking_list: {
                                "zh-tw": "使用超領(送)單",
                                en: "Utilize Excess Picking List"
                            },
                        }
                    },
                    requestion_category: {
                        "zh-tw": "請領類別設定",
                        en: "Requestion Category Setting",
                        children: {
                            /* Basic functional setting */
                            add_staff: {
                                'zh-tw': '新增成員',
                                en: 'Add Staff'
                            },
                            print: {
                                'zh-tw': '列印',
                                en: 'Print'
                            },
                            export: {
                                'zh-tw': '匯出資料',
                                en: 'Export Data'
                            },
                            import: {
                                'zh-tw': '匯入資料',
                                en: 'Import Data'
                            },
                            edit: {
                                'zh-tw': '資料編輯',
                                en: 'Edit Data'
                            },
                            copy: {
                                'zh-tw': '資料複製',
                                en: 'Copy Data'
                            },
                            delete: {
                                'zh-tw': '資料刪除',
                                en: 'Delete Data'
                            },
                            /* Basic functional setting */
                            commonly_used_stock_requisition_category: {
                                "zh-tw": "常用請領類別",
                                en: "Commonly Used Stock Requisition Category"
                            },
                            commonly_used_stock_requisition_category_setting: {
                                "zh-tw": "常用請領類別設定",
                                en: "Commonly Used Stock Requisition Category Setting"
                            },
                            material_requisition_category: {
                                "zh-tw": "材料請領類別",
                                en: "Material Requisition Category"
                            },
                            material_requisition_category_setting: {
                                "zh-tw": "材料請領類別設定",
                                en: "Material Requisition Category Setting"
                            },
                            requisition_category_id: {
                                "zh-tw": "請領類別編號",
                                en: "Requisition Category Id"
                            },
                            requisition_category_name: {
                                "zh-tw": "請領類別名稱",
                                en: "Requisition Category Name"
                            },
                            remark: {
                                "zh-tw": "備註",
                                en: "Remark"
                            },
                            borrow_category: {
                                "zh-tw": "借方科目",
                                en: "Borrow Category"
                            },
                            borrow_category_setting: {
                                "zh-tw": "借方科目設定",
                                en: "Borrow Category Setting"
                            },
                            borrow_category_id: {
                                "zh-tw": "借方科目編號",
                                en: "Borrow Category Id"
                            },
                            borrow_category_name: {
                                "zh-tw": "借方科目名稱",
                                en: "Borrow Category Name"
                            },
                        }
                    },
                    calendar_setting: {
                        "zh-tw": "生管行事曆設定",
                        en: "Calendar Setting",
                        children: {
                            /* Basic functional setting */
                            add_staff: {
                                'zh-tw': '新增成員',
                                en: 'Add Staff'
                            },
                            print: {
                                'zh-tw': '列印',
                                en: 'Print'
                            },
                            export: {
                                'zh-tw': '匯出資料',
                                en: 'Export Data'
                            },
                            import: {
                                'zh-tw': '匯入資料',
                                en: 'Import Data',
                                children: {
                                    sample: {
                                        'zh-tw': '下載範例',
                                        en: 'Download Sample'
                                    },
                                    upload: {
                                        'zh-tw': '上傳Excel檔案',
                                        en: 'Upload Excel File'
                                    },
                                    preview: {
                                        'zh-tw': '預覽檔案',
                                        en: 'Preview File'
                                    },
                                    finish: {
                                        'zh-tw': '確認匯入',
                                        en: 'Confirm'
                                    },
                                    close: {
                                        'zh-tw': '關閉',
                                        en: 'Close'
                                    },
                                }
                            },
                            edit: {
                                'zh-tw': '資料編輯',
                                en: 'Edit Data'
                            },
                            copy: {
                                'zh-tw': '資料複製',
                                en: 'Copy Data'
                            },
                            delete: {
                                'zh-tw': '資料刪除',
                                en: 'Delete Data'
                            },
                            table_column_operation: {
                                'zh-tw': '操作',
                                en: 'Functions'
                            },
                            /* Basic functional setting */
                            /* Tabs */
                            machine_setting: {
                                'zh-tw': "機台設定",
                                en: "Machine Setting"
                            },
                            employee_setting: {
                                'zh-tw': "人員設定",
                                en: "Employee Setting"
                            },
                            calendar_setting: {
                                "zh-tw": "行事曆設定",
                                en: "Calendar Setting"
                            },
                            /* Tabs */
                            industry_type: {
                                "zh-tw": "行業別",
                                en: "Industry Type"
                            },
                            industry_type_setting: {
                                "zh-tw": "行業別設定",
                                en: "Industry Type Setting"
                            },
                            industry_type_id: {
                                "zh-tw": "行業別編號",
                                en: "Industry Type Id"
                            },
                            industry_type_name: {
                                "zh-tw": "行業別名稱",
                                en: "Industry Type Name"
                            },
                            class_type: {
                                "zh-tw": "班別",
                                en: "Class Type"
                            },
                            class_type_setting: {
                                "zh-tw": "班別設定",
                                en: "Class Type Setting"
                            },
                            class_type_id: {
                                "zh-tw": "班別編號",
                                en: "Class Type Id"
                            },
                            class_type_name: {
                                "zh-tw": "班別名稱",
                                en: "Class Type Name"
                            },
                            year: {
                                "zh-tw": "年份",
                                en: "Year"
                            },
                            remark: {
                                "zh-tw": "備註",
                                en: "Remark"
                            },
                            calendar: {
                                "zh-tw": "行事曆",
                                en: "Calendar"
                            },
                            calendar_setting: {
                                "zh-tw": "行事曆設定",
                                en: "Calendar Setting"
                            },
                            calendar_id: {
                                "zh-tw": "行事曆編號",
                                en: "Calendar Id"
                            },
                            calendar_type: {
                                "zh-tw": "行事曆類別",
                                en: "Calendar Type"
                            },
                            calendar_type_id: {
                                "zh-tw": "行事曆類別編號",
                                en: "Calendar Type Id"
                            },
                            calendar_type_name: {
                                "zh-tw": "行事曆類別名稱",
                                en: "Calendar Type Id"
                            },
                            calendar_content: {
                                "zh-tw": "行事曆內容",
                                en: "Calendar Content"
                            },
                            calendar_content_setting: {
                                "zh-tw": "行事曆內容設定",
                                en: "Calendar Content Setting"
                            },
                            day_off_date: {
                                "zh-tw": "休假日期",
                                en: "Day Off Date"
                            },
                            day: {
                                "zh-tw": "星期",
                                en: "Day"
                            },
                            day_off_way: {
                                "zh-tw": "休假方式",
                                en: "Day Off Way"
                            },
                            serial_in_year: {
                                "zh-tw": "當年第幾天or週",
                                en: "Day Or Week Serial In A Year"
                            },
                            table_column_operation: {
                                'zh-tw': '操作',
                                en: 'Functions'
                            },
                            table_column_day_off_date: {
                                "zh-tw": "休假日期",
                                en: "Day Off Date"
                            },
                            table_column_day: {
                                "zh-tw": "星期",
                                en: "Day"
                            },
                            table_column_day_off_way: {
                                "zh-tw": "休假方式",
                                en: "Day Off Way"
                            },
                            table_column_serial_in_year: {
                                "zh-tw": "當年第幾天/週",
                                en: "Day Or Week Serial In A Year"
                            },
                            button_edit_permission_title: {
                                'zh-tw': '修改人員權限',
                                en: 'Edit Permission'
                            },
                            button_edit_permission_subtitle: {
                                'zh-tw': '您正在修改{X} {Y}的權限',
                                en: 'You are modifying permissions for {X} {Y}'
                            },
                            /* ------------------------------ */
                            assembly_line_code: {
                                "zh-tw": "生產線代號",
                                en: "Assembly Line Code"
                            },
                            assembly_line_name: {
                                "zh-tw": "生產線名稱",
                                en: "Assembly Line Name"
                            },
                            a_branch: {
                                'zh-tw': "廠別名稱",
                                en: "Assembly Line Branch"
                            },
                            machine_code: {
                                "zh-tw": "機台代號",
                                en: "Machine Code"
                            },
                            machine_name: {
                                "zh-tw": "機台名稱",
                                en: "Machine Name"
                            },
                            employee: {
                                "zh-tw": "人員姓名",
                                en: "Employee"
                            },
                        }
                    },
                }
            },
            production_processing_management: {
                'zh-tw': '生產製程管理模組',
                en: 'Production Processing Management',
                children: {
                    standard_process: {
                        'zh-tw': '標準製程資料設定',
                        en: 'Standard Processing',
                        children: {
                            tabs_all: {
                                'zh-tw': '總覽',
                                en: 'All'
                            },
                            tabs_inner: {
                                'zh-tw': '廠內製程',
                                en: 'Self-Industry Process'
                            },
                            tabs_outer: {
                                'zh-tw': '廠外製程',
                                en: 'Outsource Process'
                            },
                            add_process: {
                                'zh-tw': '新增製程',
                                en: 'New Process'
                            },
                            print: {
                                'zh-tw': '列印',
                                en: 'Print'
                            },
                            export: {
                                'zh-tw': '匯出資料',
                                en: 'Export Data'
                            },
                            import: {
                                'zh-tw': '匯入資料',
                                en: 'Import Data',
                                children: {
                                    sample: {
                                        'zh-tw': '下載範例',
                                        en: 'Download Sample'
                                    },
                                    upload: {
                                        'zh-tw': '上傳Excel檔案',
                                        en: 'Upload Excel File'
                                    },
                                    preview: {
                                        'zh-tw': '預覽檔案',
                                        en: 'Preview File'
                                    },
                                    finish: {
                                        'zh-tw': '確認匯入',
                                        en: 'Confirm'
                                    },
                                    close: {
                                        'zh-tw': '關閉',
                                        en: 'Close'
                                    },
                                    table_column_name: {
                                        'zh-tw': '名稱',
                                        en: 'Name'
                                    },
                                    table_column_process_codes: {
                                        'zh-tw': '製程代號',
                                        en: 'Process Code'
                                    },
                                    table_column_durations: {
                                        'zh-tw': '標準工時',
                                        en: 'Standard Process Duration'
                                    },
                                    table_column_minutes: {
                                        'zh-tw': '分',
                                        en: 'Minutes'
                                    },
                                }
                            },
                            edit: {
                                'zh-tw': '資料編輯',
                                en: 'Edit Data'
                            },
                            copy: {
                                'zh-tw': '資料複製',
                                en: 'Copy Data'
                            },
                            delete: {
                                'zh-tw': '資料刪除',
                                en: 'Delete Data'
                            },
                            table_form_number: {
                                'zh-tw': '筆數',
                                en: 'Size'
                            },
                            table_form_number_suffix: {
                                'zh-tw': '筆',
                                en: ''
                            },
                            table_form_search_placeholder: {
                                'zh-tw': '智慧搜尋',
                                en: 'Search'
                            },
                            table_column_operation: {
                                'zh-tw': '操作',
                                en: 'Functions'
                            },
                            table_column_process_code: {
                                'zh-tw': '製程代號',
                                en: 'Process Code'
                            },
                            table_column_process_name: {
                                'zh-tw': '製程名稱',
                                en: 'Process Name'
                            },
                            table_column_process_description: {
                                'zh-tw': '製程描述',
                                en: 'Process Description'
                            },
                            table_column_process_status_name: {
                                'zh-tw': '製程性質',
                                en: 'Process Status'
                            },
                            table_column_assembly_line: {
                                'zh-tw': '線別',
                                en: 'Assembly Line'
                            },
                            table_column_description: {
                                'zh-tw': '備註',
                                en: 'Description'
                            },
                        }
                    },
                    order_temp_process: {
                        'zh-tw': '線上生產製程排定',
                        en: 'Process Scheduling',
                        children: {
                            list: {
                                'zh-tw': '訂單列表',
                                en: 'Order list',
                                children: {
                                }
                            },
                            content: {
                                'zh-tw': '製程資訊',
                                en: 'Process Infomation',
                                children: {
                                }
                            },
                            edit_process: {
                                'zh-tw': '編輯製程',
                                en: 'Edit Process',
                                children: {
                                    save_process_group: {
                                        'zh-tw': '設為常用組合',
                                        en: 'Save Commonly Group'
                                    },
                                    add: {
                                        'zh-tw': '新增',
                                        en: 'Add',
                                    },
                                    add_process_group: {
                                        'zh-tw': '新增製程組',
                                        en: 'Add Process Group',
                                    },
                                    modify_process_group: {
                                        'zh-tw': '修改組合',
                                        en: 'Add Process Group',
                                    },
                                    finished_editting: {
                                        'zh-tw': '儲存編輯',
                                        en: 'Finished Editting'
                                    },
                                    process_group_name: {
                                        'zh-tw': '組合名稱',
                                        en: 'Process Group Name',
                                        children: {
                                            message: {
                                                'zh-tw': '請輸入組合名稱',
                                                en: 'Please enter the process group name'
                                            },
                                            save_tips: {
                                                'zh-tw': '設為常用組合',
                                                en: 'Set This As Commonly Group'
                                            },
                                            edit_tips: {
                                                'zh-tw': '修改組合',
                                                en: 'Edit Group',
                                                children: {
                                                    confirm: {
                                                        'zh-tw': '確認',
                                                        en: 'Confirm'
                                                    },
                                                    cancel: {
                                                        'zh-tw': '取消',
                                                        en: 'Cancel'
                                                    }
                                                }
                                            },
                                            delete_tips: {
                                                'zh-tw': '刪除組合',
                                                en: 'Delete Group'
                                            },
                                        }
                                    },
                                    note: {
                                        'zh-tw': '備註',
                                        en: 'note',
                                    },
                                    selected_process: {
                                        'zh-tw': '已選製程',
                                        en: 'Selected Process'
                                    },
                                    choose_process: {
                                        'zh-tw': '製程選擇',
                                        en: 'Choose Process'
                                    },
                                    confirm: {
                                        'zh-tw': '新增',
                                        en: 'Confirm',
                                    },
                                    cancel: {
                                        'zh-tw': '取消',
                                        en: 'Cancel'
                                    },
                                    delete_successful: {
                                        'zh-tw': '刪除成功',
                                        en: 'Delete Successful'
                                    },
                                    save_successful: {
                                        'zh-tw': '儲存成功',
                                        en: 'Save Successful'
                                    },
                                    save_failed: {
                                        'zh-tw': '儲存失敗',
                                        en: 'Save Failed'
                                    },
                                    hours: {
                                        'zh-tw': '小時',
                                        en: 'hours'
                                    },
                                    total_working_hours: {
                                        'zh-tw': '總工時',
                                        en: 'Total Working Hours'
                                    },
                                }
                            },
                            commonly_process_group: {
                                'zh-tw': '常用製程組',
                                en: 'Commonly Process Group',
                                children: {
                                    apply_group: {
                                        'zh-tw': '套用',
                                        en: 'Apply Group'
                                    },
                                }
                            },
                            process: {
                                'zh-tw': '全部製程',
                                en: 'Process'
                            },
                            print: {
                                'zh-tw': '列印',
                                en: 'Print'
                            },
                            export: {
                                'zh-tw': '匯出資料',
                                en: 'Export Data'
                            },
                            import: {
                                'zh-tw': '匯入資料',
                                en: 'Import Data',
                                children: {
                                    sample: {
                                        'zh-tw': '下載範例',
                                        en: 'Download Sample'
                                    },
                                    upload: {
                                        'zh-tw': '上傳Excel檔案',
                                        en: 'Upload Excel File'
                                    },
                                    preview: {
                                        'zh-tw': '預覽檔案',
                                        en: 'Preview File'
                                    },
                                    finish: {
                                        'zh-tw': '確認匯入',
                                        en: 'Confirm'
                                    },
                                    close: {
                                        'zh-tw': '關閉',
                                        en: 'Close'
                                    },
                                    table_column_name: {
                                        'zh-tw': '名稱',
                                        en: 'Name'
                                    },
                                    table_column_process_codes: {
                                        'zh-tw': '製程代號',
                                        en: 'Process Code'
                                    },
                                    table_column_durations: {
                                        'zh-tw': '標準工時',
                                        en: 'Standard Process Duration'
                                    },
                                    table_column_minutes: {
                                        'zh-tw': '分',
                                        en: 'Minutes'
                                    },
                                }
                            },
                            edit: {
                                'zh-tw': '資料編輯',
                                en: 'Edit Data'
                            },
                            copy: {
                                'zh-tw': '資料複製',
                                en: 'Copy Data'
                            },
                            delete: {
                                'zh-tw': '資料刪除',
                                en: 'Delete Data'
                            },
                            table_form_number: {
                                'zh-tw': '筆數',
                                en: 'Size'
                            },
                            table_form_number_suffix: {
                                'zh-tw': '筆',
                                en: ''
                            },
                            table_form_search_placeholder: {
                                'zh-tw': '智慧搜尋',
                                en: 'Search'
                            },
                            table_column_operation: {
                                'zh-tw': '操作',
                                en: 'Functions'
                            },
                            table_column_order_code: {
                                'zh-tw': '訂單編號',
                                en: 'Order Code'
                            },
                            table_column_product_code: {
                                'zh-tw': '產品編號',
                                en: 'Product Code'
                            },
                            table_column_product_name: {
                                'zh-tw': '產品名稱',
                                en: 'Product Name'
                            },
                            table_column_description: {
                                'zh-tw': '備註',
                                en: 'Description'
                            },
                            modal_add_stage: {
                                'zh-tw': '新增階段',
                                en: 'Add Stage',
                                children: {
                                    confirm: {
                                        'zh-tw': '新增',
                                        en: 'Confirm'
                                    },
                                    cancel: {
                                        'zh-tw': '取消',
                                        en: 'Cancel'
                                    },
                                    stage_name: {
                                        'zh-tw': '階段名稱',
                                        en: 'Stage Name',
                                        children: {
                                            message: {
                                                'zh-tw': '請輸入階段名稱',
                                                en: 'Please Input Stage Name',
                                            }
                                        }
                                    },
                                    selected_process: {
                                        'zh-tw': '已選製程',
                                        en: 'Selected Process'
                                    },
                                    choose_process: {
                                        'zh-tw': '製程選擇',
                                        en: 'Choose Process'
                                    },

                                }
                            }
                        }
                    },
                    order_process: {
                        'zh-tw': '製令製程建立作業',
                        en: 'Manufacturing Process',
                        children: {
                            list: {
                                'zh-tw': '訂單列表',
                                en: 'Order list',
                                children: {
                                }
                            },
                            content: {
                                'zh-tw': '製令資訊',
                                en: 'Process Infomation',
                                children: {
                                }
                            },
                            print: {
                                'zh-tw': '列印',
                                en: 'Print'
                            },
                            export: {
                                'zh-tw': '匯出資料',
                                en: 'Export Data'
                            },
                            import: {
                                'zh-tw': '匯入資料',
                                en: 'Import Data',
                                children: {
                                    sample: {
                                        'zh-tw': '下載範例',
                                        en: 'Download Sample'
                                    },
                                    upload: {
                                        'zh-tw': '上傳Excel檔案',
                                        en: 'Upload Excel File'
                                    },
                                    preview: {
                                        'zh-tw': '預覽檔案',
                                        en: 'Preview File'
                                    },
                                    finish: {
                                        'zh-tw': '確認匯入',
                                        en: 'Confirm'
                                    },
                                    close: {
                                        'zh-tw': '關閉',
                                        en: 'Close'
                                    },
                                    table_column_name: {
                                        'zh-tw': '名稱',
                                        en: 'Name'
                                    },
                                    table_column_process_codes: {
                                        'zh-tw': '製程代號',
                                        en: 'Process Code'
                                    },
                                    table_column_durations: {
                                        'zh-tw': '標準工時',
                                        en: 'Standard Process Duration'
                                    },
                                    table_column_minutes: {
                                        'zh-tw': '分',
                                        en: 'Minutes'
                                    },
                                }
                            },
                            edit: {
                                'zh-tw': '資料編輯',
                                en: 'Edit Data'
                            },
                            copy: {
                                'zh-tw': '資料複製',
                                en: 'Copy Data'
                            },
                            delete: {
                                'zh-tw': '資料刪除',
                                en: 'Delete Data'
                            },
                            table_form_number: {
                                'zh-tw': '筆數',
                                en: 'Size'
                            },
                            table_form_number_suffix: {
                                'zh-tw': '筆',
                                en: ''
                            },
                            table_form_search_placeholder: {
                                'zh-tw': '智慧搜尋',
                                en: 'Search'
                            },
                            table_column_operation: {
                                'zh-tw': '操作',
                                en: 'Functions'
                            },
                            table_column_order_code: {
                                'zh-tw': '訂單編號',
                                en: 'Order Code'
                            },
                            table_column_product_code: {
                                'zh-tw': '產品編號',
                                en: 'Product Code'
                            },
                            table_column_product_name: {
                                'zh-tw': '產品名稱',
                                en: 'Product Name'
                            },
                            table_column_description: {
                                'zh-tw': '備註',
                                en: 'Description'
                            },
                            table_column_serial: {
                                'zh-tw': '加工順序',
                                en: '#'
                            },
                            table_column_process_names: {
                                'zh-tw': '已排定製程',
                                en: 'Planned Process'
                            },
                            table_column_process_code: {
                                'zh-tw': '製程代號',
                                en: 'Process Code'
                            },
                            table_column_process_name: {
                                'zh-tw': '製程名稱',
                                en: 'Process Name'
                            },
                            table_column_process_description: {
                                'zh-tw': '製程敘述',
                                en: 'Process Description'
                            },
                            table_column_process_status: {
                                'zh-tw': '性質',
                                en: 'Process Class'
                            },
                            table_column_line_code: {
                                'zh-tw': '線別代號',
                                en: 'Line Code'
                            },
                            table_column_line_name: {
                                'zh-tw': '線別名稱',
                                en: 'Line Name'
                            }
                        }
                    },
                    processing_order: {
                        'zh-tw': '製程加工單',
                        en: 'Processing Order',
                        children: {
                            list: {
                                'zh-tw': '訂單列表',
                                en: 'Order list',
                                children: {
                                }
                            },
                            content: {
                                'zh-tw': '製令資訊',
                                en: 'Process Infomation',
                                children: {
                                }
                            },
                            print: {
                                'zh-tw': '列印',
                                en: 'Print'
                            },
                            export: {
                                'zh-tw': '匯出資料',
                                en: 'Export Data'
                            },
                            import: {
                                'zh-tw': '匯入資料',
                                en: 'Import Data',
                                children: {
                                    sample: {
                                        'zh-tw': '下載範例',
                                        en: 'Download Sample'
                                    },
                                    upload: {
                                        'zh-tw': '上傳Excel檔案',
                                        en: 'Upload Excel File'
                                    },
                                    preview: {
                                        'zh-tw': '預覽檔案',
                                        en: 'Preview File'
                                    },
                                    finish: {
                                        'zh-tw': '確認匯入',
                                        en: 'Confirm'
                                    },
                                    close: {
                                        'zh-tw': '關閉',
                                        en: 'Close'
                                    },
                                    table_column_name: {
                                        'zh-tw': '名稱',
                                        en: 'Name'
                                    },
                                    table_column_process_codes: {
                                        'zh-tw': '製程代號',
                                        en: 'Process Code'
                                    },
                                    table_column_durations: {
                                        'zh-tw': '標準工時',
                                        en: 'Standard Process Duration'
                                    },
                                    table_column_minutes: {
                                        'zh-tw': '分',
                                        en: 'Minutes'
                                    },
                                }
                            },
                            edit: {
                                'zh-tw': '資料編輯',
                                en: 'Edit Data'
                            },
                            copy: {
                                'zh-tw': '資料複製',
                                en: 'Copy Data'
                            },
                            delete: {
                                'zh-tw': '資料刪除',
                                en: 'Delete Data'
                            },
                            table_form_number: {
                                'zh-tw': '筆數',
                                en: 'Size'
                            },
                            table_form_number_suffix: {
                                'zh-tw': '筆',
                                en: ''
                            },
                            table_form_search_placeholder: {
                                'zh-tw': '智慧搜尋',
                                en: 'Search'
                            },
                            table_column_operation: {
                                'zh-tw': '操作',
                                en: 'Functions'
                            },
                            table_column_order_code: {
                                'zh-tw': '訂單編號',
                                en: 'Order Code'
                            },
                            table_column_product_code: {
                                'zh-tw': '產品編號',
                                en: 'Product Code'
                            },
                            table_column_product_name: {
                                'zh-tw': '產品名稱',
                                en: 'Product Name'
                            },
                            table_column_description: {
                                'zh-tw': '備註',
                                en: 'Description'
                            },
                            table_column_serial: {
                                'zh-tw': '加工順序',
                                en: '#'
                            },
                            table_column_process_names: {
                                'zh-tw': '已排定製程',
                                en: 'Planned Process'
                            },
                            table_column_process_code: {
                                'zh-tw': '製程代號',
                                en: 'Process Code'
                            },
                            table_column_process_name: {
                                'zh-tw': '製程名稱',
                                en: 'Process Name'
                            },
                            table_column_process_description: {
                                'zh-tw': '製程敘述',
                                en: 'Process Description'
                            },
                            table_column_process_status: {
                                'zh-tw': '性質',
                                en: 'Process Class'
                            },
                            table_column_item_code: {
                                'zh-tw': '材料編號',
                                en: 'Item Code'
                            },
                            table_column_item_name: {
                                'zh-tw': '材料品名',
                                en: 'Item Name'
                            },
                            table_column_item_count: {
                                'zh-tw': '應領用量',
                                en: 'Item Count'
                            },
                            table_column_item_unit: {
                                'zh-tw': '用量單位',
                                en: 'Item Unit'
                            },
                            table_column_item_description: {
                                'zh-tw': '備註',
                                en: 'Item Description'
                            },
                        }
                    },
                    manufacturing_order: {
                        'zh-tw': '製造命令單建立作業',
                        en: 'Manufacturing Order',
                        children: {

                            list: {
                                'zh-tw': '訂單列表',
                                en: 'Order list',
                                children: {
                                }
                            },
                            content: {
                                'zh-tw': '製令資訊',
                                en: 'Process Infomation',
                                children: {
                                }
                            },
                            print: {
                                'zh-tw': '列印',
                                en: 'Print'
                            },
                            export: {
                                'zh-tw': '匯出資料',
                                en: 'Export Data'
                            },
                            import: {
                                'zh-tw': '匯入資料',
                                en: 'Import Data',
                                children: {
                                    sample: {
                                        'zh-tw': '下載範例',
                                        en: 'Download Sample'
                                    },
                                    upload: {
                                        'zh-tw': '上傳Excel檔案',
                                        en: 'Upload Excel File'
                                    },
                                    preview: {
                                        'zh-tw': '預覽檔案',
                                        en: 'Preview File'
                                    },
                                    finish: {
                                        'zh-tw': '確認匯入',
                                        en: 'Confirm'
                                    },
                                    close: {
                                        'zh-tw': '關閉',
                                        en: 'Close'
                                    },
                                    table_column_name: {
                                        'zh-tw': '名稱',
                                        en: 'Name'
                                    },
                                    table_column_process_codes: {
                                        'zh-tw': '製程代號',
                                        en: 'Process Code'
                                    },
                                    table_column_durations: {
                                        'zh-tw': '標準工時',
                                        en: 'Standard Process Duration'
                                    },
                                    table_column_minutes: {
                                        'zh-tw': '分',
                                        en: 'Minutes'
                                    },
                                }
                            },
                            edit: {
                                'zh-tw': '資料編輯',
                                en: 'Edit Data'
                            },
                            copy: {
                                'zh-tw': '資料複製',
                                en: 'Copy Data'
                            },
                            delete: {
                                'zh-tw': '資料刪除',
                                en: 'Delete Data'
                            },
                            table_form_number: {
                                'zh-tw': '筆數',
                                en: 'Size'
                            },
                            table_form_number_suffix: {
                                'zh-tw': '筆',
                                en: ''
                            },
                            table_form_search_placeholder: {
                                'zh-tw': '智慧搜尋',
                                en: 'Search'
                            },
                            table_column_operation: {
                                'zh-tw': '操作',
                                en: 'Functions'
                            },
                            table_column_order_code: {
                                'zh-tw': '訂單編號',
                                en: 'Order Code'
                            },
                            table_column_product_code: {
                                'zh-tw': '產品編號',
                                en: 'Product Code'
                            },
                            table_column_product_name: {
                                'zh-tw': '產品名稱',
                                en: 'Product Name'
                            },
                            table_column_description: {
                                'zh-tw': '備註',
                                en: 'Description'
                            },
                            table_column_serial: {
                                'zh-tw': '加工順序',
                                en: '#'
                            },
                            table_column_process_names: {
                                'zh-tw': '已排定製程',
                                en: 'Planned Process'
                            },
                            table_column_process_code: {
                                'zh-tw': '製程代號',
                                en: 'Process Code'
                            },
                            table_column_process_name: {
                                'zh-tw': '製程名稱',
                                en: 'Process Name'
                            },
                            table_column_process_description: {
                                'zh-tw': '製程敘述',
                                en: 'Process Description'
                            },
                            table_column_process_status: {
                                'zh-tw': '性質',
                                en: 'Process Class'
                            },
                            table_column_item_code: {
                                'zh-tw': '材料編號',
                                en: 'Item Code'
                            },
                            table_column_item_name: {
                                'zh-tw': '材料品名',
                                en: 'Item Name'
                            },
                            table_column_item_spec: {
                                'zh-tw': '材料規格',
                                en: 'Item Specification'
                            },
                            table_column_item_count: {
                                'zh-tw': '應領用量',
                                en: 'Item Count'
                            },
                            table_column_item_count_have: {
                                'zh-tw': '已領用量',
                                en: 'Item Have Count'
                            },
                            table_column_item_count_havent: {
                                'zh-tw': '未領用量',
                                en: 'Item Have Count'
                            },
                            table_column_item_unit: {
                                'zh-tw': '用量單位',
                                en: 'Item Unit'
                            },
                            table_column_item_description: {
                                'zh-tw': '備註',
                                en: 'Item Description'
                            },
                        }
                    },
                    permission: {
                        'zh-tw': '系統權限設定與管理',
                        en: 'System And Permission Management',
                        children: {
                            add_staff: {
                                'zh-tw': '新增成員',
                                en: 'Add Staff'
                            },
                            print: {
                                'zh-tw': '列印',
                                en: 'Print'
                            },
                            export: {
                                'zh-tw': '匯出資料',
                                en: 'Export Data'
                            },
                            import: {
                                'zh-tw': '匯入資料',
                                en: 'Import Data'
                            },
                            edit: {
                                'zh-tw': '資料編輯',
                                en: 'Edit Data'
                            },
                            copy: {
                                'zh-tw': '資料複製',
                                en: 'Copy Data'
                            },
                            delete: {
                                'zh-tw': '資料刪除',
                                en: 'Delete Data'
                            },
                            belong_module: {
                                'zh-tw': '隸屬部門',
                                en: 'Department'
                            },
                            belong_module_all: {
                                'zh-tw': '總覽',
                                en: 'All Departments'
                            },
                            table_form_number: {
                                'zh-tw': '筆數',
                                en: 'Size'
                            },
                            table_form_number_suffix: {
                                'zh-tw': '筆',
                                en: ''
                            },
                            table_form_search_placeholder: {
                                'zh-tw': '智慧搜尋',
                                en: 'Search'
                            },
                            table_column_operation: {
                                'zh-tw': '操作',
                                en: 'Functions'
                            },
                            table_column_uid: {
                                'zh-tw': '員工代號',
                                en: 'Staff ID'
                            },
                            table_column_user_name: {
                                'zh-tw': '員工名稱',
                                en: 'Staff Name'
                            },
                            table_column_module_name: {
                                'zh-tw': '隸屬部門',
                                en: 'Department Name'
                            },
                            table_column_user_activated: {
                                'zh-tw': '帳號狀態',
                                en: 'User Activated'
                            },
                            table_column_user_activated_checked: {
                                'zh-tw': '開啟帳號',
                                en: 'Activated'
                            },
                            table_column_user_activated_unchecked: {
                                'zh-tw': '關閉帳號',
                                en: 'Deactivated'
                            },
                            table_column_permission_detail: {
                                'zh-tw': '權限內容',
                                en: 'Permission Detail'
                            },
                            edit: {
                                'zh-tw': '資料編輯',
                                en: 'Edit Data'
                            },
                            copy: {
                                'zh-tw': '資料複製',
                                en: 'Copy Data'
                            },
                            delete: {
                                'zh-tw': '資料刪除',
                                en: 'Delete Data'
                            },
                            button_edit_permission_title: {
                                'zh-tw': '修改人員權限',
                                en: 'Edit Permission'
                            },
                            button_edit_permission_subtitle: {
                                'zh-tw': '您正在修改{X} {Y}的權限',
                                en: 'You are modifying permissions for {X} {Y}'
                            }
                        }
                    },

                }
            },
            flow_engine: {
                'zh-tw': '流程引擎模組',
                en: 'Flow Engine',
                children: {
                    information: {
                        'zh-tw': '顯示資訊',
                        en: 'Information',
                        children: {
                            item: {
                                'zh-tw': '項次',
                                en: 'Item'
                            },
                            from_start_to_finish: {
                                'zh-tw': '起訖',
                                en: 'From Start To Finish'
                            },
                            reason: {
                                'zh-tw': '事由',
                                en: 'Reason'
                            },
                            place: {
                                'zh-tw': '地點',
                                en: 'Place'
                            },
                            process: {
                                'zh-tw': '流程',
                                en: 'Process'
                            },
                            edit: {
                                'zh-tw': '編輯',
                                en: 'Edit'
                            },
                        }
                    },
                    editting: {
                        'zh-tw': '編輯',
                        en: 'Editting',
                        children: {
                            setting_staff: {
                                'zh-tw': '設定流程',
                                en: 'Setting Process',
                                children: {
                                    save_process_group: {
                                        'zh-tw': '設為常用',
                                        en: 'Save Process Group'
                                    },
                                    finished_editting: {
                                        'zh-tw': '儲存編輯',
                                        en: 'Finished Editting'
                                    },
                                    setting: {
                                        'zh-tw': '設定',
                                        en: 'Setting'
                                    }
                                }
                            },
                            commonly_staff_group: {
                                'zh-tw': '常用人員組',
                                en: 'Commonly Staff Group',
                                children: {
                                    apply_group: {
                                        'zh-tw': '套用',
                                        en: 'Apply Group'
                                    },
                                }
                            },
                            all_staff: {
                                'zh-tw': '全部人員',
                                en: 'All Staff',
                                children: {
                                    staff_group_name: {
                                        'zh-tw': '人員組名稱',
                                        en: 'Staff Group Name',
                                        children: {
                                            message: {
                                                'zh-tw': '請輸入人員組名稱',
                                                en: 'Please enter the staff group name'
                                            },
                                        }
                                    },
                                    add_staff_group: {
                                        'zh-tw': '新增人員組',
                                        en: 'Add Staff Group',
                                        children: {
                                            add_staff: {
                                                'zh-tw': '新增人員',
                                                en: 'Add Staff'
                                            },
                                            selected_staff: {
                                                'zh-tw': '已選人員',
                                                en: 'Selected Staff'
                                            },
                                            all_staff: {
                                                'zh-tw': '所有人員',
                                                en: 'All Staff'
                                            }
                                        }
                                    }
                                }
                            },
                            save_successful: {
                                'zh-tw': '儲存成功',
                                en: 'Save Successful'
                            },
                            save_failed: {
                                'zh-tw': '儲存失敗',
                                en: 'Save Failed'
                            },
                            delete_successful: {
                                'zh-tw': '刪除成功',
                                en: 'Delete Successful'
                            },
                            confirm: {
                                'zh-tw': '新增',
                                en: 'Confirm',
                            },
                            cancel: {
                                'zh-tw': '取消',
                                en: 'Cancel'
                            },
                        }
                    },
                    back_to_list: {
                        'zh-tw': '回到列表',
                        en: 'Back To List'
                    }
                }
            },
            bill_of_material_data_management: {
                'zh-tw': '產品結構資料模組',
                en: 'Bill Of Material Data Management',
                children: {
                    bill_of_material_setting: {
                        'zh-tw': "產品結構設定",
                        en: "Bill Of Material Setting",
                        children: {
                            /* Basic functional setting */
                            add_staff: {
                                'zh-tw': '新增BOM',
                                en: 'Add Staff'
                            },
                            go_back: {
                                "zh-tw": "返回",
                                en: "Go Back"
                            },
                            print: {
                                'zh-tw': '列印',
                                en: 'Print'
                            },
                            export: {
                                'zh-tw': '匯出資料',
                                en: 'Export Data'
                            },
                            import: {
                                'zh-tw': '匯入資料',
                                en: 'Import Data',
                                children: {
                                    sample: {
                                        'zh-tw': '下載範例',
                                        en: 'Download Sample'
                                    },
                                    upload: {
                                        'zh-tw': '上傳Excel檔案',
                                        en: 'Upload Excel File'
                                    },
                                    preview: {
                                        'zh-tw': '預覽檔案',
                                        en: 'Preview File'
                                    },
                                    finish: {
                                        'zh-tw': '確認匯入',
                                        en: 'Confirm'
                                    },
                                    close: {
                                        'zh-tw': '關閉',
                                        en: 'Close'
                                    },
                                }
                            },
                            edit: {
                                'zh-tw': '資料編輯',
                                en: 'Edit Data'
                            },
                            copy: {
                                'zh-tw': '資料複製',
                                en: 'Copy Data'
                            },
                            delete: {
                                'zh-tw': '資料刪除',
                                en: 'Delete Data'
                            },
                            table_column_operation: {
                                'zh-tw': '操作',
                                en: 'Functions'
                            },
                            button_edit_permission_title: {
                                'zh-tw': '修改人員權限',
                                en: 'Edit Permission'
                            },
                            button_edit_permission_subtitle: {
                                'zh-tw': '您正在修改{X} {Y}的權限',
                                en: 'You are modifying permissions for {X} {Y}'
                            },
                            /* Basic functional setting */
                            parent_material: {
                                "zh-tw": "母件編號",
                                en: "Parent Material Number"
                            },
                            std_batch: {
                                "zh-tw": "標準批量",
                                en: "Standard batch"
                            },
                            daily_production: {
                                "zh-tw": "日產量",
                                en: "Daily Production"
                            },
                            cost_category: {
                                "zh-tw": "成本類別",
                                en: "Cost Category"
                            },
                            min_manufacturing_quantity: {
                                "zh-tw": "最低製造量",
                                en: "Min Manufacturing Quantity"
                            },
                            lead_time: {
                                "zh-tw": "前置天數",
                                en: "Lead Time"
                            },
                            image: {
                                "zh-tw": "圖號",
                                en: "Image"
                            },
                            usual_production_ways: {
                                "zh-tw": "常態生產方式",
                                en: "Usual Production Ways"
                            },
                            assembly: {
                                "zh-tw": "生產單位",
                                en: "Production Unit"
                            },
                            company: {
                                "zh-tw": "委外廠商",
                                en: "Outsourcing Company"
                            },
                            nultiple_production: {
                                "zh-tw": "多品",
                                en: "Multiple Productions"
                            },
                            actual_cost: { // Tabs
                                "zh-tw": "實際成本",
                                en: "Actual Cost"
                            },
                            batch_labor_cost: {
                                "zh-tw": "批量人工成本",
                                en: "Batch Labor Cost"
                            },
                            batch_direct_material: {
                                "zh-tw": "批量直接材料",
                                en: "Batch Direct Material"
                            },
                            batch_manufactur_cost: {
                                "zh-tw": "批量製造費用",
                                en: "Batch Manufactur Cost"
                            },
                            batch_processing_cost: {
                                "zh-tw": "批量加工費用",
                                en: "Batch Processing Cost"
                            },
                            batch_cost_total: {
                                "zh-tw": "批量成本合計",
                                en: "Batch Cost Total"
                            },
                            single_structure_cost: {
                                "zh-tw": "單一結構成本",
                                en: "Single Structure Cost"
                            },
                            parent_material_current_cost: {
                                "zh-tw": "母件現行成本",
                                en: "Parent Material Current Cost"
                            },
                            std_cost: { // Tabs
                                "zh-tw": "標準成本",
                                en: "Standard Cost"
                            },
                            parent_std_cost: {
                                "zh-tw": "母件標準成本",
                                en: "Parent Standard Cost"
                            },
                            expand_table_column_serial: {
                                "zh-tw": "欄號",
                                en: "Serial"
                            },
                            expand_table_column_is_material: {
                                "zh-tw": "材料",
                                en: "Is Material"
                            },
                            expand_table_column_process_code: {
                                "zh-tw": "製程代號",
                                en: "Process Code"
                            },
                            expand_table_column_process_name: {
                                "zh-tw": "製程名稱",
                                en: "Process Name"
                            },
                            expand_table_column_process_full_name: {
                                "zh-tw": "製程品名",
                                en: "Process Full Name"
                            },
                            expand_table_column_process_status: {
                                "zh-tw": "生產別",
                                en: "Process Status"
                            },
                            expand_table_column_assembly_line_id_or_company_id: {
                                "zh-tw": "生產單位",
                                en: "Assembly Line ID/Company ID"
                            },
                            expand_table_column_assembly_line_name_or_company_name: {
                                "zh-tw": "單位名稱",
                                en: "Assembly Line Name/Company Name"
                            },
                            expand_table_column_lead_time: {
                                "zh-tw": "前置天數",
                                en: "Lead Time"
                            },
                            expand_table_column_daily_production: {
                                "zh-tw": "日產量",
                                en: "Daily Production"
                            },
                            expand_table_column_calcu_way: {
                                "zh-tw": "計價方式",
                                en: "Calculation way"
                            },
                            expand_table_column_unit_weight: {
                                "zh-tw": "單位重量",
                                en: "Unit Weight"
                            },
                        }
                    },
                    bill_of_material_create: {
                        "zh-tw": "BOM用料批次建立作業",
                        en: "BOM Batch Creating",
                        children: {
                            /* Basic functional setting */
                            add_staff: {
                                'zh-tw': '新增BOM',
                                en: 'Add Staff'
                            },
                            go_back: {
                                "zh-tw": "返回",
                                en: "Go Back"
                            },
                            print: {
                                'zh-tw': '列印',
                                en: 'Print'
                            },
                            export: {
                                'zh-tw': '匯出資料',
                                en: 'Export Data'
                            },
                            import: {
                                'zh-tw': '匯入資料',
                                en: 'Import Data',
                                children: {
                                    sample: {
                                        'zh-tw': '下載範例',
                                        en: 'Download Sample'
                                    },
                                    upload: {
                                        'zh-tw': '上傳Excel檔案',
                                        en: 'Upload Excel File'
                                    },
                                    preview: {
                                        'zh-tw': '預覽檔案',
                                        en: 'Preview File'
                                    },
                                    finish: {
                                        'zh-tw': '確認匯入',
                                        en: 'Confirm'
                                    },
                                    close: {
                                        'zh-tw': '關閉',
                                        en: 'Close'
                                    },
                                }
                            },
                            edit: {
                                'zh-tw': '資料編輯',
                                en: 'Edit Data'
                            },
                            copy: {
                                'zh-tw': '資料複製',
                                en: 'Copy Data'
                            },
                            delete: {
                                'zh-tw': '資料刪除',
                                en: 'Delete Data'
                            },
                            table_column_operation: {
                                'zh-tw': '操作',
                                en: 'Functions'
                            },
                            button_edit_permission_title: {
                                'zh-tw': '修改人員權限',
                                en: 'Edit Permission'
                            },
                            button_edit_permission_subtitle: {
                                'zh-tw': '您正在修改{X} {Y}的權限',
                                en: 'You are modifying permissions for {X} {Y}'
                            },
                            /* Basic functional setting */
                            production_number: {
                                "zh-tw": "主件品號",
                                en: "Production Number"
                            },
                            production_name: {
                                "zh-tw": "品名",
                                en: "Production Name"
                            },
                            specification: {
                                "zh-tw": "規格",
                                en: "Specification"
                            },
                            unit: {
                                "zh-tw": "單位",
                                en: "Unit"
                            },
                            attribute: {
                                "zh-tw": "屬性",
                                en: "Attribute"
                            },
                            std_batch: {
                                "zh-tw": "標準批量",
                                en: "Standard Batch"
                            },
                            work_order: {
                                "zh-tw": "製令單別",
                                en: "Work Order"
                            },
                            expand_table_column_serial: {
                                "zh-tw": "序號",
                                en: "Serial"
                            },
                            expand_table_column_material_number: {
                                "zh-tw": "元件品號",
                                en: "Child Material Number"
                            },
                            expand_table_column_material_name: {
                                "zh-tw": "品名",
                                en: "Child Material Name"
                            },
                            expand_table_column_specification: {
                                "zh-tw": "規格",
                                en: "Specification"
                            },
                            expand_table_column_unit: {
                                "zh-tw": "單位",
                                en: "Unit"
                            },
                            expand_table_column_small_unit: {
                                "zh-tw": "小單位",
                                en: "Small Unit"
                            },
                            expand_table_column_attribute: {
                                "zh-tw": "屬性",
                                en: "Attribute"
                            },
                            expand_table_column_conpose_quantity: {
                                "zh-tw": "組成用量",
                                en: "Compose Quantity"
                            },
                            expand_table_column_base: {
                                "zh-tw": "基底",
                                en: "Base"
                            },
                            expand_table_column_attrition_rate: {
                                "zh-tw": "損耗率",
                                en: "Attrition Rate"
                            },
                            expand_table_column_std_cost_calculation: {
                                "zh-tw": "標本成本計算",
                                en: "Standard Cost Calculation"
                            },
                            expand_table_column_material_type: {
                                "zh-tw": "材料型態",
                                en: "Material Type"
                            },
                            expand_table_column_process: {
                                "zh-tw": "製程",
                                en: "Process"
                            },
                            expand_table_column_process_name: {
                                "zh-tw": "製程名稱",
                                en: "Process Name"
                            },
                            expand_table_column_feeding_time_interval: {
                                "zh-tw": "投料時距",
                                en: "Feeding Intervals Of Time"
                            },
                            expand_table_column_start_date: {
                                "zh-tw": "生效日期",
                                en: "Start Date"
                            },
                            expand_table_column_end_date: {
                                "zh-tw": "失效日期",
                                en: "End Date"
                            },
                        }
                    }
                },
            },
            inplant_production_management: {
                'zh-tw': '廠內生產管理模組',
                en: '',
                children: {
                    "inplant_manufacturing_order": {
                        'zh-tw': '廠內製造命令單',
                        en: 'In-plant manufacturing order',
                        children: {
                            "inplant_manufacturing_order": {
                                'zh-tw': '廠內製造命令單',
                                en: 'In-plant manufacturing order',
                            },
                            "editing": {
                                'zh-tw': '編輯',
                                en: 'Edit',
                            },
                            "create": {
                                'zh-tw': '新增',
                                en: 'create',
                            },
                            "read": {
                                'zh-tw': '瀏覽',
                                en: 'read',
                            },
                            "edit": {
                                'zh-tw': '資料編輯',
                                en: 'Edit',
                            },
                            "copy": {
                                'zh-tw': '資料複製',
                                en: 'Copy',
                            },
                            "delete": {
                                'zh-tw': '資料刪除',
                                en: 'Delete',
                            },
                            "operate": {
                                'zh-tw': '操作',
                                en: 'Operate',
                            },
                            "create_time": {
                                'zh-tw': '製令日期',
                                en: 'Order Date',
                            },
                            "manufacturing_order_number": {
                                'zh-tw': '製令單號',
                                en: 'Order number',
                            },
                            "process_status_name": {
                                'zh-tw': '製令類別',
                                en: 'Order category',
                            },
                            "master_part_number": {
                                'zh-tw': '母件編號',
                                en: 'Master part number',
                            },
                            "product_number": {
                                'zh-tw': '產品編號',
                                en: 'product number',
                            },
                            "specification": {
                                'zh-tw': '產品規格',
                                en: 'specification',
                            },
                            "order_process_list_status_name": {
                                'zh-tw': '單況',
                                en: 'Order Status',
                            },
                            "preset_output": {
                                'zh-tw': '生產數量',
                                en: 'Production quantity',
                            },
                            "unit": {
                                'zh-tw': '生產單位',
                                en: 'Production unit',
                            },

                            "production_parts": {
                                'zh-tw': '生產件',
                                en: 'Production parts',
                            },
                            "daily_production": {
                                'zh-tw': '日產量',
                                en: 'Daily production',
                            },
                            "original_production_quantity": {
                                'zh-tw': '原生產數量',
                                en: 'Original production quantity',
                            },

                            "source_name": {
                                'zh-tw': '來源別',
                                en: 'Source',
                            },
                            "orders": {
                                'zh-tw': '訂單',
                                en: 'orders',
                            },
                            "S/C": {
                                'zh-tw': 'S/C',
                                en: 'S/C',
                            },
                            "other": {
                                'zh-tw': '其他',
                                en: 'Other',
                            },
                            "order_code": {
                                'zh-tw': '來源單號',
                                en: 'Source tracking number',
                            },
                            "customer_name": {
                                'zh-tw': '客戶名稱',
                                en: 'Customer order number',
                            },
                            "responsible_person": {
                                'zh-tw': '負責人員',
                                en: 'Responsible person',
                            },
                            "project": {
                                'zh-tw': '所屬專案',
                                en: 'Project',
                            },
                            "order_maker": {
                                'zh-tw': '製單人員',
                                en: 'Order maker',
                            },
                            "storage_method": {
                                'zh-tw': '入庫方式',
                                en: 'Storage method',
                            },
                            "into_warehouse": {
                                'zh-tw': '入倉庫',
                                en: 'Into the warehouse',
                            },
                            "into_order": {
                                'zh-tw': '入製令',
                                en: 'Into the order',
                            },
                            "costing_method": {
                                'zh-tw': '成本計算方式',
                                en: 'Costing method',
                            },
                            "department": {
                                'zh-tw': '所屬部門',
                                en: 'department',
                            },
                            "reviewer": {
                                'zh-tw': '覆核人員',
                                en: 'Reviewer',
                            },
                            "check_orders": {
                                'zh-tw': '查單',
                                en: 'Check orders',
                            },
                            "component_requirements_analysis": {
                                'zh-tw': '子件需求分析',
                                en: 'Component Requirements Analysis',
                            },
                            "process_name": {
                                'zh-tw': '製程名稱',
                                en: 'process name',
                            },
                            "storage_status": {
                                'zh-tw': '入庫狀況',
                                en: 'Storage status',
                            },
                            "material_receiving_status": {
                                'zh-tw': '材料領用狀況',
                                en: 'Material receiving status',
                            },
                            "rework_picking_information": {
                                'zh-tw': '重工資訊',
                                en: 'Heavy industry information',
                            },
                            "row_number": {
                                'zh-tw': '序號',
                                en: 'NO.',
                            },
                            "material_type": {
                                'zh-tw': '料件型態',
                                en: 'material_type',
                            },
                            "component_number": {
                                'zh-tw': '子件編號',
                                en: 'component number',
                            },
                            "product_name": {
                                'zh-tw': '產品名稱',
                                en: 'Product name',
                            },
                            "specification": {
                                'zh-tw': '規格',
                                en: 'Specification',
                            },
                            "unit_dosage": {
                                'zh-tw': '單位用量',
                                en: 'Unit dosage',
                            },
                            "production_application_volume": {
                                'zh-tw': '生產應用量',
                                en: 'Production application volume',
                            },
                            "production_allowance": {
                                'zh-tw': '生產允領量',
                                en: 'Production allowance',
                            },
                            "calculation_unit": {
                                'zh-tw': '計算單位',
                                en: 'Calculation unit',
                            },
                            "attrition_rate": {
                                'zh-tw': '損耗率(%)',
                                en: 'Attrition rate(%)',
                            },
                            "material_source": {
                                'zh-tw': '料件來源',
                                en: 'Source of material',
                            },
                            "remark": {
                                'zh-tw': '備註',
                                en: 'Remark',
                            },
                            "required_dosage": {
                                'zh-tw': '需求用量',
                                en: 'required dosage',
                            },
                            "product_structure": {
                                'zh-tw': '產品結構',
                                en: 'product structure',
                            },
                            "order_code": {
                                'zh-tw': '訂單編號',
                                en: 'order code',
                            },
                            "source_name": {
                                'zh-tw': '來源別',
                                en: 'source name',
                            },
                            "order_date": {
                                'zh-tw': '訂單日期',
                                en: 'order date',
                            },
                            "customer_code": {
                                'zh-tw': '客戶代號',
                                en: 'customer code',
                            },
                            "customer_name": {
                                'zh-tw': '客戶名稱',
                                en: 'customer name',
                            },
                            "product_quantity": {
                                'zh-tw': '產品數量',
                                en: 'product quantity',
                            },
                            "specification": {
                                'zh-tw': '產品規格',
                                en: 'specification',
                            },
                            "total_amount": {
                                'zh-tw': ' 訂單總金額',
                                en: 'total_amount',
                            },
                        }
                    },
                    "inplant_picking_list": {
                        'zh-tw': '廠內領料單',
                        en: 'In-plant picking list',
                        children: {
                            "inplant_picking_list": {
                                'zh-tw': '廠內領料單',
                                en: 'In-plant picking list',
                            },
                            "editing": {
                                'zh-tw': '編輯',
                                en: 'Edit',
                            },
                            "create": {
                                'zh-tw': '新增',
                                en: 'create',
                            },
                            "read": {
                                'zh-tw': '瀏覽',
                                en: 'read',
                            },
                            "edit": {
                                'zh-tw': '資料編輯',
                                en: 'Edit',
                            },
                            "copy": {
                                'zh-tw': '資料複製',
                                en: 'Copy',
                            },
                            "delete": {
                                'zh-tw': '資料刪除',
                                en: 'Delete',
                            },
                            "operate": {
                                'zh-tw': '操作',
                                en: 'Operate',
                            },
                            "pick_up_date": {
                                'zh-tw': '領取日期',
                                en: 'Pick up date',
                            },
                            "picking_order_number": {
                                'zh-tw': '領料單號',
                                en: 'Picking order number',
                            },
                            "picking_list_number": {
                                'zh-tw': '領料單號',
                                en: 'Picking order number',
                            },
                            "creation_date": {
                                'zh-tw': '建立日期',
                                en: 'Creation date',
                            },
                            "subpoena_number": {
                                'zh-tw': '傳票編號',
                                en: 'Subpoena number',
                            },
                            "picking_sets": {
                                'zh-tw': '領料套數',
                                en: 'Picking sets',
                            },
                            "picker": {
                                'zh-tw': '領料人員',
                                en: 'Picker',
                            },
                            "picking_department": {
                                'zh-tw': '領料部門',
                                en: 'Picking department',
                            },
                            "order_maker": {
                                'zh-tw': '製單人員',
                                en: 'Order maker',
                            },
                            "reviewer": {
                                'zh-tw': '覆核人員',
                                en: 'Reviewer',
                            },

                            "picking_category": {
                                'zh-tw': '領料類別',
                                en: 'Picking category',
                            },
                            "order_picking": {
                                'zh-tw': '製令領料',
                                en: 'order_picking',
                            },
                            "out_of_material_picking": {
                                'zh-tw': '缺料領料',
                                en: 'Out of material picking',
                            },
                            "rework_picking": {
                                'zh-tw': '重工領料',
                                en: 'Rework picking',
                            },
                            "loss_picking": {
                                'zh-tw': '製損領料',
                                en: 'Loss Picking',
                            },
                            "other": {
                                'zh-tw': '其他',
                                en: 'Other',
                            },
                            "order_category": {
                                'zh-tw': '製令類別',
                                en: 'Order category',
                            },
                            "order_number": {
                                'zh-tw': '製令單號',
                                en: 'Order number',
                            },
                            "order_date": {
                                'zh-tw': '製令日期',
                                en: 'Order date',
                            },
                            "master_part_number": {
                                'zh-tw': '母件編號',
                                en: 'Master part number',
                            },
                            "product_name": {
                                'zh-tw': '品名',
                                en: 'Product name',
                            },
                            "specification": {
                                'zh-tw': '規格',
                                en: 'Specification',
                            },
                            "production_volume": {
                                'zh-tw': '生產數量',
                                en: 'Production volume',
                            },
                            "production_unit": {
                                'zh-tw': '生產單位',
                                en: 'Production unit',
                            },

                            "serial_number": {
                                'zh-tw': '序號',
                                en: 'NO.',
                            },
                            "material_type": {
                                'zh-tw': '料件型態',
                                en: 'material_type',
                            },
                            "component_number": {
                                'zh-tw': '子件編號',
                                en: 'component number',
                            },
                            "product_number": {
                                'zh-tw': '品號',
                                en: 'Product number',
                            },
                            "product_name": {
                                'zh-tw': '品名',
                                en: 'Product name',
                            },
                            "pick_up_quantity": {
                                'zh-tw': '領料數量',
                                en: 'Pick up quantity',
                            },
                            "requisition_quantity": {
                                'zh-tw': '需領料量',
                                en: 'Requisition quantity',
                            },
                            "unclaimed_quantity": {
                                'zh-tw': '未領料量',
                                en: 'Unclaimed quantity',
                            },
                            "calculation_unit": {
                                'zh-tw': '計算單位',
                                en: 'Calculation unit',
                            },
                            "warehouse": {
                                'zh-tw': '倉庫',
                                en: 'Warehouse',
                            },

                        }
                    },
                    "inplant_return_form": {
                        'zh-tw': '廠內退料單',
                        en: 'In-plant return form',
                        children: {
                            "editing": {
                                'zh-tw': '編輯',
                                en: 'Edit',
                            },
                            "create": {
                                'zh-tw': '新增',
                                en: 'create',
                            },
                            "read": {
                                'zh-tw': '瀏覽',
                                en: 'read',
                            },
                            "edit": {
                                'zh-tw': '資料編輯',
                                en: 'Edit',
                            },
                            "copy": {
                                'zh-tw': '資料複製',
                                en: 'Copy',
                            },
                            "delete": {
                                'zh-tw': '資料刪除',
                                en: 'Delete',
                            },
                            "operate": {
                                'zh-tw': '操作',
                                en: 'Operate',
                            },
                            "inplant_return_form": {
                                'zh-tw': '廠內退料單',
                                en: 'In-plant return form',
                            },
                            returning_list_number: {
                                'zh-tw': '退料單號',
                                en: 'return order number',
                            },
                            "return_order_number": {
                                'zh-tw': '退料單號',
                                en: 'return order number',
                            },
                            "nature": {
                                'zh-tw': '性質',
                                en: 'nature',
                            },
                            "makeing_order_number": {
                                'zh-tw': '製令單號',
                                en: 'Makeing order number',
                            },
                            "returning_time": {
                                'zh-tw': '退料日期',
                                en: 'Return date',
                            },
                            "product_number": {
                                'zh-tw': '品號',
                                en: 'Product number',
                            },
                            "product_name": {
                                'zh-tw': '品名',
                                en: 'Product name',
                            },
                            "returning_employee_name": {
                                'zh-tw': '製單人',
                                en: 'Order maker',
                            },
                            "returner": {
                                'zh-tw': '退料人',
                                en: 'Returner',
                            },
                            "unit": {
                                'zh-tw': '單位',
                                en: 'Unit',
                            },
                            "returning_type_name": {
                                'zh-tw': '退料性質',
                                en: 'Return type',
                            },
                            "get_order": {
                                'zh-tw': '取單',
                                en: 'Get Order',
                            },
                            "surplus_material_return": {
                                'zh-tw': '餘料退料',
                                en: 'Surplus material return',
                            },
                            "serial_number": {
                                'zh-tw': '序號',
                                en: 'serial number',
                            },
                            "field_warehouse": {
                                'zh-tw': '現場倉',
                                en: 'Field Warehouse',
                            },
                            "receiving_warehouse": {
                                'zh-tw': '領料倉',
                                en: 'Receiving warehouse',
                            },
                            "return_quantity": {
                                'zh-tw': '退回數量',
                                en: 'Return quantity',
                            },


                        }
                    },
                    "inplant_inbound_order": {
                        'zh-tw': '廠內生產入庫單',
                        en: 'Inplant inbound order',
                        children: {
                            "editing": {
                                'zh-tw': '編輯',
                                en: 'Edit',
                            },
                            "create": {
                                'zh-tw': '新增',
                                en: 'create',
                            },
                            "read": {
                                'zh-tw': '瀏覽',
                                en: 'read',
                            },
                            "edit": {
                                'zh-tw': '資料編輯',
                                en: 'Edit',
                            },
                            "copy": {
                                'zh-tw': '資料複製',
                                en: 'Copy',
                            },
                            "delete": {
                                'zh-tw': '資料刪除',
                                en: 'Delete',
                            },
                            "operate": {
                                'zh-tw': '操作',
                                en: 'Operate',
                            },
                            "inplant_inbound_order": {
                                'zh-tw': '廠內生產入庫單',
                                en: 'Inplant inbound order',
                            },
                            "create_time": {
                                'zh-tw': '單據日期',
                                en: 'order_date',
                            },
                            "enter_stock_order_list_number": {
                                'zh-tw': '入庫單號',
                                en: 'Inbound order number',
                            },
                            "subpoena_number": {
                                'zh-tw': '傳票編號',
                                en: 'Subpoena number',
                            },
                            "responsible_person": {
                                'zh-tw': '負責人',
                                en: 'Responsible person',
                            },
                            "department": {
                                'zh-tw': '所屬部門',
                                en: 'Department',
                            },
                            "order_maker": {
                                'zh-tw': '製單人',
                                en: 'order maker',
                            },
                            "order_category": {
                                'zh-tw': '製令類別',
                                en: 'Order category',
                            },
                            "finished_state": {
                                'zh-tw': '完工狀態',
                                en: 'Finished state',
                            },
                            "making_order_number": {
                                'zh-tw': '製令單號',
                                en: 'Order number',
                            },
                            "makeing_order_date": {
                                'zh-tw': '製令日期',
                                en: 'Making order date',
                            },
                            "master_part_number": {
                                'zh-tw': '母件編號',
                                en: 'Master part number',
                            },
                            "master_part_name": {
                                'zh-tw': '母件名稱',
                                en: 'Master part name',
                            },
                            "specification": {
                                'zh-tw': '規格',
                                en: 'Specification',
                            },
                            "production_unit": {
                                'zh-tw': '生產單位',
                                en: 'Production unit',
                            },
                            "production_volume": {
                                'zh-tw': '生產數量',
                                en: 'Production volume',
                            },
                            "volume_unit": {
                                'zh-tw': '數量單位',
                                en: 'Volume unit',
                            },
                            "standard_batch_working_hours": {
                                'zh-tw': '標準批量工時',
                                en: 'Standard batch working hours',
                            },
                            "standard_inbound_hours": {
                                'zh-tw': '標準入庫工時',
                                en: 'Standard inbound hours',
                            },
                            "actual_production_working_hours": {
                                'zh-tw': '實際生產工時',
                                en: 'Actual production working hours',
                            },
                            "goods_storage": {
                                'zh-tw': '良品入庫',
                                en: 'Goods storage',
                            },
                            "bad_storage": {
                                'zh-tw': '不良品入庫',
                                en: 'Defective product storage',
                            },
                            "storage_cost": {
                                'zh-tw': '入庫成本',
                                en: 'Storage cost',
                            },
                            "inspection_reports": {
                                'zh-tw': '驗貨報告',
                                en: 'Inspection reports',
                            },
                            "inbound_category": {
                                'zh-tw': '入庫類別',
                                en: 'Inbound category',
                            },
                            "inbound_quantity": {
                                'zh-tw': '入庫數量',
                                en: 'Inbound quantity',
                            },
                            "inbound_weight": {
                                'zh-tw': '入庫重量',
                                en: 'Inbound weight',
                            },
                            "shipping_date": {
                                'zh-tw': '出廠日期',
                                en: 'Shipping date',
                            },
                            "making_order_date": {
                                'zh-tw': '製令日期',
                                en: 'making order date',
                            },
                            "order_maker": {
                                'zh-tw': '製單人員',
                                en: 'order maker',
                            },
                            "master_unit_cost": {
                                'zh-tw': '母件單一成本',
                                en: 'master unit cost',
                            },
                            "total_storage_cost": {
                                'zh-tw': '入庫總成本',
                                en: 'Total storage cost',
                            },
                            "labor_cost": {
                                'zh-tw': '人工成本',
                                en: 'Labor cost',
                            },
                            "processing_cost": {
                                'zh-tw': '加工費用',
                                en: 'processing cost',
                            },
                            "manufacturing_costs": {
                                'zh-tw': '製造費用',
                                en: 'Manufacturing costs',
                            },
                            "material_costs": {
                                'zh-tw': '材料費用',
                                en: 'Material costs',
                            },
                        }
                    },
                    "infactory_over_collection": {
                        'zh-tw': '廠內超領單',
                        en: 'In-factory over-collection',
                        children: {
                            "infactory_over_collection": {
                                'zh-tw': '廠內超領單',
                                en: 'In-factory over-collection',
                            },
                            "inplant_picking_list": {
                                'zh-tw': '廠內領料單',
                                en: 'In-plant picking list',
                            },
                            "editing": {
                                'zh-tw': '編輯',
                                en: 'Edit',
                            },
                            "create": {
                                'zh-tw': '新增',
                                en: 'create',
                            },
                            "read": {
                                'zh-tw': '瀏覽',
                                en: 'read',
                            },
                            "edit": {
                                'zh-tw': '資料編輯',
                                en: 'Edit',
                            },
                            "copy": {
                                'zh-tw': '資料複製',
                                en: 'Copy',
                            },
                            "delete": {
                                'zh-tw': '資料刪除',
                                en: 'Delete',
                            },
                            "operate": {
                                'zh-tw': '操作',
                                en: 'Operate',
                            },
                            "pick_up_date": {
                                'zh-tw': '領取日期',
                                en: 'Pick up date',
                            },
                            "excess_material_requisition_list_number": {
                                'zh-tw': '領料單號',
                                en: 'Picking order number',
                            },
                            "creation_date": {
                                'zh-tw': '建立日期',
                                en: 'Creation date',
                            },
                            "subpoena_number": {
                                'zh-tw': '傳票編號',
                                en: 'Subpoena number',
                            },
                            "picking_sets": {
                                'zh-tw': '領料套數',
                                en: 'Picking sets',
                            },
                            "picker": {
                                'zh-tw': '領料人員',
                                en: 'Picker',
                            },
                            "picking_department": {
                                'zh-tw': '領料部門',
                                en: 'Picking department',
                            },
                            "order_maker": {
                                'zh-tw': '製單人員',
                                en: 'Order maker',
                            },
                            "reviewer": {
                                'zh-tw': '覆核人員',
                                en: 'Reviewer',
                            },

                            "picking_category": {
                                'zh-tw': '領料類別',
                                en: 'Picking category',
                            },
                            "order_picking": {
                                'zh-tw': '製令領料',
                                en: 'order_picking',
                            },
                            "out_of_material_picking": {
                                'zh-tw': '缺料領料',
                                en: 'Out of material picking',
                            },
                            "rework_picking": {
                                'zh-tw': '重工領料',
                                en: 'Rework picking',
                            },
                            "loss_picking": {
                                'zh-tw': '製損領料',
                                en: 'Loss Picking',
                            },
                            "other": {
                                'zh-tw': '其他',
                                en: 'Other',
                            },
                            "order_category": {
                                'zh-tw': '製令類別',
                                en: 'Order category',
                            },
                            "order_number": {
                                'zh-tw': '製令單號',
                                en: 'Order number',
                            },
                            "order_date": {
                                'zh-tw': '製令日期',
                                en: 'Order date',
                            },
                            "master_part_number": {
                                'zh-tw': '母件編號',
                                en: 'Master part number',
                            },
                            "product_name": {
                                'zh-tw': '品名',
                                en: 'Product name',
                            },
                            "specification": {
                                'zh-tw': '規格',
                                en: 'Specification',
                            },
                            "production_volume": {
                                'zh-tw': '生產數量',
                                en: 'Production volume',
                            },
                            "production_unit": {
                                'zh-tw': '生產單位',
                                en: 'Production unit',
                            },

                            "serial_number": {
                                'zh-tw': '序號',
                                en: 'NO.',
                            },
                            "material_type": {
                                'zh-tw': '料件型態',
                                en: 'material_type',
                            },
                            "component_number": {
                                'zh-tw': '子件編號',
                                en: 'component number',
                            },
                            "product_number": {
                                'zh-tw': '品號',
                                en: 'Product number',
                            },
                            "product_name": {
                                'zh-tw': '品名',
                                en: 'Product name',
                            },
                            "pick_up_quantity": {
                                'zh-tw': '領料數量',
                                en: 'Pick up quantity',
                            },
                            "requisition_quantity": {
                                'zh-tw': '需領料量',
                                en: 'Requisition quantity',
                            },
                            "unclaimed_quantity": {
                                'zh-tw': '未領料量',
                                en: 'Unclaimed quantity',
                            },
                            "calculation_unit": {
                                'zh-tw': '計算單位',
                                en: 'Calculation unit',
                            },
                            "warehouse": {
                                'zh-tw': '倉庫',
                                en: 'Warehouse',
                            },
                            reason: {
                                'zh-tw': '超領原因',
                                en: 'reason',
                            }
                        }
                    },
                    "integrated_printing_of_documents": {
                        'zh-tw': '單據整合列印',
                        en: 'Integrated printing of documents',
                        children: {

                        }
                    },
                },
            },
            multiple_processing_management: {
                'zh-tw': '多次加工管理模組',
                en: '',
                children: {
                    multiple_making_order: {
                        'zh-tw': '多次加工製令單',
                        en: '',
                        children: {
                            "multiple_making_order": {
                                'zh-tw': '多次加工製令單',
                                en: 'multiple making order',
                            },
                            "editing": {
                                'zh-tw': '編輯',
                                en: 'Edit',
                            },
                            "create": {
                                'zh-tw': '新增',
                                en: 'create',
                            },
                            "read": {
                                'zh-tw': '瀏覽',
                                en: 'read',
                            },
                            "edit": {
                                'zh-tw': '資料編輯',
                                en: 'Edit',
                            },
                            "copy": {
                                'zh-tw': '資料複製',
                                en: 'Copy',
                            },
                            "delete": {
                                'zh-tw': '資料刪除',
                                en: 'Delete',
                            },
                            "operate": {
                                'zh-tw': '操作',
                                en: 'Operate',
                            },
                            "order_date": {
                                'zh-tw': '製令日期',
                                en: 'Order Date',
                            },
                            "order_number": {
                                'zh-tw': '製令單號',
                                en: 'Order number',
                            },
                            "order_category": {
                                'zh-tw': '製令類別',
                                en: 'Order category',
                            },
                            "master_part_number": {
                                'zh-tw': '母件編號',
                                en: 'Master part number',
                            },
                            "order_status": {
                                'zh-tw': '單況',
                                en: 'Order Status',
                            },
                            "production_quantity": {
                                'zh-tw': '生產數量',
                                en: 'Production quantity',
                            },
                            "production_unit": {
                                'zh-tw': '生產單位',
                                en: 'Production unit',
                            },

                            "production_parts": {
                                'zh-tw': '生產件',
                                en: 'Production parts',
                            },
                            "daily_production": {
                                'zh-tw': '日產量',
                                en: 'Daily production',
                            },
                            "original_production_quantity": {
                                'zh-tw': '原生產數量',
                                en: 'Original production quantity',
                            },

                            "source": {
                                'zh-tw': '來源別',
                                en: 'Source',
                            },
                            "orders": {
                                'zh-tw': '訂單',
                                en: 'orders',
                            },
                            "S/C": {
                                'zh-tw': 'S/C',
                                en: 'S/C',
                            },
                            "other": {
                                'zh-tw': 'other',
                                en: 'Other',
                            },
                            "source_tracking_number": {
                                'zh-tw': '來源單號',
                                en: 'Source tracking number',
                            },
                            "customer_order_number": {
                                'zh-tw': '客戶單號',
                                en: 'Customer order number',
                            },
                            "responsible_person": {
                                'zh-tw': '負責人員',
                                en: 'Responsible person',
                            },
                            "project": {
                                'zh-tw': '所屬專案',
                                en: 'Project',
                            },
                            "order_maker": {
                                'zh-tw': '製單人員',
                                en: 'Order maker',
                            },
                            "storage_method": {
                                'zh-tw': '入庫方式',
                                en: 'Storage method',
                            },
                            "into_warehouse": {
                                'zh-tw': '入倉庫',
                                en: 'Into the warehouse',
                            },
                            "into_order": {
                                'zh-tw': '入製令',
                                en: 'Into the order',
                            },
                            "costing_method": {
                                'zh-tw': '成本計算方式',
                                en: 'Costing method',
                            },
                            "department": {
                                'zh-tw': '所屬部門',
                                en: 'department',
                            },
                            "reviewer": {
                                'zh-tw': '覆核人員',
                                en: 'Reviewer',
                            },
                            "check_orders": {
                                'zh-tw': '查單',
                                en: 'Check orders',
                            },
                            "component_requirements_analysis": {
                                'zh-tw': '子件需求分析',
                                en: 'Component Requirements Analysis',
                            },
                            "storage_status": {
                                'zh-tw': '入庫狀況',
                                en: 'Storage status',
                            },
                            "material_receiving_status": {
                                'zh-tw': '材料領用狀況',
                                en: 'Material receiving status',
                            },
                            "rework_picking_information": {
                                'zh-tw': '重工資訊',
                                en: 'Heavy industry information',
                            },
                            "delivery_date": {
                                'zh-tw': '交貨日期',
                                en: 'Delivery date',
                            },
                            "transaction_currency": {
                                'zh-tw': '交易幣別',
                                en: 'Transaction currency',
                            },
                            "transaction_exchange_rate": {
                                'zh-tw': '交易匯率',
                                en: 'transaction exchange rate',
                            },
                            "department_number": {
                                'zh-tw': '部門編號',
                                en: 'Department Number',
                            },
                            "manufacturer_number": {
                                'zh-tw': '廠商編號',
                                en: 'Dmanufacturer number',
                            },
                            "processing_unit_price": {
                                'zh-tw': '加工單價',
                                en: 'Processing unit price',
                            },
                            "tax_category": {
                                'zh-tw': '課稅類別',
                                en: 'tax category',
                            },
                            "pre_tax_unit_price": {
                                'zh-tw': '稅前單價',
                                en: 'Pre-tax unit price',
                            },
                            "total_before_taxes": {
                                'zh-tw': '稅前合計',
                                en: 'total before taxes',
                            },
                            "business_tax": {
                                'zh-tw': '營業稅額',
                                en: 'business tax',
                            },
                            "total_cost": {
                                'zh-tw': '費用總額',
                                en: 'total cost',
                            },
                            "serial_number": {
                                'zh-tw': '序號',
                                en: 'NO.',
                            },
                            "material_type": {
                                'zh-tw': '料件型態',
                                en: 'material_type',
                            },
                            "component_number": {
                                'zh-tw': '子件編號',
                                en: 'component number',
                            },
                            "product_name": {
                                'zh-tw': '品名',
                                en: 'Product name',
                            },
                            "specification": {
                                'zh-tw': '規格',
                                en: 'Specification',
                            },
                            "unit_dosage": {
                                'zh-tw': '單位用量',
                                en: 'Unit dosage',
                            },
                            "production_application_volume": {
                                'zh-tw': '生產應用量',
                                en: 'Production application volume',
                            },
                            "production_allowance": {
                                'zh-tw': '生產允領量',
                                en: 'Production allowance',
                            },
                            "calculation_unit": {
                                'zh-tw': '計算單位',
                                en: 'Calculation unit',
                            },
                            "attrition_rate": {
                                'zh-tw': '損耗率(%)',
                                en: 'Attrition rate(%)',
                            },
                            "material_source": {
                                'zh-tw': '料件來源',
                                en: 'Source of material',
                            },
                            "remark": {
                                'zh-tw': '備註',
                                en: 'Remark',
                            },
                        },
                    },
                    multiple_processing_orders: {
                        'zh-tw': '多次加工單',
                        en: '',
                        children: {
                            "multiple_processing_orders": {
                                'zh-tw': '多次加工單',
                                en: 'multiple processing orders',
                            },
                            "editing": {
                                'zh-tw': '編輯',
                                en: 'Edit',
                            },
                            "create": {
                                'zh-tw': '新增',
                                en: 'create',
                            },
                            "read": {
                                'zh-tw': '瀏覽',
                                en: 'read',
                            },
                            "edit": {
                                'zh-tw': '資料編輯',
                                en: 'Edit',
                            },
                            "copy": {
                                'zh-tw': '資料複製',
                                en: 'Copy',
                            },
                            "delete": {
                                'zh-tw': '資料刪除',
                                en: 'Delete',
                            },
                            "operate": {
                                'zh-tw': '操作',
                                en: 'Operate',
                            },
                            "making_order_number": {
                                'zh-tw': '製令單號',
                                en: 'making order number',
                            },
                            "product_number": {
                                'zh-tw': '產品編號',
                                en: 'product number',
                            },
                            "process_sequence": {
                                'zh-tw': '製程順序',
                                en: 'process sequence',
                            },
                            "process_name": {
                                'zh-tw': '製程名稱',
                                en: 'process name',
                            },
                            "production_unit": {
                                'zh-tw': '生產單位',
                                en: 'production unit',
                            },
                            "production_category": {
                                'zh-tw': '生產類別',
                                en: 'production category',
                            },
                            "estimated_start_date": {
                                'zh-tw': '預計開工日',
                                en: 'Estimated start date',
                            },
                            "product_specifications": {
                                'zh-tw': '產品規格',
                                en: 'product specifications',
                            },
                            "product_name": {
                                'zh-tw': '產品名稱',
                                en: 'product name',
                            },
                            "processing_date": {
                                'zh-tw': '加工日期',
                                en: 'processing date',
                            },
                            "processing_order_number": {
                                'zh-tw': '加工單號',
                                en: 'processing order number',
                            },
                            "process_code": {
                                'zh-tw': '製程代號',
                                en: 'process code',
                            },
                            "picking_date": {
                                'zh-tw': '領料日期',
                                en: 'picking_date',
                            },
                            "production_quantity": {
                                'zh-tw': '生產數量',
                                en: 'production quantity',
                            },
                            "serial_number": {
                                'zh-tw': '序號',
                                en: 'serial number',
                            },
                            "material_number": {
                                'zh-tw': '料件編號',
                                en: 'Material number',
                            },
                            "receivable_quantity": {
                                'zh-tw': '應領數量',
                                en: 'Receivable quantity',
                            },
                            "measure_unit": {
                                'zh-tw': '計量單位',
                                en: 'measure unit',
                            },
                            "estimated_delivery_date": {
                                'zh-tw': '預計交貨日',
                                en: 'Estimated delivery date',
                            },
                        }
                    },
                    multiple_material_transfer_order: {
                        'zh-tw': '多次加工料件移轉單',
                        en: 'Multiple Material Transfer Order',
                        children: {
                            multiple_material_transfer_order: {
                                'zh-tw': '多次加工料件移轉單',
                                en: 'Multiple Material Transfer Order',

                            },
                            "editing": {
                                'zh-tw': '編輯',
                                en: 'Edit',
                            },
                            "create": {
                                'zh-tw': '新增',
                                en: 'create',
                            },
                            "read": {
                                'zh-tw': '瀏覽',
                                en: 'read',
                            },
                            "edit": {
                                'zh-tw': '資料編輯',
                                en: 'Edit',
                            },
                            "copy": {
                                'zh-tw': '資料複製',
                                en: 'Copy',
                            },
                            "delete": {
                                'zh-tw': '資料刪除',
                                en: 'Delete',
                            },
                            "operate": {
                                'zh-tw': '操作',
                                en: 'Operate',
                            },
                            "transfer_date": {
                                'zh-tw': '移轉日期',
                                en: 'transfer date',
                            },
                            "processing_order_number": {
                                'zh-tw': '加工單號',
                                en: 'Processing order number',
                            },
                            "transfer_order_number": {
                                'zh-tw': '移轉單號',
                                en: 'transfer order number',
                            },
                            "completed_quantity": {
                                'zh-tw': '完成數量',
                                en: 'completed quantity',
                            },
                            "completed_weight": {
                                'zh-tw': '完成重量',
                                en: 'completed weight',
                            },
                            "scrapped_quantity": {
                                'zh-tw': '報廢數量',
                                en: 'scrapped quantity',
                            },
                            "inspection_return_quantity": {
                                'zh-tw': '驗退數量',
                                en: 'inspection return quantity',
                            },
                            "responsible_person": {
                                'zh-tw': '負責人員',
                                en: 'responsible person',
                            },
                            "making_order_number": {
                                'zh-tw': '製令單號',
                                en: 'making order number',
                            },
                            "product_number": {
                                'zh-tw': '產品編號',
                                en: 'product number',
                            },
                            "product_name": {
                                'zh-tw': '產品名稱',
                                en: 'product name',
                            },
                            "remove_process": {
                                'zh-tw': '移出製程',
                                en: 'remove process',
                            },
                            "into_process": {
                                'zh-tw': '移入製程',
                                en: 'into process',
                            },
                            "into_production_unit": {
                                'zh-tw': '移入生產單位',
                                en: 'into production unit',
                            },
                            "remove_production_unit": {
                                'zh-tw': '移出生產單位',
                                en: 'remove production unit',
                            },
                            "production_unit": {
                                'zh-tw': '生產單位',
                                en: 'production unit',
                            },
                            "production_category": {
                                'zh-tw': '生產類別',
                                en: 'production category',
                            },
                            "product_specifications": {
                                'zh-tw': '產品規格',
                                en: 'product specifications',
                            },
                            "production_quantity": {
                                'zh-tw': '生產數量',
                                en: 'production quantity',
                            },
                            "order_maker": {
                                'zh-tw': '製單人員',
                                en: 'order maker',
                            },
                            "unit_weight": {
                                'zh-tw': '單位重',
                                en: 'unit weight',
                            },
                            "transfer_category": {
                                'zh-tw': '移轉類別',
                                en: 'Transfer category',
                            },
                            "transfer_weight": {
                                'zh-tw': '移轉重量',
                                en: 'transfer weight',
                            },
                            "transfer_quantity": {
                                'zh-tw': '移轉數量',
                                en: 'transfer quantity',
                            },

                        }
                    },
                    multiple_material_return_order: {
                        'zh-tw': '多次加工料件退回單',
                        en: 'Multiple Material Return Order',
                        children: {
                            multiple_material_return_order: {
                                'zh-tw': '多次加工料件退回單',
                                en: 'Multiple Material Return Order',
                            },
                            "editing": {
                                'zh-tw': '編輯',
                                en: 'Edit',
                            },
                            "create": {
                                'zh-tw': '新增',
                                en: 'create',
                            },
                            "read": {
                                'zh-tw': '瀏覽',
                                en: 'read',
                            },
                            "edit": {
                                'zh-tw': '資料編輯',
                                en: 'Edit',
                            },
                            "copy": {
                                'zh-tw': '資料複製',
                                en: 'Copy',
                            },
                            "delete": {
                                'zh-tw': '資料刪除',
                                en: 'Delete',
                            },
                            "operate": {
                                'zh-tw': '操作',
                                en: 'Operate',
                            },
                            "return_date": {
                                'zh-tw': '退回日期',
                                en: 'return date',
                            },
                            "processing_order_number": {
                                'zh-tw': '加工單號',
                                en: 'Processing order number',
                            },
                            "return_order_number": {
                                'zh-tw': '退回單號',
                                en: 'return order number',
                            },
                            "completed_quantity": {
                                'zh-tw': '完成數量',
                                en: 'completed quantity',
                            },
                            "completed_weight": {
                                'zh-tw': '完成重量',
                                en: 'completed weight',
                            },
                            "scrapped_quantity": {
                                'zh-tw': '報廢數量',
                                en: 'scrapped quantity',
                            },
                            "inspection_return_quantity": {
                                'zh-tw': '驗退數量',
                                en: 'inspection return quantity',
                            },
                            "responsible_person": {
                                'zh-tw': '負責人員',
                                en: 'responsible person',
                            },
                            "making_order_number": {
                                'zh-tw': '製令單號',
                                en: 'making order number',
                            },
                            "product_number": {
                                'zh-tw': '產品編號',
                                en: 'product number',
                            },
                            "product_name": {
                                'zh-tw': '產品名稱',
                                en: 'product name',
                            },
                            "remove_process": {
                                'zh-tw': '退出製程',
                                en: 'remove process',
                            },
                            "into_process": {
                                'zh-tw': '退回製程',
                                en: 'into process',
                            },
                            "into_production_unit": {
                                'zh-tw': '退回生產單位',
                                en: 'into production unit',
                            },
                            "remove_production_unit": {
                                'zh-tw': '退出生產單位',
                                en: 'remove production unit',
                            },
                            "production_unit": {
                                'zh-tw': '生產單位',
                                en: 'production unit',
                            },
                            "production_category": {
                                'zh-tw': '生產類別',
                                en: 'production category',
                            },
                            "product_specifications": {
                                'zh-tw': '產品規格',
                                en: 'product specifications',
                            },
                            "production_quantity": {
                                'zh-tw': '生產數量',
                                en: 'production quantity',
                            },
                            "order_maker": {
                                'zh-tw': '製單人員',
                                en: 'order maker',
                            },
                            "unit_weight": {
                                'zh-tw': '單位重',
                                en: 'unit weight',
                            },

                            "return_weight": {
                                'zh-tw': '退回重量',
                                en: 'return weight',
                            },
                            "return_quantity": {
                                'zh-tw': '退回數量',
                                en: 'return quantity',
                            },

                        }
                    },
                },
            },
            onsite_production_management: {
                'zh-tw': '現場生產管理模組',
                en: '',
                children: {
                    "instant_order_production_status_overview": {
                        'zh-tw': '即時訂單生產狀態總覽',
                        en: 'Instant order production status overview',
                        children: {
                            "instant_order_production_status_overview": {
                                'zh-tw': '即時訂單生產狀態總覽',
                                en: 'Instant order production status overview',
                            },
                            "instant_order": {
                                'zh-tw': '即時訂單',
                                en: 'Instant order',
                            },
                            "all_orders": {
                                'zh-tw': '全部訂單',
                                en: 'Instant order',
                            },
                            "pending_delivery": {
                                'zh-tw': '待發貨',
                                en: 'Pending delivery',
                            },
                            "shipped": {
                                'zh-tw': '已發貨',
                                en: 'Shipped',
                            },
                            "making_order_number": {
                                'zh-tw': '製程單單號',
                                en: 'Making order number',
                            },
                            "client_name": {
                                'zh-tw': '客戶名稱',
                                en: 'Client name',
                            },
                            "product_name": {
                                'zh-tw': '產品名稱',
                                en: 'product name',
                            },
                            "specification": {
                                'zh-tw': '規格',
                                en: 'Specification',
                            },
                            "quantity": {
                                'zh-tw': '數量',
                                en: 'quantity',
                            },
                            "production_progress": {
                                'zh-tw': '生產進度',
                                en: 'production progress',
                            },
                            "delivery_status": {
                                'zh-tw': '交貨狀態',
                                en: 'delivery status',
                            },
                            "order_date": {
                                'zh-tw': '下單日期',
                                en: 'order date',
                            },
                            "delivery_date": {
                                'zh-tw': '交貨日期',
                                en: 'Delivery date',
                            },
                            "remaining_days": {
                                'zh-tw': '剩餘天數',
                                en: 'remaining days',
                            },
                            "the_output_and_cumulative_situation_of_each_time_period_of_the_day": {
                                'zh-tw': '當日各時段產量與累計情況',
                                en: 'The output and cumulative situation of each time period of the day',
                            },
                            "output": {
                                'zh-tw': '生產產量',
                                en: 'output',
                            }
                            ,
                            "accumulate_output": {
                                'zh-tw': '累積產量',
                                en: 'accumulate output',
                            },
                            "current_month_day_progress_output": {
                                'zh-tw': '當月/當日進度產量',
                                en: 'Current month/day progress output',
                            },
                            "today": {
                                'zh-tw': '當日',
                                en: 'today',
                            },
                            "month": {
                                'zh-tw': '當月',
                                en: 'month',
                            },
                            "planned_output": {
                                'zh-tw': '計畫產量',
                                en: 'Planned output',
                            },
                            "actual_output": {
                                'zh-tw': '實際產量',
                                en: 'Actual output',
                            },
                            "output_overview": {
                                'zh-tw': '產量總覽',
                                en: 'output overview',
                            },
                            "completed": {
                                'zh-tw': '已完成',
                                en: 'completed',
                            },
                            "completion_rate": {
                                'zh-tw': '完成率',
                                en: 'Completion rate',
                            },
                            "bad_rate_trend": {
                                'zh-tw': '不良率趨勢',
                                en: 'Bad rate trend',
                            },
                            "targe_value": {
                                'zh-tw': '目標值',
                                en: 'target value',
                            },
                            "average_value": {
                                'zh-tw': '平均值',
                                en: 'average_value',
                            },
                            "bad_rate": {
                                'zh-tw': '不良率',
                                en: 'Bad rate',
                            },
                        },
                    },
                    "real_time_machine_status_overview": {
                        'zh-tw': '即時機台運作狀態總覽',
                        en: 'Real-time machine status overview',
                        children: {
                            "real_time_machine_status_overview": {
                                'zh-tw': '即時機台運作狀態總覽',
                                en: 'Real-time machine status overview',
                            },
                            "machine_name": {
                                'zh-tw': '機台名稱',
                                en: 'Machine name',
                            },
                            "machine_utilization_rate": {
                                'zh-tw': '機台稼動率',
                                en: 'Machine utilization rate',
                            },
                            "making_order_number": {
                                'zh-tw': '製令單號',
                                en: 'making order number',
                            },
                            "current_production_quantity": {
                                'zh-tw': '目前生產數量',
                                en: 'current production quantity',
                            },
                            "estimated_production_quantity": {
                                'zh-tw': '預計生產數量',
                                en: 'estimated production quantity',
                            },
                            "completeness": {
                                'zh-tw': '完成度',
                                en: 'Completeness',
                            },
                            "in_time": {
                                'zh-tw': '進站時間',
                                en: 'in time',
                            },
                            "pass_production_time": {
                                'zh-tw': '已生產時間',
                                en: 'pass production time',
                            },
                            "estimated_finish_time": {
                                'zh-tw': '預計完成時間',
                                en: 'estimated finish time',
                            },
                        },
                    },
                    "online_rework_records": {
                        'zh-tw': '線上重工紀錄',
                        en: 'Online Rework Records',
                        children: {

                        },
                    },
                    "process_overtime_record": {
                        'zh-tw': '製程加時紀錄',
                        en: 'Process overtime record',
                        children: {

                        },
                    },
                    "online_defect_records": {
                        'zh-tw': '線上不良品紀錄',
                        en: 'Online defect records',
                        children: {

                        },
                    },
                    "order_splitting_in_production": {
                        'zh-tw': '生產中途分單作業',
                        en: 'Order splitting in the middle of production',
                        children: {

                        },
                    },
                    "production_hours_record": {
                        'zh-tw': '生產工時紀錄',
                        en: 'Production hours record',
                        children: {

                        },
                    },
                    "rfid_production_history_record": {
                        'zh-tw': 'RFID生產歷程紀錄',
                        en: 'RFID Production History Record',
                        children: {

                        },
                    },
                },
            },
            production_equipment_management: {
                'zh-tw': '生產設備管理模組',
                en: '',
                children: {
                },
            },
            outsourced_production_management: {
                'zh-tw': '委外生產管理模組',
                en: 'Outsourced Production Management',
                children: {
                    outsourcing_work_order: {
                        "zh-tw": "委外製造命令單",
                        en: "Outsourcing Work Order",
                        children: {
                            /* Basic functional setting */
                            print: {
                                'zh-tw': '列印',
                                en: 'Print'
                            },
                            export: {
                                'zh-tw': '匯出資料',
                                en: 'Export Data'
                            },
                            import: {
                                'zh-tw': '匯入資料',
                                en: 'Import Data',
                                children: {
                                    sample: {
                                        'zh-tw': '下載範例',
                                        en: 'Download Sample'
                                    },
                                    upload: {
                                        'zh-tw': '上傳Excel檔案',
                                        en: 'Upload Excel File'
                                    },
                                    preview: {
                                        'zh-tw': '預覽檔案',
                                        en: 'Preview File'
                                    },
                                    finish: {
                                        'zh-tw': '確認匯入',
                                        en: 'Confirm'
                                    },
                                    close: {
                                        'zh-tw': '關閉',
                                        en: 'Close'
                                    },
                                }
                            },
                            /* Basic functional setting */
                            order_date: {
                                "zh-tw": "製令日期",
                                en: "Order Date"
                            },
                            order_number: {
                                "zh-tw": "製令單號",
                                en: "Order Number"
                            },
                            parent_order_number: {
                                "zh-tw": "母件編號",
                                en: "Parent Order Number"
                            },
                            production_quantity: {
                                "zh-tw": "生產數量",
                                en: "Production Quantity"
                            },
                            production_unit: {
                                "zh-tw": "生產單位",
                                en: "Production Unit"
                            },
                            daily_production: {
                                "zh-tw": "日產量",
                                en: "Daily Production"
                            },
                            original_production_quantity: {
                                "zh-tw": "原生產數量",
                                en: "Original Production Quantity"
                            },
                            work_order_category: {
                                "zh-tw": "製令類別",
                                en: "Work Order Category"
                            },
                            production_parts: {
                                "zh-tw": "生產件",
                                en: "Production Parts"
                            },
                            storage_method: {
                                'zh-tw': '入庫方式',
                                en: 'Storage Method',
                            },
                            into_warehouse: {
                                'zh-tw': '入倉庫',
                                en: 'Into The Warehouse',
                            },
                            into_order: {
                                'zh-tw': '入製令',
                                en: 'Into The Order',
                            },
                            delivery_location: {
                                "zh-tw": "交貨地點",
                                en: "Delivery Location"
                            },
                            company: {
                                "zh-tw": "廠商",
                                en: "Company"
                            },
                            currency: {
                                "zh-tw": "幣別",
                                en: "Currency"
                            },
                            price: {
                                "zh-tw": "單價",
                                en: "Price"
                            },
                            payment: {
                                "zh-tw": "付款方式",
                                en: "Payment"
                            },
                            expand_table_column_serial: {
                                "zh-tw": "欄號",
                                en: "Serial"
                            },
                            expand_table_column_material_type: {
                                "zh-tw": "料件型態",
                                en: "Material Type"
                            },
                            expand_table_column_child_material_number: {
                                "zh-tw": "子件編號",
                                en: "Child Material Number"
                            },
                            expand_table_column_material_name: {
                                "zh-tw": "品名",
                                en: "Material Name"
                            },
                            expand_table_column_specification: {
                                "zh-tw": "規格",
                                en: "Specification"
                            },
                            expand_table_column_unit_dosage: {
                                "zh-tw": "單位用量",
                                en: "Unit Dosage"
                            },
                            expand_table_column_production_application_volume: {
                                "zh-tw": "生產應用量",
                                en: "Production Application Volume"
                            },
                            expand_table_column_production_allowance: {
                                'zh-tw': '生產允領量',
                                en: 'Production Allowance',
                            },
                            expand_table_column_calculation_unit: {
                                'zh-tw': '計算單位',
                                en: 'Calculation Unit',
                            },
                            expand_table_column_attrition_rate: {
                                'zh-tw': '損耗率(%)',
                                en: 'Attrition Rate(%)',
                            },
                            expand_table_column_material_source: {
                                'zh-tw': '料件來源',
                                en: 'Source of Material',
                            },
                        }
                    },
                    supply_or_return_material: {
                        "zh-tw": "委外送料/退料單",
                        en: "Supply/Return Material",
                        children: {
                            /* Title */
                            supply_material: {
                                "zh-tw": "委外送料單",
                                en: "Outsourcing Supply Material Order",
                            },
                            return_material: {
                                "zh-tw": "委外退料單",
                                en: "Outsourcing Return Material Order",
                            },
                            /* Title */
                            /* Basic functional setting */
                            add_staff: {
                                'zh-tw': '新增BOM',
                                en: 'Add Staff'
                            },
                            go_back: {
                                "zh-tw": "返回",
                                en: "Go Back"
                            },
                            print: {
                                'zh-tw': '列印',
                                en: 'Print'
                            },
                            export: {
                                'zh-tw': '匯出資料',
                                en: 'Export Data'
                            },
                            import: {
                                'zh-tw': '匯入資料',
                                en: 'Import Data',
                                children: {
                                    sample: {
                                        'zh-tw': '下載範例',
                                        en: 'Download Sample'
                                    },
                                    upload: {
                                        'zh-tw': '上傳Excel檔案',
                                        en: 'Upload Excel File'
                                    },
                                    preview: {
                                        'zh-tw': '預覽檔案',
                                        en: 'Preview File'
                                    },
                                    finish: {
                                        'zh-tw': '確認匯入',
                                        en: 'Confirm'
                                    },
                                    close: {
                                        'zh-tw': '關閉',
                                        en: 'Close'
                                    },
                                }
                            },
                            edit: {
                                'zh-tw': '資料編輯',
                                en: 'Edit Data'
                            },
                            copy: {
                                'zh-tw': '資料複製',
                                en: 'Copy Data'
                            },
                            delete: {
                                'zh-tw': '資料刪除',
                                en: 'Delete Data'
                            },
                            table_column_operation: {
                                'zh-tw': '操作',
                                en: 'Functions'
                            },
                            button_edit_permission_title: {
                                'zh-tw': '修改人員權限',
                                en: 'Edit Permission'
                            },
                            button_edit_permission_subtitle: {
                                'zh-tw': '您正在修改{X} {Y}的權限',
                                en: 'You are modifying permissions for {X} {Y}'
                            },
                            /* Basic functional setting */
                            order_number: {
                                "zh-tw": "單號",
                                en: "Order Number"
                            },
                            supply_material_order: {
                                "zh-tw": "送料單別",
                                en: "Supply Material Order"
                            },
                            return_material_order: {
                                "zh-tw": "退料單別",
                                en: "Return Material Order"
                            },
                            supply_material_order_number: {
                                "zh-tw": "送料單號",
                                en: "Supply Material Order Number"
                            },
                            return_material_order_number: {
                                "zh-tw": "退料單號",
                                en: "Return Material Order Number"
                            },
                            parent_material_number: {
                                "zh-tw": "主件品號",
                                en: "Parent Material Number"
                            },
                            parent_material_name: {
                                "zh-tw": "主件品名",
                                en: "Parent Material Name"
                            },
                            order_date: {
                                "zh-tw": "單據日期",
                                en: "Order Date"
                            },
                            remark: {
                                "zh-tw": "備註",
                                en: "Remark"
                            },
                            responsible_person: {
                                "zh-tw": "負責人",
                                en: "Responsible Person"
                            },
                            company: {
                                "zh-tw": "廠商",
                                en: "Company"
                            },
                            company_address: {
                                "zh-tw": "廠商地址",
                                en: "Company Address"
                            },
                            inventory: {
                                "zh-tw": "倉庫",
                                en: "Inventory"
                            },
                            total_quantity: {
                                "zh-tw": "數量合計",
                                en: "Total Quantity"
                            },
                            expand_table_column_serial: {
                                "zh-tw": "序號",
                                en: "Serial"
                            },
                            expand_table_column_material_number: {
                                "zh-tw": "材料品號",
                                en: "Material Number"
                            },
                            expand_table_column_material_name: {
                                "zh-tw": "品名",
                                en: "Material Name"
                            },
                            expand_table_column_specification: {
                                "zh-tw": "規格",
                                en: "Specification"
                            },
                            expand_table_column_need_supply_quantity: {
                                "zh-tw": "需送料量",
                                en: "The Quantity Needed To Be Supplied"
                            },
                            expand_table_column_need_return_quantity: {
                                "zh-tw": "需退料量",
                                en: "The Quantity Needed To Be Returned"
                            },
                            expand_table_column_not_supply_quantity: {
                                "zh-tw": "未送料量",
                                en: "The Quantity Wasn't Be Supplied Yet"
                            },
                            expand_table_column_not_return_quantity: {
                                "zh-tw": "未退料量",
                                en: "The Quantity Wasn't Be Returned Yet"
                            },
                            expand_table_column_has_supply_quantity: {
                                "zh-tw": "已送料量",
                                en: "The Quantity Has Been Supplied"
                            },
                            expand_table_column_has_return_quantity: {
                                "zh-tw": "已退料量",
                                en: "The Quantity Has Been Returned"
                            },
                            expand_table_column_unit: {
                                "zh-tw": "單位",
                                en: "Unit"
                            },
                            expand_table_column_supply_inventory: {
                                "zh-tw": "送料倉",
                                en: "Supply Inventory"
                            },
                            expand_table_column_return_inventory: {
                                "zh-tw": "退料倉",
                                en: "Return Inventory"
                            },
                            expand_table_column_outsourcing_inventory: {
                                "zh-tw": "委外倉",
                                en: "Outsourcing Inventory"
                            },
                        }
                    },
                    inbound_order: {
                        "zh-tw": "委外生產入庫單",
                        en: "Outsourcing Inbound Order",
                        children: {
                            /* Basic functional setting */
                            print: {
                                'zh-tw': '列印',
                                en: 'Print'
                            },
                            export: {
                                'zh-tw': '匯出資料',
                                en: 'Export Data'
                            },
                            import: {
                                'zh-tw': '匯入資料',
                                en: 'Import Data',
                                children: {
                                    sample: {
                                        'zh-tw': '下載範例',
                                        en: 'Download Sample'
                                    },
                                    upload: {
                                        'zh-tw': '上傳Excel檔案',
                                        en: 'Upload Excel File'
                                    },
                                    preview: {
                                        'zh-tw': '預覽檔案',
                                        en: 'Preview File'
                                    },
                                    finish: {
                                        'zh-tw': '確認匯入',
                                        en: 'Confirm'
                                    },
                                    close: {
                                        'zh-tw': '關閉',
                                        en: 'Close'
                                    },
                                }
                            },
                            create: {
                                "zh-tw": "新增",
                                en: "Create"
                            },
                            /* Basic functional setting */
                            order_date: {
                                "zh-tw": "單據日期",
                                en: "Order Date"
                            },
                            delivery_date: {
                                "zh-tw": "交貨日期",
                                en: "Delivery Date"
                            },
                            inbound_order_number: {
                                "zh-tw": "入庫單號",
                                en: "Inbound Order Number"
                            },
                            responsible_person: {
                                "zh-tw": "負責人",
                                en: "Responsible Person"
                            },
                            module: {
                                "zh-tw": "部門",
                                en: "Module"
                            },
                            work_order_category: {
                                "zh-tw": "製令類別",
                                en: "Work Order Category"
                            },
                            parent_material_number: {
                                "zh-tw": "母件編號",
                                en: "Parent Material Number"
                            },
                            production_quantity: {
                                "zh-tw": "生產數量",
                                en: "Production Quantity"
                            },
                            material_name: {
                                "zh-tw": "品名",
                                en: "Material Name"
                            },
                            specification: {
                                "zh-tw": "規格",
                                en: "Specification"
                            },
                            company: {
                                "zh-tw": "委外廠商",
                                en: "Outsourcing Company"
                            },
                            std_batch_working_hours: {
                                "zh-tw": "標準批量工時",
                                en: "Standard Batch Working Hours"
                            },
                            std_inbound_working_hours: {
                                "zh-tw": "標準入庫工時",
                                en: "Standard Inbound Working Hours"
                            },
                            actual_production_working_hours: {
                                "zh-tw": "實際生產工時",
                                en: "Actual Production Working Hours"
                            },
                            complete_status: {
                                "zh-tw": "完工狀態",
                                en: "Complete Status"
                            },
                            work_order_date: {
                                "zh-tw": "製令日期",
                                en: "Work Order Date"
                            },
                            non_defective_products: { // Tabs
                                "zh-tw": "良品入庫",
                                en: "Non-defective Products Inbound"
                            },
                            defective_products: { // Tabs
                                "zh-tw": "不良品入庫",
                                en: "Defective Products Inbound"
                            },
                            storage_method: {
                                "zh-tw": "入庫方式",
                                en: "Storage Method"
                            },
                            into_warehouse: {
                                'zh-tw': '入倉庫',
                                en: 'Into The Warehouse',
                            },
                            into_order: {
                                'zh-tw': '入製令',
                                en: 'Into The Order',
                            },
                            inbound_weight: {
                                "zh-tw": "入庫重量",
                                en: "Inbound Weight"
                            },
                            table_column_serial: {
                                "zh-tw": "欄號",
                                en: "Serial"
                            },
                            table_column_inbound_category: {
                                "zh-tw": "入庫類別",
                                en: "Inbound Category"
                            },
                            table_column_inventory: {
                                "zh-tw": "倉庫名稱",
                                en: "Inventory"
                            },
                            table_column_product_quantity: {
                                "zh-tw": "產品數量",
                                en: "Product Quantity"
                            },
                            table_column_unit: {
                                "zh-tw": "單位",
                                en: "Unit"
                            },
                            table_column_inbound_weight: {
                                "zh-tw": "入庫重量",
                                en: "Inbound Weight"
                            },
                            table_column_remark: {
                                "zh-tw": "備註",
                                en: "remark"
                            },
                            work_order_number: {
                                "zh-tw": "製令單號",
                                en: "Work Order Number"
                            },
                            product_name: {
                                "zh-tw": "產品名稱",
                                en: "Product Name"
                            },
                            inbound_quantity: {
                                "zh-tw": "入庫數量",
                                en: "Inbound Quantity"
                            },
                            inbound_date: {
                                "zh-tw": "入庫日期",
                                en: "Inbound Date"
                            }
                        }
                    },

                    processing_delivery_goods: {
                        "zh-tw": "委外加工送貨帳單",
                        en: "Outsourcing Processing Delivery Goods Order",
                        children: {
                            /* Basic functional setting */
                            print: {
                                'zh-tw': '列印',
                                en: 'Print'
                            },
                            export: {
                                'zh-tw': '匯出資料',
                                en: 'Export Data'
                            },
                            import: {
                                'zh-tw': '匯入資料',
                                en: 'Import Data',
                                children: {
                                    sample: {
                                        'zh-tw': '下載範例',
                                        en: 'Download Sample'
                                    },
                                    upload: {
                                        'zh-tw': '上傳Excel檔案',
                                        en: 'Upload Excel File'
                                    },
                                    preview: {
                                        'zh-tw': '預覽檔案',
                                        en: 'Preview File'
                                    },
                                    finish: {
                                        'zh-tw': '確認匯入',
                                        en: 'Confirm'
                                    },
                                    close: {
                                        'zh-tw': '關閉',
                                        en: 'Close'
                                    },
                                }
                            },
                            /* Basic functional setting */
                            order_date: {
                                "zh-tw": "帳單日期",
                                en: "Order Date"
                            },
                            order_number: {
                                "zh-tw": "單據號碼",
                                en: "Order Number"
                            },
                            work_order_number: {
                                "zh-tw": "製令單號",
                                en: "Work Order Number"
                            },
                            product_name: {
                                "zh-tw": "產品名稱",
                                en: "Product Name"
                            },
                            quantity: {
                                "zh-tw": "數量",
                                en: "Quantity"
                            },
                            unit: {
                                "zh-tw": "單位",
                                en: "Unit"
                            },
                            company: {
                                "zh-tw": "委外廠商",
                                en: "Outsourcing Company"
                            },
                            address: {
                                "zh-tw": "單據地址",
                                en: "Order Address"
                            },
                            currency: {
                                "zh-tw": "幣別",
                                en: "Currency"
                            },
                            contact_person: {
                                "zh-tw": "聯絡人員",
                                en: "Contact Person"
                            },
                            contact_phone: {
                                "zh-tw": "聯絡電話",
                                en: "Contact Phone"
                            },
                            product_price: {
                                "zh-tw": "產品單價",
                                en: "Product Price"
                            },
                            untaxed: {
                                "zh-tw": "未稅",
                                en: "Untaxed"
                            },
                            taxed: {
                                "zh-tw": "含稅",
                                en: "Taxed"
                            },
                            invoice_number: {
                                "zh-tw": "發票號碼",
                                en: "Invoice Number"
                            },
                            second_confirm: {
                                "zh-tw": "覆核",
                                en: "Second Confirm"
                            },
                            delivery_inventory: {
                                "zh-tw": "送貨倉",
                                en: "Delevery Inventory"
                            },
                            tax_category: {
                                "zh-tw": "課稅類別",
                                en: "Tax Category"
                            },
                            original_currency_price: {
                                "zh-tw": "原幣金額",
                                en: "Original Currency Price"
                            },
                            original_currency_tax: {
                                "zh-tw": "原幣稅金",
                                en: "Orinal Currency Tax"
                            },
                            original_currency_total_price: {
                                "zh-tw": "原幣合計",
                                en: "Orignal Currency Total Price"
                            },
                            local_currency_price: {
                                "zh-tw": "本幣金額",
                                en: "Local Currency Price"
                            },
                            local_currency_tax: {
                                "zh-tw": "本幣稅額",
                                en: "Local Currency Tax"
                            },
                            local_currency_total_price: {
                                "zh-tw": "本幣合計",
                                en: "Local Currency Total Price"
                            },
                            paid_price: {
                                "zh-tw": "已付金額",
                                en: "Paid Price"
                            },
                            local_currency_paid: {
                                "zh-tw": "本幣已付",
                                en: "Local Cuurency Paid"
                            },
                        }
                    },
                    work_in_process_outsourcing_debit: {
                        "zh-tw": "委外加工扣款憑單",
                        en: "Work In Process Outsourcing Debit Order",
                        children: {
                            /* Basic functional setting */
                            add_staff: {
                                'zh-tw': '新增BOM',
                                en: 'Add Staff'
                            },
                            go_back: {
                                "zh-tw": "返回",
                                en: "Go Back"
                            },
                            print: {
                                'zh-tw': '列印',
                                en: 'Print'
                            },
                            export: {
                                'zh-tw': '匯出資料',
                                en: 'Export Data'
                            },
                            import: {
                                'zh-tw': '匯入資料',
                                en: 'Import Data',
                                children: {
                                    sample: {
                                        'zh-tw': '下載範例',
                                        en: 'Download Sample'
                                    },
                                    upload: {
                                        'zh-tw': '上傳Excel檔案',
                                        en: 'Upload Excel File'
                                    },
                                    preview: {
                                        'zh-tw': '預覽檔案',
                                        en: 'Preview File'
                                    },
                                    finish: {
                                        'zh-tw': '確認匯入',
                                        en: 'Confirm'
                                    },
                                    close: {
                                        'zh-tw': '關閉',
                                        en: 'Close'
                                    },
                                }
                            },
                            edit: {
                                'zh-tw': '資料編輯',
                                en: 'Edit Data'
                            },
                            copy: {
                                'zh-tw': '資料複製',
                                en: 'Copy Data'
                            },
                            delete: {
                                'zh-tw': '資料刪除',
                                en: 'Delete Data'
                            },
                            table_column_operation: {
                                'zh-tw': '操作',
                                en: 'Functions'
                            },
                            button_edit_permission_title: {
                                'zh-tw': '修改人員權限',
                                en: 'Edit Permission'
                            },
                            button_edit_permission_subtitle: {
                                'zh-tw': '您正在修改{X} {Y}的權限',
                                en: 'You are modifying permissions for {X} {Y}'
                            },
                            /* Basic functional setting */
                            product_number: {
                                "zh-tw": "產品編號",
                                en: "Product Number"
                            },
                            product_name: {
                                "zh-tw": "產品名稱",
                                en: "Product Name"
                            },
                            quantity: {
                                "zh-tw": "數量",
                                en: "Quantity"
                            },
                            start_date: {
                                "zh-tw": "開始日期",
                                en: "Start Date"
                            },
                            end_date: {
                                "zh-tw": "結束日期",
                                en: "End Date"
                            },
                            process_cost: {
                                "zh-tw": "加工費用",
                                en: "Process Cost"
                            },
                            manage_cost: {
                                "zh-tw": "管理費用",
                                en: "Manage Cost"
                            },
                            mold_cost: {
                                "zh-tw": "模具費用",
                                en: "Mold Cost"
                            },
                            prepare_cost: {
                                "zh-tw": "準備成本",
                                en: "Prepare Cost"
                            },
                            else: {
                                "zh-tw": "其他",
                                en: "Else"
                            }
                        }
                    },
                    return_goods: {
                        "zh-tw": "委外退貨單",
                        en: "Return Goods Order",
                        children: {
                            /* Basic functional setting */
                            add_staff: {
                                'zh-tw': '新增BOM',
                                en: 'Add Staff'
                            },
                            go_back: {
                                "zh-tw": "返回",
                                en: "Go Back"
                            },
                            print: {
                                'zh-tw': '列印',
                                en: 'Print'
                            },
                            export: {
                                'zh-tw': '匯出資料',
                                en: 'Export Data'
                            },
                            import: {
                                'zh-tw': '匯入資料',
                                en: 'Import Data',
                                children: {
                                    sample: {
                                        'zh-tw': '下載範例',
                                        en: 'Download Sample'
                                    },
                                    upload: {
                                        'zh-tw': '上傳Excel檔案',
                                        en: 'Upload Excel File'
                                    },
                                    preview: {
                                        'zh-tw': '預覽檔案',
                                        en: 'Preview File'
                                    },
                                    finish: {
                                        'zh-tw': '確認匯入',
                                        en: 'Confirm'
                                    },
                                    close: {
                                        'zh-tw': '關閉',
                                        en: 'Close'
                                    },
                                }
                            },
                            edit: {
                                'zh-tw': '資料編輯',
                                en: 'Edit Data'
                            },
                            copy: {
                                'zh-tw': '資料複製',
                                en: 'Copy Data'
                            },
                            delete: {
                                'zh-tw': '資料刪除',
                                en: 'Delete Data'
                            },
                            table_column_operation: {
                                'zh-tw': '操作',
                                en: 'Functions'
                            },
                            button_edit_permission_title: {
                                'zh-tw': '修改人員權限',
                                en: 'Edit Permission'
                            },
                            button_edit_permission_subtitle: {
                                'zh-tw': '您正在修改{X} {Y}的權限',
                                en: 'You are modifying permissions for {X} {Y}'
                            },
                            /* Basic functional setting */
                            order_date: {
                                "zh-tw": "帳單日期",
                                en: "Order Date"
                            },
                            order_number: {
                                "zh-tw": "單據號碼",
                                en: "Order Number"
                            },
                            work_order_number: {
                                "zh-tw": "製令單號",
                                en: "Work Order Number"
                            },
                            product_name: {
                                "zh-tw": "產品名稱",
                                en: "Product Name"
                            },
                            quantity: {
                                "zh-tw": "數量",
                                en: "Quantity"
                            },
                            unit: {
                                "zh-tw": "單位",
                                en: "Unit"
                            },
                            company: {
                                "zh-tw": "委外廠商",
                                en: "Outsourcing Company"
                            },
                            address: {
                                "zh-tw": "單據地址",
                                en: "Order Address"
                            },
                            currency: {
                                "zh-tw": "幣別",
                                en: "Currency"
                            },
                            contact_person: {
                                "zh-tw": "聯絡人員",
                                en: "Contact Person"
                            },
                            contact_phone: {
                                "zh-tw": "聯絡電話",
                                en: "Contact Phone"
                            },
                            product_price: {
                                "zh-tw": "產品單價",
                                en: "Product Price"
                            },
                            untaxed: {
                                "zh-tw": "未稅",
                                en: "Untaxed"
                            },
                            taxed: {
                                "zh-tw": "含稅",
                                en: "Taxed"
                            },
                            invoice_number: {
                                "zh-tw": "發票號碼",
                                en: "Invoice Number"
                            },
                            second_confirm: {
                                "zh-tw": "覆核",
                                en: "Second Confirm"
                            },
                            return_inventory: {
                                "zh-tw": "退貨倉",
                                en: "Return Inventory"
                            },
                            tax_category: {
                                "zh-tw": "課稅類別",
                                en: "Tax Category"
                            },
                            original_currency_price: {
                                "zh-tw": "原幣金額",
                                en: "Original Currency Price"
                            },
                            original_currency_tax: {
                                "zh-tw": "原幣稅金",
                                en: "Orinal Currency Tax"
                            },
                            original_currency_total_price: {
                                "zh-tw": "原幣合計",
                                en: "Orignal Currency Total Price"
                            },
                            local_currency_price: {
                                "zh-tw": "本幣金額",
                                en: "Local Currency Price"
                            },
                            local_currency_tax: {
                                "zh-tw": "本幣稅額",
                                en: "Local Currency Tax"
                            },
                            local_currency_total_price: {
                                "zh-tw": "本幣合計",
                                en: "Local Currency Total Price"
                            },
                            paid_price: {
                                "zh-tw": "已付金額",
                                en: "Paid Price"
                            },
                            local_currency_paid: {
                                "zh-tw": "本幣已付",
                                en: "Local Cuurency Paid"
                            },
                        }
                    },
                    over_collection: {
                        "zh-tw": "委外超送單",
                        en: "Outsourcing Over-Collection Order",
                        children: {
                            /* Basic functional setting */
                            add_staff: {
                                'zh-tw': '新增BOM',
                                en: 'Add Staff'
                            },
                            go_back: {
                                "zh-tw": "返回",
                                en: "Go Back"
                            },
                            print: {
                                'zh-tw': '列印',
                                en: 'Print'
                            },
                            export: {
                                'zh-tw': '匯出資料',
                                en: 'Export Data'
                            },
                            import: {
                                'zh-tw': '匯入資料',
                                en: 'Import Data',
                                children: {
                                    sample: {
                                        'zh-tw': '下載範例',
                                        en: 'Download Sample'
                                    },
                                    upload: {
                                        'zh-tw': '上傳Excel檔案',
                                        en: 'Upload Excel File'
                                    },
                                    preview: {
                                        'zh-tw': '預覽檔案',
                                        en: 'Preview File'
                                    },
                                    finish: {
                                        'zh-tw': '確認匯入',
                                        en: 'Confirm'
                                    },
                                    close: {
                                        'zh-tw': '關閉',
                                        en: 'Close'
                                    },
                                }
                            },
                            edit: {
                                'zh-tw': '資料編輯',
                                en: 'Edit Data'
                            },
                            copy: {
                                'zh-tw': '資料複製',
                                en: 'Copy Data'
                            },
                            delete: {
                                'zh-tw': '資料刪除',
                                en: 'Delete Data'
                            },
                            table_column_operation: {
                                'zh-tw': '操作',
                                en: 'Functions'
                            },
                            button_edit_permission_title: {
                                'zh-tw': '修改人員權限',
                                en: 'Edit Permission'
                            },
                            button_edit_permission_subtitle: {
                                'zh-tw': '您正在修改{X} {Y}的權限',
                                en: 'You are modifying permissions for {X} {Y}'
                            },
                            /* Basic functional setting */
                            order_date: {
                                "zh-tw": "單據日期",
                                en: "Order Date"
                            },
                            responsible_person: {
                                "zh-tw": "製單人員",
                                en: "Responsible Person"
                            },
                            second_confirm: {
                                "zh-tw": "覆核",
                                en: "Second Confirm"
                            },
                            pick_up_date: {
                                "zh-tw": "領取日期",
                                en: "Pick Up Date"
                            },
                            company: {
                                "zh-tw": "委外廠商",
                                en: "Outsourcing Company"
                            },
                            company_address: {
                                "zh-tw": "廠商地址",
                                en: "Company Address"
                            },
                            inventory: {
                                "zh-tw": "倉庫",
                                en: "Inventory"
                            },
                            work_order_category: {
                                "zh-tw": "製令類別",
                                en: "Work Order Category"
                            },
                            work_order_number: {
                                "zh-tw": "製令單號",
                                en: "Work Order Number"
                            },
                            parent_material_number: {
                                "zh-tw": "母件編號",
                                en: "Parent Material Number"
                            },
                            expand_table_column_serial: {
                                "zh-tw": "序號",
                                en: "Serial"
                            },
                            expand_table_column_material_number: {
                                "zh-tw": "材料品號",
                                en: "Material Number"
                            },
                            expand_table_column_material_name: {
                                "zh-tw": "品名",
                                en: "Material Name"
                            },
                            expand_table_column_specification: {
                                "zh-tw": "規格",
                                en: "Specification"
                            },
                            expand_table_column_need_supply_quantity: {
                                "zh-tw": "需送料量",
                                en: "The Quantity Needed To Be Supplied"
                            },
                            expand_table_column_not_supply_quantity: {
                                "zh-tw": "未送料量",
                                en: "The Quantity Wasn't Be Supplied Yet"
                            },
                            expand_table_column_has_supply_quantity: {
                                "zh-tw": "已送料量",
                                en: "The Quantity Has Been Supplied"
                            },
                            expand_table_column_unit: {
                                "zh-tw": "單位",
                                en: "Unit"
                            },
                            expand_table_column_supply_inventory: {
                                "zh-tw": "送料倉",
                                en: "Supply Inventory"
                            },

                        }
                    },
                    /* Basic functional setting */
                    functional_setting: {
                        "zh-tw": "基礎功能",
                        children: {
                            /* Basic functional setting */
                            add_staff: {
                                'zh-tw': '新增BOM',
                                en: 'Add Staff'
                            },
                            go_back: {
                                "zh-tw": "返回",
                                en: "Go Back"
                            },
                            print: {
                                'zh-tw': '列印',
                                en: 'Print'
                            },
                            export: {
                                'zh-tw': '匯出資料',
                                en: 'Export Data'
                            },
                            import: {
                                'zh-tw': '匯入資料',
                                en: 'Import Data',
                                children: {
                                    sample: {
                                        'zh-tw': '下載範例',
                                        en: 'Download Sample'
                                    },
                                    upload: {
                                        'zh-tw': '上傳Excel檔案',
                                        en: 'Upload Excel File'
                                    },
                                    preview: {
                                        'zh-tw': '預覽檔案',
                                        en: 'Preview File'
                                    },
                                    finish: {
                                        'zh-tw': '確認匯入',
                                        en: 'Confirm'
                                    },
                                    close: {
                                        'zh-tw': '關閉',
                                        en: 'Close'
                                    },
                                }
                            },
                            edit: {
                                'zh-tw': '資料編輯',
                                en: 'Edit Data'
                            },
                            copy: {
                                'zh-tw': '資料複製',
                                en: 'Copy Data'
                            },
                            delete: {
                                'zh-tw': '資料刪除',
                                en: 'Delete Data'
                            },
                            table_column_operation: {
                                'zh-tw': '操作',
                                en: 'Functions'
                            },
                            button_edit_permission_title: {
                                'zh-tw': '修改人員權限',
                                en: 'Edit Permission'
                            },
                            button_edit_permission_subtitle: {
                                'zh-tw': '您正在修改{X} {Y}的權限',
                                en: 'You are modifying permissions for {X} {Y}'
                            },
                        }
                    }
                    /* Basic functional setting */
                },
            },
            materials_transfer: {
                'zh-tw': '料件請領移轉模組',
                en: '',
                children: {
                    "materials_transfer_order": {
                        'zh-tw': '料件移轉單',
                        en: 'materials_transfer_order',
                        children: {
                            "materials_transfer_order": {
                                'zh-tw': '料件移轉單',
                                en: 'materials_transfer_order'
                            },
                            "editing": {
                                'zh-tw': '編輯',
                                en: 'Edit',
                            },
                            "create": {
                                'zh-tw': '新增',
                                en: 'create',
                            },
                            "read": {
                                'zh-tw': '瀏覽',
                                en: 'read',
                            },
                            "edit": {
                                'zh-tw': '資料編輯',
                                en: 'Edit',
                            },
                            "copy": {
                                'zh-tw': '資料複製',
                                en: 'Copy',
                            },
                            "delete": {
                                'zh-tw': '資料刪除',
                                en: 'Delete',
                            },
                            "operate": {
                                'zh-tw': '操作',
                                en: 'Operate',
                            },
                            "transfer_date": {
                                'zh-tw': '移轉日期',
                                en: 'transfer date',
                            },
                            "processing_order_number": {
                                'zh-tw': '加工單號',
                                en: 'Processing order number',
                            },
                            "transfer_order_number": {
                                'zh-tw': '移轉單號',
                                en: 'transfer order number',
                            },
                            "completed_quantity": {
                                'zh-tw': '完成數量',
                                en: 'completed quantity',
                            },
                            "completed_weight": {
                                'zh-tw': '完成重量',
                                en: 'completed weight',
                            },
                            "scrapped_quantity": {
                                'zh-tw': '報廢數量',
                                en: 'scrapped quantity',
                            },
                            "inspection_return_quantity": {
                                'zh-tw': '驗退數量',
                                en: 'inspection return quantity',
                            },
                            "responsible_person": {
                                'zh-tw': '負責人員',
                                en: 'responsible person',
                            },
                            "making_order_number": {
                                'zh-tw': '製令單號',
                                en: 'making order number',
                            },
                            "product_number": {
                                'zh-tw': '產品編號',
                                en: 'product number',
                            },
                            "product_name": {
                                'zh-tw': '產品名稱',
                                en: 'product name',
                            },
                            "remove_process": {
                                'zh-tw': '移出製程',
                                en: 'remove process',
                            },
                            "into_process": {
                                'zh-tw': '移入製程',
                                en: 'into process',
                            },
                            "into_production_unit": {
                                'zh-tw': '移入生產單位',
                                en: 'into production unit',
                            },
                            "remove_production_unit": {
                                'zh-tw': '移出生產單位',
                                en: 'remove production unit',
                            },
                            "production_unit": {
                                'zh-tw': '生產單位',
                                en: 'production unit',
                            },
                            "production_category": {
                                'zh-tw': '生產類別',
                                en: 'production category',
                            },
                            "product_specifications": {
                                'zh-tw': '產品規格',
                                en: 'product specifications',
                            },
                            "production_quantity": {
                                'zh-tw': '生產數量',
                                en: 'production quantity',
                            },
                            "order_maker": {
                                'zh-tw': '製單人員',
                                en: 'order maker',
                            },
                            "unit_weight": {
                                'zh-tw': '單位重',
                                en: 'unit weight',
                            },
                            "transfer_category": {
                                'zh-tw': '移轉類別',
                                en: 'Transfer category',
                            },
                            "transfer_weight": {
                                'zh-tw': '移轉重量',
                                en: 'transfer weight',
                            },
                            "transfer_quantity": {
                                'zh-tw': '移轉數量',
                                en: 'transfer quantity',
                            },
                        },
                    },
                    "materials_requisition": {
                        'zh-tw': '材料請領單',
                        en: 'materials requisition',
                        children: {
                            "materials_requisition": {
                                'zh-tw': '材料請領單',
                                en: 'materials requisition'
                            },
                            "inplant_picking_list": {
                                'zh-tw': '廠內領料單',
                                en: 'In-plant picking list',
                            },
                            "editing": {
                                'zh-tw': '編輯',
                                en: 'Edit',
                            },
                            "create": {
                                'zh-tw': '新增',
                                en: 'create',
                            },
                            "read": {
                                'zh-tw': '瀏覽',
                                en: 'read',
                            },
                            "edit": {
                                'zh-tw': '資料編輯',
                                en: 'Edit',
                            },
                            "copy": {
                                'zh-tw': '資料複製',
                                en: 'Copy',
                            },
                            "delete": {
                                'zh-tw': '資料刪除',
                                en: 'Delete',
                            },
                            "operate": {
                                'zh-tw': '操作',
                                en: 'Operate',
                            },
                            "pick_up_date": {
                                'zh-tw': '領取日期',
                                en: 'Pick up date',
                            },
                            "invoice_requisition_number": {
                                'zh-tw': '請領單號',
                                en: 'invoice_requisition_number',
                            },
                            "creation_date": {
                                'zh-tw': '建立日期',
                                en: 'Creation date',
                            },
                            "subpoena_number": {
                                'zh-tw': '傳票編號',
                                en: 'Subpoena number',
                            },
                            "picking_sets": {
                                'zh-tw': '領料套數',
                                en: 'Picking sets',
                            },
                            "picker": {
                                'zh-tw': '領料人員',
                                en: 'Picker',
                            },
                            "picking_department": {
                                'zh-tw': '領料部門',
                                en: 'Picking department',
                            },
                            "order_maker": {
                                'zh-tw': '製單人員',
                                en: 'Order maker',
                            },
                            "reviewer": {
                                'zh-tw': '覆核人員',
                                en: 'Reviewer',
                            },
                            "requisition_category": {
                                'zh-tw': '請領類別',
                                en: 'requisition category',
                            },
                            "picking_category": {
                                'zh-tw': '領料類別',
                                en: 'Picking category',
                            },
                            "order_picking": {
                                'zh-tw': '製令領料',
                                en: 'order_picking',
                            },
                            "out_of_material_picking": {
                                'zh-tw': '缺料領料',
                                en: 'Out of material picking',
                            },
                            "rework_picking": {
                                'zh-tw': '重工領料',
                                en: 'Rework picking',
                            },
                            "loss_picking": {
                                'zh-tw': '製損領料',
                                en: 'Loss Picking',
                            },
                            "other": {
                                'zh-tw': '其他',
                                en: 'Other',
                            },
                            "order_category": {
                                'zh-tw': '製令類別',
                                en: 'Order category',
                            },
                            "order_number": {
                                'zh-tw': '製令單號',
                                en: 'Order number',
                            },
                            "order_date": {
                                'zh-tw': '製令日期',
                                en: 'Order date',
                            },
                            "master_part_number": {
                                'zh-tw': '母件編號',
                                en: 'Master part number',
                            },
                            "product_name": {
                                'zh-tw': '品名',
                                en: 'Product name',
                            },
                            "specification": {
                                'zh-tw': '規格',
                                en: 'Specification',
                            },
                            "production_volume": {
                                'zh-tw': '生產數量',
                                en: 'Production volume',
                            },
                            "production_unit": {
                                'zh-tw': '生產單位',
                                en: 'Production unit',
                            },

                            "serial_number": {
                                'zh-tw': '序號',
                                en: 'NO.',
                            },
                            "material_type": {
                                'zh-tw': '料件型態',
                                en: 'material_type',
                            },
                            "component_number": {
                                'zh-tw': '子件編號',
                                en: 'component number',
                            },
                            "product_number": {
                                'zh-tw': '品號',
                                en: 'Product number',
                            },
                            "product_name": {
                                'zh-tw': '品名',
                                en: 'Product name',
                            },
                            "pick_up_quantity": {
                                'zh-tw': '領料數量',
                                en: 'Pick up quantity',
                            },
                            "requisition_quantity": {
                                'zh-tw': '需領料量',
                                en: 'Requisition quantity',
                            },
                            "unclaimed_quantity": {
                                'zh-tw': '未領料量',
                                en: 'Unclaimed quantity',
                            },
                            "calculation_unit": {
                                'zh-tw': '計算單位',
                                en: 'Calculation unit',
                            },
                            "warehouse": {
                                'zh-tw': '倉庫',
                                en: 'Warehouse',
                            },
                            "approval_status": {
                                'zh-tw': '審核狀態',
                                en: 'approval_status',
                            },
                        },
                    },
                    "picking_list": {
                        'zh-tw': '批次領料單',
                        en: 'In-plant picking list',
                        children: {
                            "picking_list": {
                                'zh-tw': '批次領料單',
                                en: 'In-plant picking list',
                            },
                            "editing": {
                                'zh-tw': '編輯',
                                en: 'Edit',
                            },
                            "create": {
                                'zh-tw': '新增',
                                en: 'create',
                            },
                            "read": {
                                'zh-tw': '瀏覽',
                                en: 'read',
                            },
                            "edit": {
                                'zh-tw': '資料編輯',
                                en: 'Edit',
                            },
                            "copy": {
                                'zh-tw': '資料複製',
                                en: 'Copy',
                            },
                            "delete": {
                                'zh-tw': '資料刪除',
                                en: 'Delete',
                            },
                            "operate": {
                                'zh-tw': '操作',
                                en: 'Operate',
                            },
                            "pick_up_date": {
                                'zh-tw': '領取日期',
                                en: 'Pick up date',
                            },
                            "picking_order_number": {
                                'zh-tw': '領料單號',
                                en: 'Picking order number',
                            },
                            "creation_date": {
                                'zh-tw': '建立日期',
                                en: 'Creation date',
                            },
                            "subpoena_number": {
                                'zh-tw': '傳票編號',
                                en: 'Subpoena number',
                            },
                            "picking_sets": {
                                'zh-tw': '領料套數',
                                en: 'Picking sets',
                            },
                            "picker": {
                                'zh-tw': '領料人員',
                                en: 'Picker',
                            },
                            "picking_department": {
                                'zh-tw': '領料部門',
                                en: 'Picking department',
                            },
                            "order_maker": {
                                'zh-tw': '製單人員',
                                en: 'Order maker',
                            },
                            "reviewer": {
                                'zh-tw': '覆核人員',
                                en: 'Reviewer',
                            },

                            "picking_category": {
                                'zh-tw': '領料類別',
                                en: 'Picking category',
                            },
                            "order_picking": {
                                'zh-tw': '製令領料',
                                en: 'order_picking',
                            },
                            "out_of_material_picking": {
                                'zh-tw': '缺料領料',
                                en: 'Out of material picking',
                            },
                            "rework_picking": {
                                'zh-tw': '重工領料',
                                en: 'Rework picking',
                            },
                            "loss_picking": {
                                'zh-tw': '製損領料',
                                en: 'Loss Picking',
                            },
                            "other": {
                                'zh-tw': '其他',
                                en: 'Other',
                            },
                            "order_category": {
                                'zh-tw': '製令類別',
                                en: 'Order category',
                            },
                            "order_number": {
                                'zh-tw': '製令單號',
                                en: 'Order number',
                            },
                            "order_date": {
                                'zh-tw': '製令日期',
                                en: 'Order date',
                            },
                            "master_part_number": {
                                'zh-tw': '母件編號',
                                en: 'Master part number',
                            },
                            "product_name": {
                                'zh-tw': '品名',
                                en: 'Product name',
                            },
                            "specification": {
                                'zh-tw': '規格',
                                en: 'Specification',
                            },
                            "production_volume": {
                                'zh-tw': '生產數量',
                                en: 'Production volume',
                            },
                            "production_unit": {
                                'zh-tw': '生產單位',
                                en: 'Production unit',
                            },

                            "serial_number": {
                                'zh-tw': '序號',
                                en: 'NO.',
                            },
                            "material_type": {
                                'zh-tw': '料件型態',
                                en: 'material_type',
                            },
                            "component_number": {
                                'zh-tw': '子件編號',
                                en: 'component number',
                            },
                            "product_number": {
                                'zh-tw': '品號',
                                en: 'Product number',
                            },
                            "product_name": {
                                'zh-tw': '品名',
                                en: 'Product name',
                            },
                            "pick_up_quantity": {
                                'zh-tw': '領料數量',
                                en: 'Pick up quantity',
                            },
                            "requisition_quantity": {
                                'zh-tw': '需領料量',
                                en: 'Requisition quantity',
                            },
                            "unclaimed_quantity": {
                                'zh-tw': '未領料量',
                                en: 'Unclaimed quantity',
                            },
                            "calculation_unit": {
                                'zh-tw': '計算單位',
                                en: 'Calculation unit',
                            },
                            "warehouse": {
                                'zh-tw': '倉庫',
                                en: 'Warehouse',
                            },

                        }
                    },
                    "inbound_order": {
                        'zh-tw': '批次入庫單',
                        en: 'inbound order',
                        children: {
                            "inbound_order": {
                                'zh-tw': '批次入庫單',
                                en: 'inbound order',
                            },
                            "editing": {
                                'zh-tw': '編輯',
                                en: 'Edit',
                            },
                            "create": {
                                'zh-tw': '新增',
                                en: 'create',
                            },
                            "read": {
                                'zh-tw': '瀏覽',
                                en: 'read',
                            },
                            "edit": {
                                'zh-tw': '資料編輯',
                                en: 'Edit',
                            },
                            "copy": {
                                'zh-tw': '資料複製',
                                en: 'Copy',
                            },
                            "delete": {
                                'zh-tw': '資料刪除',
                                en: 'Delete',
                            },
                            "operate": {
                                'zh-tw': '操作',
                                en: 'Operate',
                            },
                            "inplant_inbound_order": {
                                'zh-tw': '廠內生產入庫單',
                                en: 'Inplant inbound order',
                            },
                            "order_date": {
                                'zh-tw': '單據日期',
                                en: 'order_date',
                            },
                            "inbound_order_number": {
                                'zh-tw': '入庫單號',
                                en: 'Inbound order number',
                            },
                            "subpoena_number": {
                                'zh-tw': '傳票編號',
                                en: 'Subpoena number',
                            },
                            "responsible_person": {
                                'zh-tw': '負責人',
                                en: 'Responsible person',
                            },
                            "department": {
                                'zh-tw': '所屬部門',
                                en: 'Department',
                            },
                            "making_order": {
                                'zh-tw': '製令',
                                en: 'Making order',
                            },
                            "order_category": {
                                'zh-tw': '製令類別',
                                en: 'Order category',
                            },
                            "finished_state": {
                                'zh-tw': '完工狀態',
                                en: 'Finished state',
                            },
                            "making_order_number": {
                                'zh-tw': '製令單號',
                                en: 'Order number',
                            },
                            "makeing_order_date": {
                                'zh-tw': '製令日期',
                                en: 'Making order date',
                            },
                            "master_part_number": {
                                'zh-tw': '母件編號',
                                en: 'Master part number',
                            },
                            "master_part_name": {
                                'zh-tw': '母件名稱',
                                en: 'Master part name',
                            },
                            "specification": {
                                'zh-tw': '規格',
                                en: 'Specification',
                            },
                            "production_unit": {
                                'zh-tw': '生產單位',
                                en: 'Production unit',
                            },
                            "production_volume": {
                                'zh-tw': '生產數量',
                                en: 'Production volume',
                            },
                            "volume_unit": {
                                'zh-tw': '數量單位',
                                en: 'Volume unit',
                            },
                            "standard_batch_working_hours": {
                                'zh-tw': '標準批量工時',
                                en: 'Standard batch working hours',
                            },
                            "standard_inbound_hours": {
                                'zh-tw': '標準入庫工時',
                                en: 'Standard inbound hours',
                            },
                            "actual_production_working_hours": {
                                'zh-tw': '實際生產工時',
                                en: 'Actual production working hours',
                            },
                            "goods_storage": {
                                'zh-tw': '良品入庫',
                                en: 'Goods storage',
                            },
                            "bad_storage": {
                                'zh-tw': '不良品入庫',
                                en: 'Defective product storage',
                            },
                            "storage_cost": {
                                'zh-tw': '入庫成本',
                                en: 'Storage cost',
                            },
                            "inspection_reports": {
                                'zh-tw': '驗貨報告',
                                en: 'Inspection reports',
                            },
                            "inbound_category": {
                                'zh-tw': '入庫類別',
                                en: 'Inbound category',
                            },
                            "inbound_quantity": {
                                'zh-tw': '入庫數量',
                                en: 'Inbound quantity',
                            },
                            "inbound_weight": {
                                'zh-tw': '入庫重量',
                                en: 'Inbound weight',
                            },
                            "shipping_date": {
                                'zh-tw': '出廠日期',
                                en: 'Shipping date',
                            },
                            "making_order_date": {
                                'zh-tw': '製令日期',
                                en: 'making order date',
                            },
                            "order_maker": {
                                'zh-tw': '製單人員',
                                en: 'order maker',
                            },
                            "master_unit_cost": {
                                'zh-tw': '母件單一成本',
                                en: 'master unit cost',
                            },
                            "total_storage_cost": {
                                'zh-tw': '入庫總成本',
                                en: 'Total storage cost',
                            },
                            "labor_cost": {
                                'zh-tw': '人工成本',
                                en: 'Labor cost',
                            },
                            "processing_cost": {
                                'zh-tw': '加工費用',
                                en: 'processing cost',
                            },
                            "manufacturing_costs": {
                                'zh-tw': '製造費用',
                                en: 'Manufacturing costs',
                            },
                            "material_costs": {
                                'zh-tw': '材料費用',
                                en: 'Material costs',
                            },
                        }
                    },
                    "materials_requisition_check": {
                        'zh-tw': '請領審核',
                        en: 'materials requisition check',
                        children: {

                            "materials_requisition_check": {
                                'zh-tw': '請領審核',
                                en: 'materials requisition'
                            },
                            "details": {
                                'zh-tw': '詳細資料',
                                en: 'details',
                            },
                            "cancel": {
                                'zh-tw': '取消',
                                en: 'cancel',
                            },
                            "approved": {
                                'zh-tw': '審核通過',
                                en: 'Approved',
                            },
                            "editing": {
                                'zh-tw': '編輯',
                                en: 'Edit',
                            },
                            "create": {
                                'zh-tw': '新增',
                                en: 'create',
                            },
                            "read": {
                                'zh-tw': '瀏覽',
                                en: 'read',
                            },
                            "approval_failed": {
                                'zh-tw': '審核不通過',
                                en: 'Approval failed',
                            },
                            "copy": {
                                'zh-tw': '資料複製',
                                en: 'Copy',
                            },
                            "delete": {
                                'zh-tw': '資料刪除',
                                en: 'Delete',
                            },
                            "operate": {
                                'zh-tw': '操作',
                                en: 'Operate',
                            },
                            "pick_up_date": {
                                'zh-tw': '領取日期',
                                en: 'Pick up date',
                            },
                            "invoice_requisition_number": {
                                'zh-tw': '請領單號',
                                en: 'invoice_requisition_number',
                            },
                            "creation_date": {
                                'zh-tw': '建立日期',
                                en: 'Creation date',
                            },
                            "subpoena_number": {
                                'zh-tw': '傳票編號',
                                en: 'Subpoena number',
                            },
                            "picking_sets": {
                                'zh-tw': '領料套數',
                                en: 'Picking sets',
                            },
                            "picker": {
                                'zh-tw': '領料人員',
                                en: 'Picker',
                            },
                            "picking_department": {
                                'zh-tw': '領料部門',
                                en: 'Picking department',
                            },
                            "order_maker": {
                                'zh-tw': '製單人員',
                                en: 'Order maker',
                            },
                            "reviewer": {
                                'zh-tw': '覆核人員',
                                en: 'Reviewer',
                            },
                            "requisition_category": {
                                'zh-tw': '請領類別',
                                en: 'requisition category',
                            },
                            "picking_category": {
                                'zh-tw': '領料類別',
                                en: 'Picking category',
                            },
                            "order_picking": {
                                'zh-tw': '製令領料',
                                en: 'order_picking',
                            },
                            "out_of_material_picking": {
                                'zh-tw': '缺料領料',
                                en: 'Out of material picking',
                            },
                            "rework_picking": {
                                'zh-tw': '重工領料',
                                en: 'Rework picking',
                            },
                            "loss_picking": {
                                'zh-tw': '製損領料',
                                en: 'Loss Picking',
                            },
                            "other": {
                                'zh-tw': '其他',
                                en: 'Other',
                            },
                            "order_category": {
                                'zh-tw': '製令類別',
                                en: 'Order category',
                            },
                            "order_number": {
                                'zh-tw': '製令單號',
                                en: 'Order number',
                            },
                            "order_date": {
                                'zh-tw': '製令日期',
                                en: 'Order date',
                            },
                            "master_part_number": {
                                'zh-tw': '母件編號',
                                en: 'Master part number',
                            },
                            "product_name": {
                                'zh-tw': '品名',
                                en: 'Product name',
                            },
                            "specification": {
                                'zh-tw': '規格',
                                en: 'Specification',
                            },
                            "production_volume": {
                                'zh-tw': '生產數量',
                                en: 'Production volume',
                            },
                            "production_unit": {
                                'zh-tw': '生產單位',
                                en: 'Production unit',
                            },

                            "serial_number": {
                                'zh-tw': '序號',
                                en: 'NO.',
                            },
                            "material_type": {
                                'zh-tw': '料件型態',
                                en: 'material_type',
                            },
                            "component_number": {
                                'zh-tw': '子件編號',
                                en: 'component number',
                            },
                            "product_number": {
                                'zh-tw': '品號',
                                en: 'Product number',
                            },
                            "product_name": {
                                'zh-tw': '品名',
                                en: 'Product name',
                            },
                            "pick_up_quantity": {
                                'zh-tw': '領料數量',
                                en: 'Pick up quantity',
                            },
                            "requisition_quantity": {
                                'zh-tw': '需領料量',
                                en: 'Requisition quantity',
                            },
                            "unclaimed_quantity": {
                                'zh-tw': '未領料量',
                                en: 'Unclaimed quantity',
                            },
                            "calculation_unit": {
                                'zh-tw': '計算單位',
                                en: 'Calculation unit',
                            },
                            "warehouse": {
                                'zh-tw': '倉庫',
                                en: 'Warehouse',
                            },
                            "approval_status": {
                                'zh-tw': '審核狀態',
                                en: 'approval_status',
                            },
                        },
                    },
                    "merge_picking_list": {
                        'zh-tw': '廠內合併領料單',
                        en: 'merge picking list',
                        children: {
                            "merge_picking_list": {
                                'zh-tw': '廠內合併領料單',
                                en: 'merge picking list',
                            },
                            "merge_picking_list_number": {
                                'zh-tw': '合併領料單號',
                                en: 'merge picking list number',
                            },
                            "materials_requisition_check": {
                                'zh-tw': '請領審核',
                                en: 'materials requisition'
                            },
                            "details": {
                                'zh-tw': '詳細資料',
                                en: 'details',
                            },
                            "cancel": {
                                'zh-tw': '取消',
                                en: 'cancel',
                            },
                            "close": {
                                'zh-tw': '關閉',
                                en: 'close',
                            },
                            "approved": {
                                'zh-tw': '審核通過',
                                en: 'Approved',
                            },
                            "editing": {
                                'zh-tw': '編輯',
                                en: 'Edit',
                            },
                            "create": {
                                'zh-tw': '新增',
                                en: 'create',
                            },
                            "read": {
                                'zh-tw': '瀏覽',
                                en: 'read',
                            },
                            "approval_failed": {
                                'zh-tw': '審核不通過',
                                en: 'Approval failed',
                            },
                            "copy": {
                                'zh-tw': '資料複製',
                                en: 'Copy',
                            },
                            "delete": {
                                'zh-tw': '資料刪除',
                                en: 'Delete',
                            },
                            "operate": {
                                'zh-tw': '操作',
                                en: 'Operate',
                            },
                            "pick_up_date": {
                                'zh-tw': '領取日期',
                                en: 'Pick up date',
                            },
                            "picking_order_number": {
                                'zh-tw': '領料單號',
                                en: 'Picking order number',
                            },
                            "material_preparation_status": {
                                'zh-tw': '備料狀態',
                                en: 'Material preparation status',
                            },
                            "receiving_unit": {
                                'zh-tw': '領取單位',
                                en: 'receiving unit',
                            },
                            "invoice_requisition_number": {
                                'zh-tw': '請領單號',
                                en: 'invoice_requisition_number',
                            },
                            "creation_date": {
                                'zh-tw': '建立日期',
                                en: 'Creation date',
                            },
                            "subpoena_number": {
                                'zh-tw': '傳票編號',
                                en: 'Subpoena number',
                            },
                            "picking_sets": {
                                'zh-tw': '領料套數',
                                en: 'Picking sets',
                            },
                            "picker": {
                                'zh-tw': '領料人員',
                                en: 'Picker',
                            },
                            "picking_department": {
                                'zh-tw': '領料部門',
                                en: 'Picking department',
                            },
                            "order_maker": {
                                'zh-tw': '製單人員',
                                en: 'Order maker',
                            },
                            "reviewer": {
                                'zh-tw': '覆核人員',
                                en: 'Reviewer',
                            },
                            "requisition_category": {
                                'zh-tw': '請領類別',
                                en: 'requisition category',
                            },
                            "picking_category": {
                                'zh-tw': '領料類別',
                                en: 'Picking category',
                            },
                            "order_picking": {
                                'zh-tw': '製令領料',
                                en: 'order_picking',
                            },
                            "out_of_material_picking": {
                                'zh-tw': '缺料領料',
                                en: 'Out of material picking',
                            },
                            "rework_picking": {
                                'zh-tw': '重工領料',
                                en: 'Rework picking',
                            },
                            "loss_picking": {
                                'zh-tw': '製損領料',
                                en: 'Loss Picking',
                            },
                            "other": {
                                'zh-tw': '其他',
                                en: 'Other',
                            },
                            "order_category": {
                                'zh-tw': '製令類別',
                                en: 'Order category',
                            },
                            "order_number": {
                                'zh-tw': '製令單號',
                                en: 'Order number',
                            },
                            "order_date": {
                                'zh-tw': '製令日期',
                                en: 'Order date',
                            },
                            "master_part_number": {
                                'zh-tw': '母件編號',
                                en: 'Master part number',
                            },
                            "product_name": {
                                'zh-tw': '品名',
                                en: 'Product name',
                            },
                            "specification": {
                                'zh-tw': '規格',
                                en: 'Specification',
                            },
                            "production_volume": {
                                'zh-tw': '生產數量',
                                en: 'Production volume',
                            },
                            "production_unit": {
                                'zh-tw': '生產單位',
                                en: 'Production unit',
                            },

                            "serial_number": {
                                'zh-tw': '序號',
                                en: 'NO.',
                            },
                            "material_type": {
                                'zh-tw': '料件型態',
                                en: 'material_type',
                            },
                            "component_number": {
                                'zh-tw': '子件編號',
                                en: 'component number',
                            },
                            "product_number": {
                                'zh-tw': '品號',
                                en: 'Product number',
                            },
                            "product_name": {
                                'zh-tw': '品名',
                                en: 'Product name',
                            },
                            "pick_up_quantity": {
                                'zh-tw': '領料數量',
                                en: 'Pick up quantity',
                            },
                            "requisition_quantity": {
                                'zh-tw': '需領料量',
                                en: 'Requisition quantity',
                            },
                            "unclaimed_quantity": {
                                'zh-tw': '未領料量',
                                en: 'Unclaimed quantity',
                            },
                            "calculation_unit": {
                                'zh-tw': '計算單位',
                                en: 'Calculation unit',
                            },
                            "warehouse": {
                                'zh-tw': '倉庫',
                                en: 'Warehouse',
                            },
                            "approval_status": {
                                'zh-tw': '審核狀態',
                                en: 'approval_status',
                            },
                            "merge_picking_list_order_number": {
                                'zh-tw': '合併領料單號',
                                en: 'Merge Picking List Order Number',
                            },

                        }

                    },
                    "merge_outsourcing_delivery_list": {
                        'zh-tw': '委外合併送料單',
                        en: 'merge outsourcing delivery list',
                        children: {
                            "merge_outsourcing_delivery_list": {
                                'zh-tw': '委外合併送料單',
                                en: 'merge outsourcing delivery list',
                            },
                            "details": {
                                'zh-tw': '詳細資料',
                                en: 'details',
                            },
                            "cancel": {
                                'zh-tw': '取消',
                                en: 'cancel',
                            },
                            "close": {
                                'zh-tw': '關閉',
                                en: 'close',
                            },
                            "operate": {
                                'zh-tw': '操作',
                                en: 'Operate',
                            },

                            "material_preparation_status": {
                                'zh-tw': '備料狀態',
                                en: 'Material preparation status',
                            },
                            "subpoena_number": {
                                'zh-tw': '傳票編號',
                                en: 'Subpoena number',
                            },
                            "picking_sets": {
                                'zh-tw': '領料套數',
                                en: 'Picking sets',
                            },
                            "picker": {
                                'zh-tw': '領料人員',
                                en: 'Picker',
                            },
                            "picking_department": {
                                'zh-tw': '領料部門',
                                en: 'Picking department',
                            },
                            "order_maker": {
                                'zh-tw': '製單人員',
                                en: 'Order maker',
                            },
                            "reviewer": {
                                'zh-tw': '覆核人員',
                                en: 'Reviewer',
                            },
                            "requisition_category": {
                                'zh-tw': '請領類別',
                                en: 'requisition category',
                            },
                            "picking_category": {
                                'zh-tw': '領料類別',
                                en: 'Picking category',
                            },
                            "order_picking": {
                                'zh-tw': '製令領料',
                                en: 'order_picking',
                            },
                            "out_of_material_picking": {
                                'zh-tw': '缺料領料',
                                en: 'Out of material picking',
                            },
                            "rework_picking": {
                                'zh-tw': '重工領料',
                                en: 'Rework picking',
                            },
                            "loss_picking": {
                                'zh-tw': '製損領料',
                                en: 'Loss Picking',
                            },
                            "other": {
                                'zh-tw': '其他',
                                en: 'Other',
                            },
                            "order_category": {
                                'zh-tw': '製令類別',
                                en: 'Order category',
                            },
                            "order_number": {
                                'zh-tw': '製令單號',
                                en: 'Order number',
                            },
                            "order_date": {
                                'zh-tw': '製令日期',
                                en: 'Order date',
                            },
                            "master_part_number": {
                                'zh-tw': '母件編號',
                                en: 'Master part number',
                            },
                            "product_name": {
                                'zh-tw': '品名',
                                en: 'Product name',
                            },
                            "specification": {
                                'zh-tw': '規格',
                                en: 'Specification',
                            },
                            "production_volume": {
                                'zh-tw': '生產數量',
                                en: 'Production volume',
                            },
                            "production_unit": {
                                'zh-tw': '生產單位',
                                en: 'Production unit',
                            },

                            "serial_number": {
                                'zh-tw': '序號',
                                en: 'NO.',
                            },
                            "material_type": {
                                'zh-tw': '料件型態',
                                en: 'material_type',
                            },
                            "component_number": {
                                'zh-tw': '子件編號',
                                en: 'component number',
                            },
                            "product_number": {
                                'zh-tw': '品號',
                                en: 'Product number',
                            },
                            "product_name": {
                                'zh-tw': '品名',
                                en: 'Product name',
                            },
                            "pick_up_quantity": {
                                'zh-tw': '領料數量',
                                en: 'Pick up quantity',
                            },
                            "requisition_quantity": {
                                'zh-tw': '需送料量',
                                en: 'Requisition quantity',
                            },
                            "unclaimed_quantity": {
                                'zh-tw': '未送料量',
                                en: 'Unclaimed quantity',
                            },
                            "calculation_unit": {
                                'zh-tw': '計算單位',
                                en: 'Calculation unit',
                            },
                            "warehouse": {
                                'zh-tw': '倉庫',
                                en: 'Warehouse',
                            },
                            "approval_status": {
                                'zh-tw': '審核狀態',
                                en: 'approval_status',
                            },
                            "manufacturer_address": {
                                'zh-tw': '廠商地址',
                                en: 'Manufacturer address',
                            },
                            "delivery_order_number": {
                                'zh-tw': '送料單號',
                                en: 'delivery order number',
                            },
                            "manufacturer_name": {
                                'zh-tw': '廠商名稱',
                                en: 'manufacturer name',
                            },
                            "delivery_date": {
                                'zh-tw': '送料日期',
                                en: 'delivery date',
                            },
                            "delivery_person": {
                                'zh-tw': '送料人',
                                en: 'delivery person',
                            },
                            "send_out_warehouse": {
                                'zh-tw': '發料倉',
                                en: 'send_out_warehouse',
                            },
                            "outsourcing_warehouse": {
                                'zh-tw': '委外倉',
                                en: 'Outsourcing warehouse',
                            },
                            "merge_delivery_order_number": {
                                'zh-tw': '合併送料單號',
                                en: 'merge delivery order number',
                            },
                        }

                    },
                },
            },
            defective_product_inspection_management: {
                'zh-tw': '不良品檢驗管理模組',
                en: '',
                children: {
                    defective_product_record: {
                        'zh-tw': '線上不良品紀錄',
                        en: '',
                        children: {
                            "editing": {
                                'zh-tw': '編輯',
                                en: 'Edit',
                            },
                            "create": {
                                'zh-tw': '新增',
                                en: 'create',
                            },
                            "read": {
                                'zh-tw': '瀏覽',
                                en: 'read',
                            },
                            "edit": {
                                'zh-tw': '資料編輯',
                                en: 'Edit',
                            },
                            "copy": {
                                'zh-tw': '資料複製',
                                en: 'Copy',
                            },
                            "delete": {
                                'zh-tw': '資料刪除',
                                en: 'Delete',
                            },
                            "operate": {
                                'zh-tw': '操作',
                                en: 'Operate',
                            },
                            "serial_number": {
                                'zh-tw': '序號',
                                en: 'NO.',
                            },
                            defective_product_record: {
                                'zh-tw': '線上不良品紀錄',
                                en: '',
                            },
                            defective_product_type_name: {
                                'zh-tw': '不良品類型',
                                en: '',
                            },
                            defective_quantity: {
                                'zh-tw': '不良品數量',
                                en: '',
                            },
                            reason: {
                                'zh-tw': '原因',
                                en: '',
                            },
                            create_time: {
                                'zh-tw': '建立時間',
                                en: '',
                            }
                        },
                    },
                    defective_product_cause_management: {
                        'zh-tw': '不良品原因管理',
                        en: '',
                        children: {
                            "editing": {
                                'zh-tw': '編輯',
                                en: 'Edit',
                            },
                            "create": {
                                'zh-tw': '新增',
                                en: 'create',
                            },
                            "read": {
                                'zh-tw': '瀏覽',
                                en: 'read',
                            },
                            "edit": {
                                'zh-tw': '資料編輯',
                                en: 'Edit',
                            },
                            "copy": {
                                'zh-tw': '資料複製',
                                en: 'Copy',
                            },
                            "delete": {
                                'zh-tw': '資料刪除',
                                en: 'Delete',
                            },
                            "operate": {
                                'zh-tw': '操作',
                                en: 'Operate',
                            },
                            "serial_number": {
                                'zh-tw': '序號',
                                en: 'NO.',
                            },
                            defective_product_cause_management: {
                                'zh-tw': '不良品原因管理',
                                en: '',
                            },
                            defective_product_type_name: {
                                'zh-tw': '不良品類型',
                                en: '',
                            },
                            defective_quantity: {
                                'zh-tw': '不良品數量',
                                en: '',
                            },
                            reason: {
                                'zh-tw': '原因',
                                en: '',
                            },
                            create_time: {
                                'zh-tw': '建立時間',
                                en: '',
                            }
                        },
                    },
                    defective_product_tracking_management: {
                        'zh-tw': '不良品追蹤管理',
                        en: '',
                        children: {

                        },
                    },
                },
            },
            report_management: {
                'zh-tw': '報表管理模組',
                en: '',
                children: {},
            },
            utility_form_generator: {
                "zh-tw": "表單產生器",
                en: "Utility Form Generator",
                children: {
                    basic_setting: {
                        "zh-tw": "基礎設定",
                        en: "Basic Setting",
                        children: {
                            create: {
                                "zh-tw": "創建",
                                en: "Create",
                                children: {
                                    element: {
                                        "zh-tw": "元件",
                                        en: "Element",
                                        children: {
                                            dataEntry: {
                                                "zh-tw": "資料輸入",
                                                en: "Data Entry",
                                                children: {
                                                    Button: {
                                                        "zh-tw": "按鈕",
                                                        en: "Button"
                                                    },
                                                    Steps: {
                                                        "zh-tw": "流程",
                                                        en: "Steps"
                                                    },
                                                    Checkbox: {
                                                        "zh-tw": "勾選框",
                                                        en: "Checkbox"
                                                    },
                                                    DatePicker: {
                                                        "zh-tw": "日期",
                                                        en: "DatePicker"
                                                    },
                                                    Form: {
                                                        "zh-tw": "表單",
                                                        en: "Form"
                                                    },
                                                    Input: {
                                                        "zh-tw": "輸入框",
                                                        en: "Input"
                                                    },
                                                    InputNumber: {
                                                        "zh-tw": "數字框",
                                                        en: "InputNumber"
                                                    },
                                                    Radio: {
                                                        "zh-tw": "單選框",
                                                        en: "Radio"
                                                    },
                                                    Select: {
                                                        "zh-tw": "選單",
                                                        en: "Select"
                                                    },
                                                    Switch: {
                                                        "zh-tw": "切換",
                                                        en: "Switch"
                                                    },
                                                    Typography: {
                                                        "zh-tw": "標題",
                                                        en: "Label"
                                                    },
                                                }
                                            },
                                            dataDisplay: {
                                                "zh-tw": "資料展示",
                                                en: "Data Display",
                                                children: {
                                                    Card: {
                                                        "zh-tw": "卡片",
                                                        en: "Card"
                                                    },
                                                    Image: {
                                                        "zh-tw": "圖片",
                                                        en: "Image"
                                                    },
                                                    Table: {
                                                        "zh-tw": "表格",
                                                        en: "Table"
                                                    }
                                                }
                                            }
                                        }
                                    },
                                    chart: {
                                        "zh-tw": "圖表",
                                        en: "Chart",
                                        children: {
                                            test1: {
                                                children: {
                                                    BulletChart: {
                                                        "zh-tw": "子彈圖",
                                                        en: "BulletChart"
                                                    },
                                                    HerizontalBarChart: {
                                                        "zh-tw": "橫形長條圖",
                                                        en: "HerizontalBarChart"
                                                    },
                                                }
                                            }
                                        }
                                    },
                                }
                            },
                            inspect: {
                                "zh-tw": "檢視",
                                en: "Inspect",
                                children: {
                                    elementName: {
                                        "zh-tw": "元件名稱",
                                        en: "Element Name"
                                    },
                                    elementColor: {
                                        "zh-tw": "元件顏色",
                                        en: "Element Color"
                                    },
                                    elementFontSize: {
                                        "zh-tw": "字體大小",
                                        en: "Font Size"
                                    },
                                    path: {
                                        "zh-tw": "路徑",
                                        en: "Path"
                                    },
                                    functionName: {
                                        "zh-tw": "功能名稱",
                                        en: "Function Name"
                                    },
                                    formName: {
                                        "zh-tw": "表單名稱",
                                        en: "Form Name"
                                    },
                                    formCode: {
                                        "zh-tw": "表單代碼",
                                        en: "Form Code"
                                    },
                                    workUnit: {
                                        "zh-tw": "適用單位",
                                        en: "Work Unit"
                                    },
                                    nodeName: {
                                        "zh-tw": "節點名稱",
                                        en: "Node Name"
                                    },
                                    nodePosition: {
                                        "zh-tw": "生成位置",
                                        en: "Node Position"
                                    },
                                    nodeTitle: {
                                        "zh-tw": "節點頭銜",
                                        en: "Node Title"
                                    },
                                    elementValue: {
                                        "zh-tw": "元件值",
                                        en: "Element Value"
                                    },
                                    elementLength: {
                                        "zh-tw": "元件長",
                                        en: "Element Length"
                                    },
                                    elementWidth: {
                                        "zh-tw": "元件寬",
                                        en: "Element Width"
                                    },
                                    boardLength: {
                                        "zh-tw": "表格長",
                                        en: "Board Length"
                                    },
                                    boardWidth: {
                                        "zh-tw": "表格寬",
                                        en: "Board Width"
                                    },
                                    squareLength: {
                                        "zh-tw": "格子長",
                                        en: "Square Length"
                                    },
                                    squareWidth: {
                                        "zh-tw": "格子寬",
                                        en: "Square Width"
                                    },
                                    goBack: {
                                        "zh-tw": "返回編輯",
                                        en: "Go Back To Editing"
                                    }
                                }
                            }
                        }
                    },
                    sider: {
                        "zh-tw": "Demo用",
                        en: "",
                        children: {
                            element: {
                                "zh-tw": "元件",
                                en: "Element",
                                children: {
                                    dataEntry: {
                                        "zh-tw": "資料輸入",
                                        en: "Data Entry",
                                        children: {
                                            Button: {
                                                "zh-tw": "按鈕",
                                                en: "Button"
                                            },
                                            Steps: {
                                                "zh-tw": "流程",
                                                en: "Steps"
                                            },
                                            Checkbox: {
                                                "zh-tw": "勾選框",
                                                en: "Checkbox"
                                            },
                                            DatePicker: {
                                                "zh-tw": "日期",
                                                en: "DatePicker"
                                            },
                                            Form: {
                                                "zh-tw": "表單",
                                                en: "Form"
                                            },
                                            Input: {
                                                "zh-tw": "輸入框",
                                                en: "Input"
                                            },
                                            InputNumber: {
                                                "zh-tw": "數字框",
                                                en: "InputNumber"
                                            },
                                            Radio: {
                                                "zh-tw": "單選框",
                                                en: "Radio"
                                            },
                                            Select: {
                                                "zh-tw": "選單",
                                                en: "Select"
                                            },
                                            Switch: {
                                                "zh-tw": "切換",
                                                en: "Switch"
                                            }
                                        }
                                    },
                                    dataDisplay: {
                                        "zh-tw": "資料展示",
                                        en: "Data Display",
                                        children: {
                                            Card: {
                                                "zh-tw": "卡片",
                                                en: "Card"
                                            },
                                            Image: {
                                                "zh-tw": "圖片",
                                                en: "Image"
                                            },
                                            Table: {
                                                "zh-tw": "表格",
                                                en: "Table"
                                            }
                                        }
                                    }
                                }
                            },
                            // chart: {
                            //     "zh-tw": "圖表",
                            //     en: "Chart",
                            //     children: {
                            //         test1: {
                            //             children: {
                            //                 test2: {
                            //                     "zh-tw": "test1",
                            //                     en: "Test1"
                            //                 }
                            //             }
                            //         }
                            //     }
                            // },
                        }
                    },
                    overview: {
                        "zh-tw": "表單總覽",
                        en: "Overview"
                    },
                    architecture: {
                        "zh-tw": "組織架構",
                        en: "Architecture",
                        children: {
                            employee_organization: {
                                'zh-tw': "員工組織圖",
                                en: "Employee Organization"
                            },
                            level: {
                                "zh-tw": "層級",
                                en: "Level"
                            },
                            module: {
                                "zh-tw": "隸屬部門",
                                en: "Module"
                            },
                            work_position: {
                                "zh-tw": "職稱",
                                en: "Work Position"
                            },
                            employee_id: {
                                "zh-tw": "人員編號",
                                en: "Employee ID"
                            },
                            name: {
                                "zh-tw": "姓名",
                                en: "Name"
                            },
                            substitute_module: {
                                "zh-tw": "代理人部門",
                                en: "Substitute Module"
                            },
                            substitute_work_position: {
                                "zh-tw": "代理人職稱",
                                en: "Substitute Work Position"
                            },
                            substitute_employee_id: {
                                "zh-tw": "代理人編號",
                                en: "Substitute Employee ID"
                            },
                            substitute_name: {
                                "zh-tw": "代理人姓名",
                                en: "Substitute Name"
                            }
                        }
                    }
                }
            }
        }
    },
    accounting: {
        'zh-tw': "成本會計系統",
        en: "Cost Accounting Management System",
        children: {
            basic_data_maintain_management: {
                'zh-tw': '基本資料維護模組',
                en: "Basic Data Maintain Management",
                children: {
                    customer_information: {
                        'zh-tw': "客戶基本資料",
                        en: "Customer Information",
                        children: {
                            customer_id: {
                                'zh-tw': "客戶編號",
                                en: "Customer ID"
                            },
                            customer_name: {
                                'zh-tw': "客戶名稱",
                                en: "Customer Name"
                            },
                            customer_name_short: {
                                'zh-tw': "客戶簡稱",
                                en: "Customer Name"
                            },
                            customer_group_id: {
                                'zh-tw': "客戶分類",
                                en: "Customer Group ID"
                            },
                            customer_group: {
                                'zh-tw': "客戶分類",
                                en: "Customer Group"
                            },
                            person_in_charge: {
                                'zh-tw': "負責人",
                                en: "Person in Charge"
                            },
                            tax_id_number: {
                                'zh-tw': "統一編號",
                                en: "Tax ID Number"
                            },
                            contact_person: {
                                'zh-tw': "聯絡人",
                                en: "Contact Person"
                            },
                            position: {
                                'zh-tw': "職務職稱",
                                en: "Job Title"
                            },
                            extension: {
                                'zh-tw': "分機號碼",
                                en: "Extension"
                            },
                            tel: {
                                'zh-tw': "聯絡電話",
                                en: "Tel"
                            },
                            fax: {
                                'zh-tw': "傳真號碼",
                                en: "Fax"
                            },
                            tax: {
                                'zh-tw': "稅別",
                                en: "Tax"
                            },
                            payment: {
                                'zh-tw': "請款方式",
                                en: "Payment"
                            },
                            invoice_title: {
                                'zh-tw': "發票抬頭",
                                en: "Invoice Title"
                            },
                            company_address: {
                                'zh-tw': "公司地址",
                                en: "Company Address"
                            },
                            company_area_code: {
                                'zh-tw': "區號",
                                en: "Area Code"
                            },
                            shipping_address: {
                                'zh-tw': "送貨地址",
                                en: "Shipping Address"
                            },
                            shipping_area_code: {
                                'zh-tw': "區號",
                                en: "Area Code"
                            },
                            invoice_address: {
                                'zh-tw': "發票地址",
                                en: "Invoice Address"
                            },
                            invoice_area_code: {
                                'zh-tw': "區號",
                                en: "Area Code"
                            },
                            account_day: {
                                'zh-tw': "結帳日",
                                en: "Account Date"
                            },
                            distributor_level: {
                                'zh-tw': "盤商等級",
                                en: "Distributor Level"
                            },
                            account: {
                                'zh-tw': "帳號",
                                en: "Account"
                            },
                            credits: {
                                'zh-tw': "信用額度",
                                en: "Credits"
                            },
                            quota_credits: {
                                'zh-tw': "可用額度",
                                en: "Quota Credits"
                            },
                            country: {
                                'zh-tw': "國家",
                                en: "Country"
                            },
                            discount: {
                                'zh-tw': "折數",
                                en: "Discount"
                            },
                            print: {
                                'zh-tw': '列印',
                                en: 'Print'
                            },
                            import_data: {
                                'zh-tw': "匯入資料",
                                en: "Import Data"
                            },
                            export_data: {
                                'zh-tw': "匯出資料",
                                en: "Export Data"
                            },
                            add_data: {
                                'zh-tw': '新增客戶基本資料',
                                en: "Add customer basic information"
                            }
                        }
                    },
                    manufacturers_information: {
                        'zh-tw': "廠商基本資料",
                        en: "Manufacturers Information",
                        children: {
                            manufacturers_id: {
                                'zh-tw': "廠商編號",
                                en: "Manufacturers ID"
                            },
                            manufacturers_type: {
                                'zh-tw': "廠商類別",
                                en: "Manufacturers Type"
                            },
                            tax_id_number: {
                                'zh-tw': "統一編號",
                                en: "Tax ID Number"
                            },
                            file_date: {
                                'zh-tw': "建檔日期",
                                en: "File Date"
                            },
                            chinese_name: {
                                'zh-tw': "中文名字",
                                en: "Chinese Name"
                            },
                            tel: {
                                'zh-tw': "聯絡電話",
                                en: "Tel"
                            },
                            contact_person: {
                                'zh-tw': "聯絡人員",
                                en: "Contact Person"
                            },
                            change_date: {
                                'zh-tw': "異動日期",
                                en: "Change Date"
                            },
                            address: {
                                'zh-tw': "公司地址",
                                en: "Address"
                            },
                            del_mark: {
                                'zh-tw': "刪除標記",
                                en: "Delete Mark"
                            },
                            manufacturer_list: {
                                'zh-tw': "廠商清單",
                                en: "Manufacturer List"
                            },
                            information: {
                                'zh-tw': "基本資料",
                                en: "Information"
                            },
                            account_maintain: {
                                'zh-tw': "帳款維護",
                                en: "Accounts Maintain"
                            },
                            note: {
                                'zh-tw': "備註",
                                en: "Note"
                            },
                            type: {
                                'zh-tw': "類別",
                                en: "Type"
                            },
                            person_in_charge: {
                                'zh-tw': "負責人",
                                en: "Person in Charge"
                            },
                            fax: {
                                'zh-tw': "傳真號碼",
                                en: "Fax"
                            },
                            company_tel: {
                                'zh-tw': "公司電話",
                                en: "Company Tel"
                            },
                            company_info: {
                                'zh-tw': "公司資料",
                                en: "Company Information"
                            },
                            email: {
                                'zh-tw': "電子郵件",
                                en: "E-mail"
                            },
                            website: {
                                'zh-tw': "網站",
                                en: "Website"
                            },
                            factory_info: {
                                'zh-tw': "工廠資料",
                                en: "Factory Information"
                            },
                            factory_tel: {
                                'zh-tw': "聯絡電話",
                                en: "Factory Tel"
                            },
                            file_type: {
                                'zh-tw': "檔案型態",
                                en: "File Format"
                            },
                            factory_address: {
                                'zh-tw': "工廠地址",
                                en: "Factory Address"
                            },
                            purchasing_info: {
                                'zh-tw': "採購資料",
                                en: "Purchasing Information"
                            },
                            max_yield: {
                                'zh-tw': "最大產量",
                                en: "Maximum Yield"
                            },
                            start_trading: {
                                'zh-tw': "開始交易",
                                en: "Start Trading"
                            },
                            recently_accepted_orders: {
                                'zh-tw': "最近接單量",
                                en: "Recently Accepted Orders"
                            },
                            recently_purchase: {
                                'zh-tw': "最近進貨",
                                en: "Recently Purchase"
                            },
                            purchase_id: {
                                'zh-tw': "進貨單號",
                                en: "Purchase ID"
                            },
                            invoice_info: {
                                'zh-tw': "發票資料",
                                en: "Invoice Information"
                            },
                            default_tax_category: {
                                'zh-tw': "預設稅別",
                                en: "Default Tax Category"
                            },
                            print: {
                                'zh-tw': '列印',
                                en: 'Print'
                            },
                            export: {
                                'zh-tw': '匯出資料',
                                en: 'Export Data'
                            },
                            import: {
                                'zh-tw': '匯入資料',
                                en: 'Import Data',
                                children: {
                                    sample: {
                                        'zh-tw': '下載範例',
                                        en: 'Download Sample'
                                    },
                                    upload: {
                                        'zh-tw': '上傳Excel檔案',
                                        en: 'Upload Excel File'
                                    },
                                    preview: {
                                        'zh-tw': '預覽檔案',
                                        en: 'Preview File'
                                    },
                                    finish: {
                                        'zh-tw': '確認匯入',
                                        en: 'Confirm'
                                    },
                                    close: {
                                        'zh-tw': '關閉',
                                        en: 'Close'
                                    },
                                }
                            },
                        },
                    },
                    module_information: {
                        'zh-tw': "部門資料維護",
                        en: "Department Information Maintenance",
                        children: {
                            department_id: {
                                'zh-tw': "部門代號",
                                en: "Department Number"
                            },
                            department_name: {
                                'zh-tw': "部門名稱",
                                en: "Department Name"
                            },
                            import_data: {
                                'zh-tw': "匯入資料",
                                en: "Import Data"
                            },
                            export_data: {
                                'zh-tw': "匯出資料",
                                en: "Export Data"
                            },
                        }
                    },
                    currency_setting: {
                        'zh-tw': "幣別設定",
                        en: "Currency Setting",
                        children: {
                            import_data: {
                                'zh-tw': "匯入資料",
                                en: "Import Data"
                            },
                            export_data: {
                                'zh-tw': "匯出資料",
                                en: "Export Data"
                            },
                        }
                    },
                    totalclass: {
                        'zh-tw': "會計總類維護",
                        en: "Accounting Total Class Maintain",
                        children: {
                            import_data: {
                                'zh-tw': "匯入資料",
                                en: "Import Data"
                            },
                            export_data: {
                                'zh-tw': "匯出資料",
                                en: "Export Data"
                            },
                        }
                    },
                    class: {
                        'zh-tw': "會計類別維護",
                        en: "Accounting Class Maintain",
                        children: {
                            import_data: {
                                'zh-tw': "匯入資料",
                                en: "Import Data"
                            },
                            export_data: {
                                'zh-tw': "匯出資料",
                                en: "Export Data"
                            },
                        }
                    },
                    item: {
                        'zh-tw': "會計科目維護",
                        en: "Accounting Item Maintain",
                        children: {
                            import_data: {
                                'zh-tw': "匯入資料",
                                en: "Import Data"
                            },
                            export_data: {
                                'zh-tw': "匯出資料",
                                en: "Export Data"
                            },
                        }
                    },
                    bank_class: {
                        'zh-tw': "銀行類別維護",
                        en: "Bank Class Maintain",
                        children: {
                            import_data: {
                                'zh-tw': "匯入資料",
                                en: "Import Data"
                            },
                            export_data: {
                                'zh-tw': "匯出資料",
                                en: "Export Data"
                            },
                        }
                    },
                    bank_data: {
                        'zh-tw': "銀行資料維護",
                        en: "Bank Information Maintain",
                        children: {
                            import_data: {
                                'zh-tw': "匯入資料",
                                en: "Import Data"
                            },
                            export_data: {
                                'zh-tw': "匯出資料",
                                en: "Export Data"
                            },
                        }
                    },
                    cost_of_revenue: {
                        'zh-tw': "營業成本公式",
                        en: "Cost of Revenue",
                        children: {
                            import_data: {
                                'zh-tw': "匯入資料",
                                en: "Import Data"
                            },
                            export_data: {
                                'zh-tw': "匯出資料",
                                en: "Export Data"
                            },
                        }
                    },
                    accounting_entry: {
                        'zh-tw': "常用分錄維護",
                        en: "Accounting Entry Maintain",
                        children: {
                            import_data: {
                                'zh-tw': "匯入資料",
                                en: "Import Data"
                            },
                            export_data: {
                                'zh-tw': "匯出資料",
                                en: "Export Data"
                            },
                        }
                    },
                    voucher_batch_review: {
                        'zh-tw': "傳票批次覆核",
                        en: "Voucher Batch Review",
                        children: {
                            import_data: {
                                'zh-tw': "匯入資料",
                                en: "Import Data"
                            },
                            export_data: {
                                'zh-tw': "匯出資料",
                                en: "Export Data"
                            },
                        }
                    },
                    item_transform: {
                        'zh-tw': "科目移轉",
                        en: "Item Transform",
                        children: {
                            import_data: {
                                'zh-tw': "匯入資料",
                                en: "Import Data"
                            },
                            export_data: {
                                'zh-tw': "匯出資料",
                                en: "Export Data"
                            },
                        }
                    },
                    item_change: {
                        'zh-tw': "科目變更",
                        en: "Item Change",
                        children: {
                            import_data: {
                                'zh-tw': "匯入資料",
                                en: "Import Data"
                            },
                            export_data: {
                                'zh-tw': "匯出資料",
                                en: "Export Data"
                            },
                        }
                    },
                }
            },
            cost_basic_operations: {
                'zh-tw': '成本基本作業模組',
                en: "",
                children: {
                    cost_beginning_setting: {
                        'zh-tw': "成本期初設定",
                        en: "Cost beginning Setting",
                        children: {
                            import_data: {
                                'zh-tw': "匯入資料",
                                en: "Import Data"
                            },
                            export_data: {
                                'zh-tw': "匯出資料",
                                en: "Export Data"
                            },
                        }
                    },
                    cost_class_setting: {
                        'zh-tw': "成本類別設定",
                        en: "Cost Class Setting",
                        children: {
                            import_data: {
                                'zh-tw': "匯入資料",
                                en: "Import Data"
                            },
                            export_data: {
                                'zh-tw': "匯出資料",
                                en: "Export Data"
                            },
                        }
                    },
                    allocation_class_setting: {
                        'zh-tw': "分攤類別設定",
                        en: "Allocation Category Setting",
                        children: {
                            import_data: {
                                'zh-tw': "匯入資料",
                                en: "Import Data"
                            },
                            export_data: {
                                'zh-tw': "匯出資料",
                                en: "Export Data"
                            },
                        }
                    },
                }
            },
            cost_allocation: {
                'zh-tw': '成本分攤作業模組',
                en: "",
                children: {
                    cost_allocation: {
                        'zh-tw': "成本分攤",
                        en: "Cost Allocation",
                        children: {
                            import_data: {
                                'zh-tw': "匯入資料",
                                en: "Import Data"
                            },
                            export_data: {
                                'zh-tw': "匯出資料",
                                en: "Export Data"
                            },
                        }
                    },
                    department_allocation: {
                        'zh-tw': "部門分攤",
                        en: "Department Allocation",
                        children: {
                            import_data: {
                                'zh-tw': "匯入資料",
                                en: "Import Data"
                            },
                            export_data: {
                                'zh-tw': "匯出資料",
                                en: "Export Data"
                            },
                        }
                    },
                    project_allocation: {
                        'zh-tw': "專案分攤",
                        en: "Project Allocation",
                        children: {
                            import_data: {
                                'zh-tw': "匯入資料",
                                en: "Import Data"
                            },
                            export_data: {
                                'zh-tw': "匯出資料",
                                en: "Export Data"
                            },
                        }
                    },
                    material_cost_summary_sheet: {
                        'zh-tw': "材料成本匯總單",
                        en: "Material Cost Summary Sheet",
                        children: {
                            import_data: {
                                'zh-tw': "匯入資料",
                                en: "Import Data"
                            },
                            export_data: {
                                'zh-tw': "匯出資料",
                                en: "Export Data"
                            },
                        }
                    },
                    standard_cost_transaction_order: {
                        'zh-tw': "標準成本異動單",
                        en: "Standard Cost Transaction Order",
                        children: {
                            import_data: {
                                'zh-tw': "匯入資料",
                                en: "Import Data"
                            },
                            export_data: {
                                'zh-tw': "匯出資料",
                                en: "Export Data"
                            },
                        }
                    },
                    standard_batch_transaction_order: {
                        'zh-tw': "標準批量異動單",
                        en: "Standard batch Transaction Order",
                        children: {
                            import_data: {
                                'zh-tw': "匯入資料",
                                en: "Import Data"
                            },
                            export_data: {
                                'zh-tw': "匯出資料",
                                en: "Export Data"
                            },
                        }
                    },
                    manufacturing_cost_allocation_settings: {
                        'zh-tw': "製造成本分攤設定",
                        en: "Manufacturing Cost Allocation Settings",
                        children: {
                            import_data: {
                                'zh-tw': "匯入資料",
                                en: "Import Data"
                            },
                            export_data: {
                                'zh-tw': "匯出資料",
                                en: "Export Data"
                            },
                        }
                    },
                }
            },
            credential_transfer: {
                'zh-tw': '憑證傳輸模組',
                en: "",
                children: {
                    voucher: {
                        'zh-tw': "傳票",
                        en: "Voucher",
                        children: {
                            dBillDate: {
                                'zh-tw': "傳票日期",
                                en: "Bill Date"
                            },
                            cBillNumber: {
                                'zh-tw': "傳票號碼",
                                en: "Bill Number"
                            },
                            cEntries: {
                                'zh-tw': "常用分錄",
                                en: "Entries"
                            },
                            cOperator: {
                                'zh-tw': "製作人員",
                                en: "Operator"
                            },
                            iKind_ID: {
                                'zh-tw': "傳票類別",
                                en: "Bill Kind"
                            },
                            iBillNumber: {
                                'zh-tw': "電腦編號",
                                en: "Bill Code"
                            },
                            cChecker: {
                                'zh-tw': "覆核人員",
                                en: "Checker"
                            },
                            cExplain: {
                                'zh-tw': "備註說明",
                                en: "Note"
                            },
                            receipt: {
                                'zh-tw': "傳輸單據",
                                en: "Receipt"
                            },
                            iRecords_Debit: {
                                'zh-tw': "借方筆數",
                                en: "Records Debit"
                            },
                            iRecords_Credit: {
                                'zh-tw': "貸方筆數",
                                en: "Records Credit"
                            },
                            fTotal_Debit_NTD: {
                                'zh-tw': "本幣借方",
                                en: "Total Debit(NTD)"
                            },
                            fTotal_Credit_NTD: {
                                'zh-tw': "本幣貸方",
                                en: "Total Credit(NTD)"
                            },
                            difference_NTD: {
                                'zh-tw': "本幣差額",
                                en: "Difference(NTD)"
                            },
                            fTotal_Debit: {
                                'zh-tw': "原幣借方",
                                en: "Total Debit"
                            },
                            fTotal_Credit: {
                                'zh-tw': "原幣貸方",
                                en: "Total Credit"
                            },
                            difference: {
                                'zh-tw': "原幣差額",
                                en: "Difference"
                            },
                            table_no: {
                                'zh-tw': "欄位",
                                en: "No."
                            },
                            debit_credit: {
                                'zh-tw': "借/貸",
                                en: "Debit/Credit"
                            },
                            debit: {
                                'zh-tw': "借",
                                en: "Debit"
                            },
                            credit: {
                                'zh-tw': "貸",
                                en: "Credit"
                            },
                            subject_id: {
                                'zh-tw': "科目編號",
                                en: "Subject ID"
                            },
                            subject_name: {
                                'zh-tw': "科目名稱",
                                en: "Subject Name"
                            },
                            table_note: {
                                'zh-tw': "摘要",
                                en: "Note"
                            },
                            currency_id: {
                                'zh-tw': "幣別編號",
                                en: "Currency ID"
                            },
                            currency_name: {
                                'zh-tw': "幣別名稱",
                                en: "Currency Name"
                            },
                            amount: {
                                'zh-tw': "金額",
                                en: "Amount"
                            },
                            exchange_rate: {
                                'zh-tw': "匯率",
                                en: "Exchange Rate"
                            },
                            amount_NTD: {
                                'zh-tw': "本幣金額",
                                en: "Amount(NTD)"
                            },
                            module_id: {
                                'zh-tw': "部門編號",
                                en: "Module ID"
                            },
                            module_name: {
                                'zh-tw': "部門名稱",
                                en: "Module Name"
                            },
                            project_id: {
                                'zh-tw': "專案編號",
                                en: "Project ID"
                            },
                            project_name: {
                                'zh-tw': "專案名稱",
                                en: "Project Name"
                            },
                            contacts: {
                                'zh-tw': "往來對象",
                                en: "Contacts"
                            },
                            petty_cash: {
                                'zh-tw': "零用金領取",
                                en: "Petty Cash"
                            },
                            recipients: {
                                'zh-tw': "領取人",
                                en: "Recipients"
                            },
                            historical_summary: {
                                'zh-tw': "歷史摘要",
                                en: "Historical Summary"
                            },
                            rescheduling: {
                                'zh-tw': "借貸重排",
                                en: "Debit/Credit Rescheduling"
                            },
                            department_allocation: {
                                'zh-tw': "部門分攤",
                                en: "Department Allocation"
                            },
                            project_allocation: {
                                'zh-tw': "專案分攤",
                                en: "Project Allocation"
                            },
                            summary_details: {
                                'zh-tw': "彙總明細",
                                en: "Summary Details"
                            },
                            write_off_setting: {
                                'zh-tw': "沖銷設定",
                                en: "Write Off Setting"
                            },
                            write_off_query: {
                                'zh-tw': "已沖查詢",
                                en: "Write Off Query"
                            },
                            wire_ticket: {
                                'zh-tw': "連線票據",
                                en: "Wire Ticket"
                            },
                            cost_detail: {
                                'zh-tw': "成本細項",
                                en: "Cost Detail"
                            }
                        }

                    },
                    historical_summary: {
                        'zh-tw': "歷史摘要",
                        en: "Historical Summary",
                        children: {
                            import_data: {
                                'zh-tw': "匯入資料",
                                en: "Import Data"
                            },
                            export_data: {
                                'zh-tw': "匯出資料",
                                en: "Export Data"
                            },
                        }
                    },
                    loan_sort: {
                        'zh-tw': "借貸排序",
                        en: "Loan Sort",
                        children: {
                            import_data: {
                                'zh-tw': "匯入資料",
                                en: "Import Data"
                            },
                            export_data: {
                                'zh-tw': "匯出資料",
                                en: "Export Data"
                            },
                        }
                    },
                    accounting_data_transfer_voucher: {
                        'zh-tw': "帳款資料拋轉傳票",
                        en: "Accounting Data Transfer Voucher",
                        children: {
                            import_data: {
                                'zh-tw': "匯入資料",
                                en: "Import Data"
                            },
                            export_data: {
                                'zh-tw': "匯出資料",
                                en: "Export Data"
                            },
                        }
                    },
                    monthly_cost_transfer_voucher: {
                        'zh-tw': "月結成本拋轉傳票",
                        en: "Monthly Cost Transfer Voucher",
                        children: {
                            import_data: {
                                'zh-tw': "匯入資料",
                                en: "Import Data"
                            },
                            export_data: {
                                'zh-tw': "匯出資料",
                                en: "Export Data"
                            },
                        }
                    },
                    cashier_system_transfer_voucher: {
                        'zh-tw': "出納系統拋轉傳票",
                        en: "Cashier System Transfer Voucher",
                        children: {
                            import_data: {
                                'zh-tw': "匯入資料",
                                en: "Import Data"
                            },
                            export_data: {
                                'zh-tw': "匯出資料",
                                en: "Export Data"
                            },
                        }
                    },
                    charging_depreciation_expenses_transfer_voucher: {
                        'zh-tw': "折舊提列拋轉傳票",
                        en: "Charging Depreciation Expenses Voucher",
                        children: {
                            import_data: {
                                'zh-tw': "匯入資料",
                                en: "Import Data"
                            },
                            export_data: {
                                'zh-tw': "匯出資料",
                                en: "Export Data"
                            },
                        }
                    },
                    property_change_transfer_voucher: {
                        'zh-tw': "財產異動拋轉傳票",
                        en: "Property Change Expenses Voucher",
                        children: {
                            import_data: {
                                'zh-tw': "匯入資料",
                                en: "Import Data"
                            },
                            export_data: {
                                'zh-tw': "匯出資料",
                                en: "Export Data"
                            },
                        }
                    },
                    voucher_posting: {
                        'zh-tw': "傳票過帳",
                        en: "Voucher Posting",
                        children: {
                            import_data: {
                                'zh-tw': "匯入資料",
                                en: "Import Data"
                            },
                            export_data: {
                                'zh-tw': "匯出資料",
                                en: "Export Data"
                            },
                        }
                    },
                }
            },
            business_account_management: {
                'zh-tw': '營業帳務管理模組',
                en: "",
                children: {

                }
            },
            financial_statement_management: {
                'zh-tw': '財務報表管理模組',
                en: "",
                children: {

                }
            },
            business_accounting_report_management: {
                'zh-tw': '營業帳務報表管理模組',
                en: "",
                children: {

                }
            },
        }
    },
    wms: {
        'zh-tw': '智慧倉儲管理系統',
        en: '',
        children: {
            home: {
                'zh-tw': '我的首頁',
                en: '',
                children: []
            },
            basic_data_maintain_management: {
                'zh-tw': '基本資料維護模組',
                en: "Basic Data Maintain Management",
                children: {
                    manufacturer_customer_data_maintenance: { // Title
                        icon: <HomeOutlined
                            style={{
                                color: '#E17044',
                                textAlign: 'center'
                            }}
                        />,
                        'zh-tw': "廠商(客戶)資料維護",
                        en: "",
                        children: {
                            import: {
                                'zh-tw': '匯入資料',
                                en: 'Import Data',
                                children: {
                                    sample: {
                                        'zh-tw': '下載範例',
                                        en: 'Download Sample'
                                    },
                                    upload: {
                                        'zh-tw': '上傳Excel檔案',
                                        en: 'Upload Excel File'
                                    },
                                    preview: {
                                        'zh-tw': '預覽檔案',
                                        en: 'Preview File'
                                    },
                                    finish: {
                                        'zh-tw': '確認匯入',
                                        en: 'Confirm'
                                    },
                                    close: {
                                        'zh-tw': '關閉',
                                        en: 'Close'
                                    },
                                    table_column_name: {
                                        'zh-tw': '名稱',
                                        en: 'Name'
                                    },
                                    table_column_process_codes: {
                                        'zh-tw': '製程代號',
                                        en: 'Process Code'
                                    },
                                    table_column_durations: {
                                        'zh-tw': '標準工時',
                                        en: 'Standard Process Duration'
                                    },
                                    table_column_minutes: {
                                        'zh-tw': '分',
                                        en: 'Minutes'
                                    },
                                }
                            },
                        },
                    },
                    raw_material_data_maintenance: {
                        icon: <BorderOutlined
                            style={{
                                color: '#E17044',
                                textAlign: 'center'
                            }}
                        />,
                        'zh-tw': "原物料資料維護",
                        en: "",
                        children: {
                            import: {
                                'zh-tw': '匯入資料',
                                en: 'Import Data',
                                children: {
                                    sample: {
                                        'zh-tw': '下載範例',
                                        en: 'Download Sample'
                                    },
                                    upload: {
                                        'zh-tw': '上傳Excel檔案',
                                        en: 'Upload Excel File'
                                    },
                                    preview: {
                                        'zh-tw': '預覽檔案',
                                        en: 'Preview File'
                                    },
                                    finish: {
                                        'zh-tw': '確認匯入',
                                        en: 'Confirm'
                                    },
                                    close: {
                                        'zh-tw': '關閉',
                                        en: 'Close'
                                    },
                                    table_column_name: {
                                        'zh-tw': '名稱',
                                        en: 'Name'
                                    },
                                    table_column_process_codes: {
                                        'zh-tw': '製程代號',
                                        en: 'Process Code'
                                    },
                                    table_column_durations: {
                                        'zh-tw': '標準工時',
                                        en: 'Standard Process Duration'
                                    },
                                    table_column_minutes: {
                                        'zh-tw': '分',
                                        en: 'Minutes'
                                    },
                                }
                            },
                        },
                    },
                    product_data_maintenance: {
                        icon: <BuildFilled
                            style={{
                                color: '#E17044',
                                textAlign: 'center'
                            }}
                        />,
                        'zh-tw': "產品資料維護",
                        en: "",
                        children: {
                            import: {
                                'zh-tw': '匯入資料',
                                en: 'Import Data',
                                children: {
                                    sample: {
                                        'zh-tw': '下載範例',
                                        en: 'Download Sample'
                                    },
                                    upload: {
                                        'zh-tw': '上傳Excel檔案',
                                        en: 'Upload Excel File'
                                    },
                                    preview: {
                                        'zh-tw': '預覽檔案',
                                        en: 'Preview File'
                                    },
                                    finish: {
                                        'zh-tw': '確認匯入',
                                        en: 'Confirm'
                                    },
                                    close: {
                                        'zh-tw': '關閉',
                                        en: 'Close'
                                    },
                                    table_column_name: {
                                        'zh-tw': '名稱',
                                        en: 'Name'
                                    },
                                    table_column_process_codes: {
                                        'zh-tw': '製程代號',
                                        en: 'Process Code'
                                    },
                                    table_column_durations: {
                                        'zh-tw': '標準工時',
                                        en: 'Standard Process Duration'
                                    },
                                    table_column_minutes: {
                                        'zh-tw': '分',
                                        en: 'Minutes'
                                    },
                                }
                            },
                        },
                    },
                    import_data: {
                        icon: <ImportOutlined
                            style={{
                                color: '#E17044',
                                textAlign: 'center'
                            }}
                        />,
                        'zh-tw': '匯入資料',
                        en: 'Import Data',
                        children: {
                            sample: {
                                'zh-tw': '下載範例',
                                en: 'Download Sample'
                            },
                            upload: {
                                'zh-tw': '上傳Excel檔案',
                                en: 'Upload Excel File'
                            },
                            preview: {
                                'zh-tw': '預覽檔案',
                                en: 'Preview File'
                            },
                            finish: {
                                'zh-tw': '確認匯入',
                                en: 'Confirm'
                            },
                            close: {
                                'zh-tw': '關閉',
                                en: 'Close'
                            },
                            table_column_name: {
                                'zh-tw': '名稱',
                                en: 'Name'
                            },
                            table_column_process_codes: {
                                'zh-tw': '製程代號',
                                en: 'Process Code'
                            },
                            table_column_durations: {
                                'zh-tw': '標準工時',
                                en: 'Standard Process Duration'
                            },
                            table_column_minutes: {
                                'zh-tw': '分',
                                en: 'Minutes'
                            },
                        },
                    },
                    custom_menu: {
                        icon: <ToolOutlined
                            style={{
                                color: '#E17044',
                                textAlign: 'center'
                            }}
                        />,
                        'zh-tw': '個人化選單',
                        en: ''
                    }
                },
            },
            inbound_outbound_management: {
                'zh-tw': '進出貨管理模組',
                en: "",
                children: {
                    inbound_outbound_creation: { // Title
                        'zh-tw': "進出貨建立作業",
                        en: "",
                        children: {
                            import: {
                                'zh-tw': '匯入資料',
                                en: 'Import Data',
                                children: {
                                    sample: {
                                        'zh-tw': '下載範例',
                                        en: 'Download Sample'
                                    },
                                    upload: {
                                        'zh-tw': '上傳Excel檔案',
                                        en: 'Upload Excel File'
                                    },
                                    preview: {
                                        'zh-tw': '預覽檔案',
                                        en: 'Preview File'
                                    },
                                    finish: {
                                        'zh-tw': '確認匯入',
                                        en: 'Confirm'
                                    },
                                    close: {
                                        'zh-tw': '關閉',
                                        en: 'Close'
                                    },
                                    table_column_name: {
                                        'zh-tw': '名稱',
                                        en: 'Name'
                                    },
                                    table_column_process_codes: {
                                        'zh-tw': '製程代號',
                                        en: 'Process Code'
                                    },
                                    table_column_durations: {
                                        'zh-tw': '標準工時',
                                        en: 'Standard Process Duration'
                                    },
                                    table_column_minutes: {
                                        'zh-tw': '分',
                                        en: 'Minutes'
                                    },
                                }
                            },
                        },
                    },
                    inbound_outbound_return_form: {
                        'zh-tw': "進出貨退回作業",
                        en: "",
                        children: {
                            import: {
                                'zh-tw': '匯入資料',
                                en: 'Import Data',
                                children: {
                                    sample: {
                                        'zh-tw': '下載範例',
                                        en: 'Download Sample'
                                    },
                                    upload: {
                                        'zh-tw': '上傳Excel檔案',
                                        en: 'Upload Excel File'
                                    },
                                    preview: {
                                        'zh-tw': '預覽檔案',
                                        en: 'Preview File'
                                    },
                                    finish: {
                                        'zh-tw': '確認匯入',
                                        en: 'Confirm'
                                    },
                                    close: {
                                        'zh-tw': '關閉',
                                        en: 'Close'
                                    },
                                    table_column_name: {
                                        'zh-tw': '名稱',
                                        en: 'Name'
                                    },
                                    table_column_process_codes: {
                                        'zh-tw': '製程代號',
                                        en: 'Process Code'
                                    },
                                    table_column_durations: {
                                        'zh-tw': '標準工時',
                                        en: 'Standard Process Duration'
                                    },
                                    table_column_minutes: {
                                        'zh-tw': '分',
                                        en: 'Minutes'
                                    },
                                }
                            },
                        },
                    },
                    price_adjustment: {
                        'zh-tw': "價格盤點作業",
                        en: "",
                        children: {

                        },
                    },
                    inbound_outbound_product_inspection: {
                        'zh-tw': "進出貨產品檢驗",
                        en: "",
                        children: {

                        },
                    },
                    search_inbound_outbound_product: {
                        'zh-tw': "進出貨產品查詢",
                        en: "",
                        children: {

                        },
                    },
                    print_inbound_outbound_order: {
                        'zh-tw': "進出貨單查詢列印",
                        en: "",
                        children: {

                        },
                    },
                },
            },
            inbound_management: {
                'zh-tw': '入庫管理模組',
                en: "",
                children: {
                    inbound_order_creation: { // Title
                        'zh-tw': "入庫單建立作業",
                        en: "",
                        children: {

                        },
                    },
                    purchase_storage: {
                        'zh-tw': "採購入庫",
                        en: "",
                        children: {

                        },
                    },
                    iroduction_storage: {
                        'zh-tw': "生產入庫",
                        en: "",
                        children: {

                        },
                    },
                    inbound_order_management: {
                        'zh-tw': "入庫單管理",
                        en: "",
                        children: {

                        },

                    },
                    arrival_inspection: {
                        'zh-tw': "到貨檢驗",
                        en: "",
                        children: {

                        },

                    },
                    storage_query: {
                        'zh-tw': "入庫查詢",
                        en: "",
                        children: {

                        },
                    },
                },

            },
            outbound_management: {
                'zh-tw': '出庫管理模組',
                en: "",
                children: {
                    outbound_order_creation: { // Title
                        'zh-tw': "出庫單建立作業",
                        en: "",
                        children: {

                        },
                    },

                    picking_out: {
                        'zh-tw': "領料出庫",
                        en: "",
                        children: {

                        },
                    },
                    processing_out: {
                        'zh-tw': "加工出庫",
                        en: "",
                        children: {

                        },

                    },
                    picking_process: {
                        'zh-tw': "揀貨處理",
                        en: "",
                        children: {

                        },

                    },

                    product_shipment_processing: {
                        'zh-tw': "產品出貨處理",
                        en: "",
                        children: {

                        },
                    },

                    product_shipment_inspection: {
                        'zh-tw': "產品出貨檢驗",
                        en: "",
                        children: {

                        },
                    },
                    shipping_query: {
                        'zh-tw': "出貨查詢",
                        en: "",
                        children: {

                        },
                    },
                    shipment_query: {
                        'zh-tw': "出貨單查詢",
                        en: "",
                        children: {

                        },
                    },
                },

            },
            inventory_management: {
                'zh-tw': '庫存管理模組',
                en: "",
                children: {
                    inventory_check: { // Title
                        'zh-tw': "庫存盤點",
                        en: "",
                        children: {

                        },
                    },

                    commodity_inventory_query: {
                        'zh-tw': "商品庫存查詢",
                        en: "",
                        children: {

                        },
                    },
                    transfer_management: {
                        'zh-tw': "移庫管理",
                        en: "",
                        children: {

                        },

                    },
                    processing_management: {
                        'zh-tw': "加工管理",
                        en: "",
                        children: {

                        },

                    },

                    shelf_Management: {
                        'zh-tw': "上架管理",
                        en: "",
                        children: {

                        },
                    },

                    inventory_management: {
                        'zh-tw': "庫別管理",
                        en: "",
                        children: {

                        },
                    },
                    storage_management: {
                        'zh-tw': "儲位管理",
                        en: "",
                        children: {

                        },
                    },
                    storage_modification: {
                        'zh-tw': "儲位修改",
                        en: "",
                        children: {

                        },
                    },
                    storage_container_management: {
                        'zh-tw': "存放容器管理",
                        en: "",
                        children: {

                        },
                    },
                    dead_goods_management: {
                        'zh-tw': "呆滯貨管理",
                        en: "",
                        children: {

                        },
                    },
                    document_printing: {
                        'zh-tw': "單據標籤列印",
                        en: "",
                        children: {

                        },
                    },
                },

            },
            account_management: {
                'zh-tw': '帳款管理模組',
                en: "",
                children: {
                    accounts_payable: { // Title
                        'zh-tw': "應付帳款作業",
                        en: "",
                        children: {

                        },
                    },

                    accounts_receivable: {
                        'zh-tw': "應收帳款作業",
                        en: "",
                        children: {

                        },
                    },
                    manufacturer_statement: {
                        'zh-tw': "廠商對帳單",
                        en: "",
                        children: {

                        },

                    },
                    customer_statement: {
                        'zh-tw': "客戶對帳單",
                        en: "",
                        children: {

                        },

                    },
                },

            },
            report_management: {
                'zh-tw': '報表管理模組',
                en: "",
                children: {
                    accounts_payable: { // Title
                        'zh-tw': "應付帳款作業",
                        en: "",
                        children: {

                        },
                    },

                    accounts_receivable: {
                        'zh-tw': "應收帳款作業",
                        en: "",
                        children: {

                        },
                    },
                    manufacturer_statement: {
                        'zh-tw': "廠商對帳單",
                        en: "",
                        children: {

                        },

                    },
                    customer_statement: {
                        'zh-tw': "客戶對帳單",
                        en: "",
                        children: {

                        },

                    },
                },

            }
        },
    },
    prapo: {
        'zh-tw': '請採購管理系統',
        en: '',
        children: {
            basic_data_maintain_management: {
                'zh-tw': '基本資料維護模組',
                en: "Basic Data Maintain Management",
                children: {
                    j: { // Title
                        'zh-tw': "",
                        en: "",
                        children: {

                        },
                    },
                },
            },
            supplier_management: {
                'zh-tw': '供應商管理模組',
                en: "",
                children: {
                    j: { // Title
                        'zh-tw': "",
                        en: "",
                        children: {

                        },
                    },
                },
            },
            requisition_management: {
                'zh-tw': '請購管理模組',
                en: "",
                children: {
                    j: { // Title
                        'zh-tw': "",
                        en: "",
                        children: {

                        },
                    },
                },
            },
            purchasing_management: {
                'zh-tw': '採購管理模組',
                en: "",
                children: {
                    j: { // Title
                        'zh-tw': "",
                        en: "",
                        children: {

                        },
                    },
                },
            },
            electronic_signature: {
                'zh-tw': '線上簽核管理模組',
                en: "",
                children: {
                    j: { // Title
                        'zh-tw': "",
                        en: "",
                        children: {

                        },
                    },
                },
            },
            report_management: {
                'zh-tw': '報表管理模組',
                en: "",
                children: {
                    j: { // Title
                        'zh-tw': "",
                        en: "",
                        children: {

                        },
                    },
                },
            },
        },
    },
    oms: {
        'zh-tw': '報價訂單管理系統',
        en: '',
        children: {
            basic_data_maintain_management: {
                'zh-tw': '基本資料維護模組',
                en: "Basic Data Maintain Management",
                children: {
                    manufacturer_customer_data_maintenance: { // Title
                        'zh-tw': "廠商(客戶)資料維護",
                        en: "",
                        children: {

                        },
                    },
                    raw_material_data_maintenance: {
                        'zh-tw': "原物料資料維護",
                        en: "",
                        children: {

                        },
                    },
                },
            },

            online_quotation_management: {
                'zh-tw': '線上報價管理模組',
                en: "",
                children: {

                },
            },

            online_order_management: {
                'zh-tw': '線上訂單管理模組',
                en: "Basic Data Maintain Management",
                children: {

                },
            },
            report_management: {
                'zh-tw': '報表管理模組',
                en: "",
                children: {

                },
            },
        },
    },
    hrms: {
        'zh-tw': '人力資源管理系統',
        en: '',
        children: {
            basic_data_maintain_management: {
                'zh-tw': '基本資料維護模組',
                en: "Basic Data Maintain Management",
                children: {
                    organization_management: {
                        'zh-tw': '組織架構調整',
                        en: "Organization Management",
                    },
                    system_information: {
                        'zh-tw': '系統資訊',
                        en: "Syatem Information",
                    },
                    employee_management: {
                        'zh-tw': '員工基本資料維護',
                        en: "Employee Management",
                    },
                    department_management: {
                        'zh-tw': '部門基本資料維護',
                        en: "Department Management",
                    },
                    class_management: {
                        'zh-tw': '排班輪班表',
                        en: "Class ManageMent",
                    },
                    company_calendar: {
                        'zh-tw': '人事行事曆',
                        en: "Company Calendar",
                    },
                    talent_pool: {
                        'zh-tw': '人才庫',
                        en: "Talent Pool",
                    },
                    aptitude_test: {
                        'zh-tw': '性向測驗模組',
                        en: "Aptitude Test"
                    },
                    employee_search: {
                        'zh-tw': '查詢員工模組',
                        en: "Employee Search"
                    }
                },
            },
            recruitment_management: {
                'zh-tw': '人才招募管理模組',
                en: "Recruitment Management",
                children: {
                    internal_job_vacancy: {
                        'zh-tw': '徵才職缺內部提報',
                        en: "Internal Job Vacancy",
                    },
                    external_job_vacancy_management: {
                        'zh-tw': '對外徵才公告管理',
                        en: "External Job Vacancy Management",
                    },
                    resume_management: {
                        'zh-tw': '履歷表管理',
                        en: "Resume Management",
                    },
                    candidate_management: {
                        'zh-tw': '應聘者管理',
                        en: "Candidate Management",
                    },
                    interview_invitation_management: {
                        'zh-tw': '面試邀約管理',
                        en: "Interview Invitation Management",
                    },
                    interview_result_notification: {
                        'zh-tw': '面試結果通知',
                        en: "Interview Result Notification",
                    },
                },
            },
            talent_pool_managment: {
                'zh-tw': '人才庫管理模組',
                en: "Talent Pool Managment",
                children: {
                    talent_inventory: {
                        'zh-tw': '人才盤點',
                        en: "Talent Inventory",
                    },
                    orientation_training: {
                        'zh-tw': '職前培訓管理',
                        en: "Orientation Training",
                    },
                    skill_leadership_development: {
                        'zh-tw': '技能與領導力發展',
                        en: "Skill Leadership Development",
                    },
                },
            },
            punch_management: {
                'zh-tw': '打卡管理模組',
                en: "",
                children: {
                    work_hour: {
                        'zh-tw': '打卡記錄資料檔',
                        en: "Work Hour",
                    },
                    punch_in_and_out: {
                        'zh-tw': '線上打卡',
                        en: "Punch In And Out",
                    },
                    punch_record: {
                        'zh-tw': '卡鐘刷卡檔',
                        en: "Punch Record",
                    },
                    abnormal_status_query: {
                        'zh-tw': '異常狀況查詢',
                        en: "Abnormal Status Query",
                    },
                },
            },
            attendance_data_management: {
                'zh-tw': '考勤資料管理模組',
                en: "",
                children: {
                    leave_management: {
                        'zh-tw': '請假假別定義表',
                        en: "Leave Management",
                    },
                    leave_application: {
                        'zh-tw': '員工請假紀錄作業',
                        en: "Leave Application",
                    },
                    paid_vacation_setting: {
                        'zh-tw': '特休天數設定作業',
                        en: "Paid Vacation Setting",
                    },
                    late_and_early_record_management: {
                        'zh-tw': '遲到/早退紀錄管理',
                        en: "Late And Early Record Management",
                    },
                    overtime_record: {
                        'zh-tw': '加班工時紀錄作業',
                        en: "overtime_record",
                    },
                    annual_paid_vacation_management: {
                        'zh-tw': '年度特休管理作業',
                        en: "Annual Paid Vacation Management",
                    },
                    monthly_debit_management: {
                        'zh-tw': '每月借支管理',
                        en: "Monthly Debit Management",
                    },
                    reward_and_punishment_management: {
                        'zh-tw': '獎懲加扣點管理',
                        en: "Reward And Punishment Management",
                    },
                    overtime_to_vacation_management: {
                        'zh-tw': '加班轉補休管理',
                        en: "Overtime To Vacation Management",
                    },
                },
            },
            salary_management: {
                'zh-tw': '薪資管理模組',
                en: "Salary Management",
                children: {
                    salary_payment_creation: {
                        'zh-tw': '薪資給付項目建立作業',
                        en: "Salary Payment Creation",
                    },
                    salary_template_creation: {
                        'zh-tw': '薪資範本建立作業',
                        en: "Salary Template Creation",
                    },
                    monthly_salary_calculation: {
                        'zh-tw': '每月薪資計算作業',
                        en: "Monthly Salary Calculation",
                    },
                    bonus_calculation: {
                        'zh-tw': '獎金/節金計算作業',
                        en: "Bonus Calculation",
                    },
                    business_bank_account_overview: {
                        'zh-tw': '企業-銀行帳戶總覽',
                        en: "Business Bank Account Overview",
                    }, employee_bank_account_overview: {
                        'zh-tw': '員工-銀行帳戶總覽',
                        en: "Employee Bank Account Overview",
                    },
                },
            },
            comprehensive_income_tax_declaration: {
                'zh-tw': '綜合所得稅申報模組',
                en: "Comprehensive Income Tax Declaration",
                children: {
                    employee_salary_payslip: {
                        'zh-tw': '員工薪資單',
                        en: "Employee Salary Payslip"
                    },
                    employee_monthly_salary_payslip: {
                        'zh-tw': '每月薪資單',
                        en: "Employee Monthly Salary Payslip"
                    },
                },
            },
            labor_and_health_insurance_management: {
                'zh-tw': '勞健保管理模組',
                en: "Labor And Health Insurance Management",
                children: {
                    labor_and_health_insurance_maintenance_work: {
                        'zh-tw': '勞健保維護作業',
                        en: "Labor And Health Insurance Maintenance Work"
                    },

                },
            },
            report_management: {
                'zh-tw': '報表管理模組',
                en: "Report Management",
                children: {
                    attendance_record: {
                        'zh-tw': '員工刷卡/出勤明細表',
                        en: "Attendance Record",
                    },
                    overtime_statistical_table: {
                        'zh-tw': '加班統計表',
                        en: 'Overtime Statistical Table',
                    },
                    paid_vacation_statistical_table: {
                        'zh-tw': '特休統計表',
                        en: "Paid Vacation Statistical Table",
                    },
                    leave_and_absenteeism_statistical_table: {
                        'zh-tw': '請假曠職統計表',
                        en: "Leave And Absenteeism Statistical Table",
                    },
                    bank_salary_transfer_list: {
                        'zh-tw': '銀行薪資轉存清冊',
                        en: "Bank Salary Transfer List",
                    },
                    employee_salary_list: {
                        'zh-tw': '員工薪資清冊',
                        en: "Employee Salary List",
                    },
                    salary_and_bonus_receipt_list: {
                        'zh-tw': '薪資/津貼加班費印領清冊',
                        en: "Salary/Bonus Receipt List",
                    },
                    employee_salary_annual_summary: {
                        'zh-tw': '員工薪資年度總表',
                        en: "Employee Salary Annual Summary",
                    },
                    labor_health_insurance_receipt: {
                        'zh-tw': '勞健保繳費證明單',
                        en: "Labor Health Insurance Receipt",
                    },
                    withholding_tax_of_salary: {
                        'zh-tw': '薪資所得扣繳稅額表',
                        en: "Withholding Tax Of Salary",
                    },
                    position_level_report: {
                        'zh-tw': '職等統計表',
                        en: "Position Level Report",
                    },
                    labor_health_change_list: {
                        'zh-tw': '勞健保異動明細表',
                        en: "Labor Health Change List",
                    },
                    employee_certificate: {
                        'zh-tw': '在職證明單',
                        en: "Employee Certificate",
                    },
                    employment_separation_certificate: {
                        'zh-tw': '離職證明單',
                        en: "Employment Separation Certificate",
                    },
                    employee_seniority_statistical_table: {
                        'zh-tw': '員工年資統計表',
                        en: "Employee Seniority Statistical Table",
                    },
                    employee_age_statistical_table: {
                        'zh-tw': '員工年紀統計表',
                        en: "Employee Age Statistical Table",
                    },
                    employee_education_statistical_table: {
                        'zh-tw': '員工學歷統計表',
                        en: "Employee Education Statistical Table",
                    },
                },
            },
        }
    },
    ems: {
        'zh-tw': '教育管理系統',
        en: '',
        // children: {
        //     basic_data_maintain_management: {
        //         'zh-tw': '基本資料維護模組',
        //         en: "Basic Data Maintain Management",
        //         children: {
        //             StudentList: {
        //                 children: {
        //                     address: {
        //                         "zh-tw": "地址",
        //                         en: "address"
        //                     },
        //                     email: {
        //                         "zh-tw": "Email",
        //                         en: "email"
        //                     },
        //                     emergency_contact_phone_number: {
        //                         "zh-tw": "緊急聯絡電話",
        //                         en: "emergency_contact"
        //                     },
        //                     emergency_contact_name: {
        //                         "zh-tw": "緊急聯絡人",
        //                         en: "emergency_contact"
        //                     },
        //                     emergency_contact_email: {
        //                         "zh-tw": "緊急聯絡人信箱",
        //                         en: "emergency_contact_email"
        //                     },
        //                     emergency_contact_line_id: {
        //                         "zh-tw": "緊急聯絡人Line ID",
        //                         en: "emergency_contact_line_id"
        //                     },
        //                     relation_name: {
        //                         "zh-tw": "與學生關係",
        //                         en: "relation_name"
        //                     },
                            // grade_name: {
                            //     "zh-tw": "當前年級",
                            //     en: "grade_name"
                            // },
        //                     name: {
        //                         "zh-tw": "姓名",
        //                         en: "name"
        //                     },
                            // name_english: {
                            //     "zh-tw": "英文姓名",
                            //     en: "name_english"
                            // },
                            // note: {
                            //     "zh-tw": "備註",
                            //     en: "note"
                            // },
                            // birthday: {
                            //     "zh-tw": "出生日期(西元年)",
                            //     en: "birthday"
                            // },
                            // phone_home: {
                            //     "zh-tw": "聯絡電話(H)",
                            //     en: "phone_home"
                            // },
                            // line_id: {
                            //     "zh-tw": "Line ID",
                            //     en: "line_id"
                            // },
        //                     phone: {
        //                         "zh-tw": "手機號碼",
        //                         en: "phone"
        //                     },
                            // school: {
                            //     "zh-tw": "學校",
                            //     en: "school"
                            // },
                            // serial_name: {
                            //     "zh-tw": "學號",
                            //     en: "serial_name"
                            // },
                            // study_time_start: {
                            //     "zh-tw": "就學時間（起）",
                            //     en: "study_time_start"
                            // },
                            // study_time_end: {
                            //     "zh-tw": "就學時間（迄）",
                            //     en: "study_time_end"
                            // },
        //                     student_class: {
        //                         "zh-tw": "上課班級",
        //                         en: "student_class"
        //                     },
        //                     rfid: {
        //                         "zh-tw": "RFID code",
        //                         en: "RFID code"
        //                     },
                            // line_user_id: {
                            //     "zh-tw": "Line綁定",
                            //     en: "Line"
                            // },
        //                     line_notify_token: {
        //                         "zh-tw": "LineNotify綁定",
        //                         en: "LineNotify"
        //                     },
        //                     is_free_tuition: {
        //                         "zh-tw": "免學費",
        //                         en: "Free Tuition"
        //                     },
        //                     installment_count: {
        //                         "zh-tw": "分期期數",
        //                         en: "Installment Count"
        //                     },
        //                 },
        //             },
        //         }
        //     },
        //     image_promotion_management: {
        //         'zh-tw': '形象推廣管理模組',
        //         en: "Basic Data Maintain Management",
        //         children: {
        //         }
        //     },
        //     course_arrangement_management: {
        //         'zh-tw': '課程編排管理模組',
        //         en: "Basic Data Maintain Management",
        //         children: {
        //             AdminClassScheduling: {
        //                 children: {
        //                     name_serial: {
        //                         "zh-tw": "編號",
        //                         en: " Number"
        //                     },
        //                     class_name: {
        //                         "zh-tw": "班級名稱",
        //                         en: "Class Name"
        //                     },
        //                     lesson_name: {
        //                         "zh-tw": "課程名稱",
        //                         en: "Lesson Name"
        //                     },
        //                     environment_name: {
        //                         "zh-tw": "環境名稱",
        //                         en: "Environment Name"
        //                     },
        //                     admission_time: {
        //                         "zh-tw": "招生時間",
        //                         en: "Admission Time"
        //                     },
        //                     admission_amount: {
        //                         "zh-tw": "招生人數",
        //                         en: "Admission Amount"
        //                     },
        //                     lesson_time: {
        //                         "zh-tw": "授課時間",
        //                         en: "Lesson Time"
        //                     },
        //                     lesson_date: {
        //                         "zh-tw": "授課期間",
        //                         en: "Lesson Date"
        //                     },
        //                     lesson_teacher: {
        //                         "zh-tw": "授課老師",
        //                         en: "Lesson Teacher"
        //                     },
        //                     lesson_classroom: {
        //                         "zh-tw": "授課教室",
        //                         en: "Lesson Classroom"
        //                     },
        //                     class_status: {
        //                         "zh-tw": "招生狀態",
        //                         en: "Class Status"
        //                     },
        //                     add_lesson_schedule: {
        //                         "zh-tw": "新增課程編排",
        //                         en: "Add Lesson Schedule"
        //                     }
        //                 }
        //             }
        //         }
        //     },
        //     teaching_management: {
        //         'zh-tw': '授課管理模組',
        //         en: "Basic Data Maintain Management",
        //         children: {
        //         }
        //     },
        //     course_roll_call_management: {
        //         'zh-tw': '課程點名管理模組',
        //         en: "Basic Data Maintain Management",
        //         children: {
        //         }
        //     },
        //     leave_management: {
        //         'zh-tw': '請假管理模組',
        //         en: "Basic Data Maintain Management",
        //         children: {
        //         }
        //     },
        //     tuition_management: {
        //         'zh-tw': '學費管理模組',
        //         en: "Basic Data Maintain Management",
        //         children: {
        //         }
        //     },
        //     Common: {
        //         children: {
        //             add: {
        //                 'zh-tw': "新增",
        //                 en: "Add",
        //             },
        //             edit: {
        //                 'zh-tw': "編輯",
        //                 en: "Edit",
        //             },
        //             delete: {
        //                 'zh-tw': "刪除",
        //                 en: "Delete",
        //             },
        //             cancel: {
        //                 'zh-tw': "取消",
        //                 en: "Cancel",
        //             },
        //             sure: {
        //                 "zh-tw": "確定",
        //                 en: "Sure"
        //             },
        //             edit_success: {
        //                 'zh-tw': "修改成功",
        //                 en: "Edit Success",
        //             },
        //             edit_error: {
        //                 'zh-tw': "修改失敗",
        //                 en: "Edit Error",
        //             },
        //             add_success: {
        //                 'zh-tw': "新增成功",
        //                 en: "Add Success",
        //             },
        //             add_error: {
        //                 'zh-tw': "新增失敗",
        //                 en: "Add Error",
        //             },
        //             delete_error: {
        //                 'zh-tw': "刪除失敗",
        //                 en: "Delete Error",
        //             },
        //             delete_success: {
        //                 'zh-tw': "刪除成功",
        //                 en: "Delete Success",
        //             },
        //             control: {
        //                 "zh-tw": "操作",
        //                 en: "Operate"
        //             },
        //             sure_delete: {
        //                 "zh-tw": "確定要刪除嗎",
        //                 en: "Sure to delete"
        //             },
        //             multiple_delete: {
        //                 "zh-tw": '批次刪除',
        //                 en: "Multiple Delete"
        //             },
        //             export: {
        //                 "zh-tw": '匯出資料',
        //                 en: "Export Data"
        //             },
        //             write_complete: {
        //                 'zh-tw': "請完整填寫必填欄位",
        //                 en: "Please complete the required fields",
        //             },
        //         },
        //     }
        // },
        children: {
            basic_data_maintain_management: {
                'zh-tw': '基本資料維護模組',
                en: "Basic Data Maintain Management",
                children: {
                    StudentList: {
                        children: {
                            // std_number: {
                            //     "zh-tw": "學號",
                            //     en: "std_number"
                            // },
                            // name: {
                            //     "zh-tw": "姓名",
                            //     en: "name"
                            // },
                            // gender: {
                            //     "zh-tw": "性/別",
                            //     en: "gender"
                            // },
                            // county: {
                            //     "zh-tw": "居住縣市",
                            //     en: "county"
                            // },
                            // school_u_work_at: {
                            //     "zh-tw": "服務學校",
                            //     en: "school you work at"
                            // },
                            // phone: {
                            //     "zh-tw": "手機號碼",
                            //     en: "phone"
                            // },
                            // subject: {
                            //     "zh-tw": "任教科目",
                            //     en: "subject"
                            // },
                            // email: {
                            //     "zh-tw": "Email",
                            //     en: "email"
                            // },
                            // listening: {
                            //     "zh-tw": "聽",
                            //     en: "listening"
                            // },
                            speaking: {
                                "zh-tw": "說",
                                en: "speaking"
                            },
                            reading: {
                                "zh-tw": "讀",
                                en: "reading"
                            },
                            // writing: {
                            //     "zh-tw": "寫",
                            //     en: "writing"
                            // },
                            // note: {
                            //     "zh-tw": "備註",
                            //     en: "note"
                            // },
                            address: {
                                "zh-tw": "寫",
                                en: "writing"
                            },
                            email: {
                                "zh-tw": "E-mail",
                                en: "email"
                            },
                            emergency_contact_phone_number: {
                                "zh-tw": "緊急聯絡電話",
                                en: "emergency_contact"
                            },
                            emergency_contact_name: {
                                "zh-tw": "緊急聯絡人",
                                en: "emergency_contact"
                            },
                            emergency_contact_email: {
                                "zh-tw": "緊急聯絡人信箱",
                                en: "emergency_contact_email"
                            },
                            emergency_contact_line_id: {
                                "zh-tw": "緊急聯絡人Line ID",
                                en: "emergency_contact_line_id"
                            },
                            relation_name: {
                                "zh-tw": "與學生關係",
                                en: "relation_name"
                            },
                            grade_name: {
                                "zh-tw": "性/別",
                                en: "gender"
                            },
                            name: {
                                "zh-tw": "姓名",
                                en: "name"
                            },
                            name_english: {
                                "zh-tw": "任教科目",
                                en: "subject"
                            },
                            note: {
                                "zh-tw": "備註",
                                en: "note"
                            },
                            birthday: {
                                "zh-tw": "居住縣市",
                                en: "county"
                            },
                            phone_home: {
                                "zh-tw": "聽",
                                en: "listening"
                            },
                            line_id: {
                                "zh-tw": "Line ID",
                                en: "line_id"
                            },
                            phone: {
                                "zh-tw": "手機號碼",
                                en: "phone"
                            },
                            school: {
                                "zh-tw": "服務學校",
                                en: "school"
                            },
                            serial_name: {
                                "zh-tw": "學號",
                                en: "serial_name"
                            },
                            // study_time_start: {
                            //     "zh-tw": "說",
                            //     en: "speaking"
                            // },
                            // study_time_end: {
                            //     "zh-tw": "讀",
                            //     en: "reading"
                            // },
                            student_class: {
                                "zh-tw": "上課班級",
                                en: "student_class"
                            },
                            rfid: {
                                "zh-tw": "RFID code",
                                en: "RFID code"
                            },
                            line_user_id: {
                                "zh-tw": "Line綁定",
                                en: "Line"
                            },
                            line_notify_token: {
                                "zh-tw": "LineNotify綁定",
                                en: "LineNotify"
                            },
                            is_free_tuition: {
                                "zh-tw": "班別",
                                en: "Class"
                            },
                            installment_count: {
                                "zh-tw": "分期期數",
                                en: "Installment Count"
                            },
        
        
        
                        },
                    },
                    TeacherList:{
                        children:{
                            name: {
                                "zh-tw": "姓名",
                                en: "name"
                            },
                            school_u_work: {
                                "zh-tw": "任教系所(單位)",
                                en: "school_u_work"
                            },
                            expersite: {
                                "zh-tw": "聯絡電話",
                                en: "phone(H)"
                            },
                            email: {
                                "zh-tw": "E-mail",
                                en: "email"
                            },
                            phone: {
                                "zh-tw": "手機",
                                en: "cellphone"
                            },
                            note: {
                                "zh-tw": "備註",
                                en: "note"
                            },
                        },
                    },
                    AdministrationList:{
                        children:{
                            name: {
                                "zh-tw": "姓名",
                                en: "name"
                            },
                            school_u_work: {
                                "zh-tw": "任教系所(單位)",
                                en: "school_u_work"
                            },
                            position: {
                                "zh-tw": "聯絡電話",
                                en: "phone(H)"
                            },
                            email: {
                                "zh-tw": "E-mail",
                                en: "email"
                            },
                            position_work: {
                                "zh-tw": "手機",
                                en: "cellphone"
                            },
                            note: {
                                "zh-tw": "備註說明",
                                en: "note"
                            },

                        },
                    },
                },
            },
            image_promotion_management: {
                'zh-tw': '形象推廣管理模組',
                en: "Basic Data Maintain Management",
                children: {
                }
            },
            course_arrangement_management: {
                'zh-tw': '課程編排管理模組',
                en: "Basic Data Maintain Management",
                children: {
                    AdminClassScheduling: {
                        children: {
                            name_serial: {
                                "zh-tw": "編號",
                                en: " Number"
                            },
                            class_name: {
                                "zh-tw": "班級名稱",
                                en: "Class Name"
                            },
                            lesson_name: {
                                "zh-tw": "課程名稱",
                                en: "Lesson Name"
                            },
                            environment_name: {
                                "zh-tw": "環境名稱",
                                en: "Environment Name"
                            },
                            admission_time: {
                                "zh-tw": "招生時間",
                                en: "Admission Time"
                            },
                            admission_amount: {
                                "zh-tw": "招生人數",
                                en: "Admission Amount"
                            },
                            lesson_time: {
                                "zh-tw": "授課時間",
                                en: "Lesson Time"
                            },
                            lesson_date: {
                                "zh-tw": "授課期間",
                                en: "Lesson Date"
                            },
                            lesson_teacher: {
                                "zh-tw": "授課老師",
                                en: "Lesson Teacher"
                            },
                            lesson_classroom: {
                                "zh-tw": "授課教室",
                                en: "Lesson Classroom"
                            },
                            class_status: {
                                "zh-tw": "招生狀態",
                                en: "Class Status"
                            },
                            add_lesson_schedule: {
                                "zh-tw": "新增課程編排",
                                en: "Add Lesson Schedule"
                            }
                        }
                    }
                }
            },
            teaching_management: {
                'zh-tw': '授課管理模組',
                en: "Basic Data Maintain Management",
                children: {
                }
            },
            course_roll_call_management: {
                'zh-tw': '課程點名管理模組',
                en: "Basic Data Maintain Management",
                children: {
                }
            },
            leave_management: {
                'zh-tw': '請假管理模組',
                en: "Basic Data Maintain Management",
                children: {
                }
            },
            tuition_management: {
                'zh-tw': '學費管理模組',
                en: "Basic Data Maintain Management",
                children: {
                }
            },
            Common: {
                children: {
                    add: {
                        'zh-tw': "新增",
                        en: "Add",
                    },
                    edit: {
                        'zh-tw': "編輯",
                        en: "Edit",
                    },
                    delete: {
                        'zh-tw': "刪除",
                        en: "Delete",
                    },
                    cancel: {
                        'zh-tw': "取消",
                        en: "Cancel",
                    },
                    sure: {
                        "zh-tw": "確定",
                        en: "Sure"
                    },
                    edit_success: {
                        'zh-tw': "修改成功",
                        en: "Edit Success",
                    },
                    edit_error: {
                        'zh-tw': "修改失敗",
                        en: "Edit Error",
                    },
                    add_success: {
                        'zh-tw': "新增成功",
                        en: "Add Success",
                    },
                    add_error: {
                        'zh-tw': "新增失敗",
                        en: "Add Error",
                    },
                    delete_error: {
                        'zh-tw': "刪除失敗",
                        en: "Delete Error",
                    },
                    delete_success: {
                        'zh-tw': "刪除成功",
                        en: "Delete Success",
                    },
                    control: {
                        "zh-tw": "操作",
                        en: "Operate"
                    },
                    sure_delete: {
                        "zh-tw": "確定要刪除嗎",
                        en: "Sure to delete"
                    },
                    multiple_delete: {
                        "zh-tw": '批次刪除',
                        en: "Multiple Delete"
                    },
                    export: {
                        "zh-tw": '匯出資料',
                        en: "Export Data"
                    },
                    write_complete: {
                        'zh-tw': "請完整填寫必填欄位",
                        en: "Please complete the required fields",
                    },
                },
            }
        },
    },
    cramschool: {
        children: {
            home: {
                'zh-tw': "首頁",
                en: "Main Page",
                children: {
                    annoucement_time: {
                        'zh-tw': "發布日期",
                        en: "Annoucement Date",
                    },
                    "title": {
                        'zh-tw': "標題",
                        en: "Title",
                    },
                    "content": {
                        'zh-tw': "內容",
                        en: "Content",
                    },
                    "more_content": {
                        'zh-tw': "更多內容",
                        en: "More",
                    },
                    lesson_category: {
                        'zh-tw': "我們的課程",
                        en: "Our Course",
                    },
                    news: {
                        'zh-tw': "最新消息",
                        en: "Latest News",
                    },
                    tidbits: {
                        'zh-tw': "智慧管理",
                        en: "Class Tidbits",
                    },
                    environment: {
                        'zh-tw': "環境介紹",
                        en: "Environment Introduction",
                    },
                    teachers: {
                        'zh-tw': "師資介紹",
                        en: "Teachers Introduction",
                    },
                    appointment: {
                        'zh-tw': "填單預約",
                        en: "Fill out an appointment",
                    },
                    click_time: {
                        'zh-tw': "點擊次數",
                        en: "Click Time",
                    },
                    visit_time: {
                        'zh-tw': "訪客人次",
                        en: " Visit Time",
                    },
                    show_more: {
                        'zh-tw': "查看更多",
                        en: " Show More",
                    },
                    block_show: {
                        'zh-tw': "編輯區塊顯示和順序",
                        en: "Edit Block display and Order",
                    },
                    block: {
                        'zh-tw': "編輯區塊",
                        en: "Edit Block",
                    },
                    show_or_not: {
                        'zh-tw': "是否顯示",
                        en: "Show/Not Show",
                    },
                    drag: {
                        'zh-tw': "請拖拉進行排序",
                        en: "Please drag item and order",
                    }
                }
            },
            News: {
                children: {
                    add_news: {
                        'zh-tw': "新增貼文",
                        en: "Add News",
                    },
                    edit_news: {
                        'zh-tw': "修改貼文",
                        en: "Edit News",
                    }
                },
            },
            ClassIntroduce: {
                children: {
                    classintroduce: {
                        'zh-tw': "課程分類",
                        en: "Lesson Category",
                    },
                }
            },
            Class: {
                children: {
                    add_class: {
                        'zh-tw': "新增花絮",
                        en: "Add Tidbits",
                    },
                    edit_class: {
                        'zh-tw': "修改花絮",
                        en: "Edit Tidbits",
                    }
                },
            },
            Environment: {
                children: {
                    add_environment: {
                        'zh-tw': "新增環境介紹",
                        en: "Add Environment Introduce",
                    }
                }
            },
            Lesson: {
                children: {
                    add_lesson: {
                        'zh-tw': "新增課程",
                        en: "Add Lesson",
                    },
                    edit_lesson: {
                        'zh-tw': "編輯課程",
                        en: "Edit Lesson",
                    }
                }
            },
            Route: {
                children: {
                    home: {
                        'zh-tw': "MERCY-形象網站",
                        en: "MERCY-Home",
                    },
                    news: {
                        'zh-tw': "MERCY-最新消息",
                        en: "MERCY-News",
                    },
                    class_introduce: {
                        'zh-tw': "MERCY-課程簡介",
                        en: "MERCY-Class Introduce",
                    },
                    class: {
                        'zh-tw': "MERCY-上課花絮",
                        en: "MERCY-Tidbits",
                    },
                    environment: {
                        'zh-tw': "MERCY-環境介紹",
                        en: "MERCY-Environemnt",
                    },
                    sharelearning: {
                        'zh-tw': "MERCY-學習見證分享",
                        en: "MERCY-Share Learning",
                    },
                    videowatch: {
                        'zh-tw': "MERCY-影片分享區",
                        en: "MERCY-Video Share",
                    },
                    teachers: {
                        'zh-tw': "MERCY-師資介紹",
                        en: "MERCY-Teachers Introduce",
                    },
                    aboutMercy: {
                        'zh-tw': "MERCY-關於Mercy",
                        en: "MERCY-About Mercy",
                    },
                    appointment: {
                        'zh-tw': "MERCY-填單預約",
                        en: "MERCY-Appointment",
                    },
                    enroll: {
                        'zh-tw': "MERCY-報名課程",
                        en: "MERCY-Enroll",
                    },
                    newcourse: {
                        'zh-tw': "MERCY-開課資訊",
                        en: "MERCY-New Course",
                    }
                }
            },
            Button: {
                children: {
                    home: {
                        'zh-tw': "形象網站",
                        en: "Home",
                    },
                    news: {
                        'zh-tw': "最新消息",
                        en: "News",
                    },
                    class_introduce: {
                        'zh-tw': "課程簡介",
                        en: "Class Introduce",
                    },
                    class: {
                        'zh-tw': "上課花絮",
                        en: "Tidbits",
                    },
                    environment: {
                        'zh-tw': "環境介紹",
                        en: "Environemnt",
                    },
                    sharelearning: {
                        'zh-tw': "學習見證分享",
                        en: "Share Learning",
                    },
                    videowatch: {
                        'zh-tw': "影片分享區",
                        en: "Video Share",
                    },
                    teachers: {
                        'zh-tw': "師資介紹",
                        en: "Teachers Introduce",
                    },
                    aboutMercy: {
                        'zh-tw': "關於Mercy",
                        en: "About Mercy",
                    },
                    appointment: {
                        'zh-tw': "填單預約",
                        en: "Appointment",
                    },
                    enroll: {
                        'zh-tw': "報名課程",
                        en: "Enroll",
                    },
                    newcourse: {
                        'zh-tw': "開課資訊",
                        en: "New Course",
                    },
                    copyright: {
                        'zh-tw': "Copyright ©2023 澄欣科技製作",
                        en: "Copyright ©2023 Orange Tec make",
                    },
                    change: {
                        'zh-tw': "切換為",
                        en: "Change to",
                    },
                    smartphone: {
                        'zh-tw': "手機版",
                        en: "Smartphone version",
                    },
                    computer: {
                        'zh-tw': "電腦版",
                        en: "Computer version",
                    }
                }
            },
            Common: {
                children: {
                    back: {
                        'zh-tw': "回到後台",
                        en: "Back to Admin",
                    },
                    learn_more: {
                        'zh-tw': "了解更多",
                        en: "Learn More",
                    },
                    appointment: {
                        'zh-tw': "填單預約",
                        en: "Appointment",
                    },
                    enrolling: {
                        'zh-tw': "招生中",
                        en: "Enrolling",
                    },
                    add: {
                        'zh-tw': "新增",
                        en: "Add",
                    },
                    edit: {
                        'zh-tw': "修改",
                        en: "Edit",
                    },
                    Cancel: {
                        'zh-tw': "取消",
                        en: "Cancel",
                    },
                    edit_success: {
                        'zh-tw': "修改成功",
                        en: "Edit Success",
                    },
                    edit_error: {
                        'zh-tw': "修改失敗",
                        en: "Edit Error",
                    },
                    add_success: {
                        'zh-tw': "新增成功",
                        en: "Add Success",
                    },
                    add_error: {
                        'zh-tw': "新增失敗",
                        en: "Add Error",
                    },
                    delete_error: {
                        'zh-tw': "刪除失敗",
                        en: "Delete Error",
                    },
                    delete_success: {
                        'zh-tw': "刪除成功",
                        en: "Delete Success",
                    },
                    old_new: {
                        'zh-tw': "由舊-新",
                        en: "From old to new",
                    },
                    new_old: {
                        'zh-tw': "由新-舊",
                        en: "From new to old",
                    },
                },
            }
        }

    },
    iTeach: {
        children: {
            home: {
                'zh-tw': "首頁",
                en: "Main Page",
                children: {
                    lesson_category: {
                        'zh-tw': "我們的課程",
                        en: "Our Course",
                    },
                    news: {
                        'zh-tw': "最新消息",
                        en: "Latest News",
                    },
                    tidbits: {
                        'zh-tw': "上課花絮",
                        en: "Class Tidbits",
                    },
                    environment: {
                        'zh-tw': "環境介紹",
                        en: "Environment Introduction",
                    },
                    teachers: {
                        'zh-tw': "師資介紹",
                        en: "Teachers Introduction",
                    },
                    appointment: {
                        'zh-tw': "填單預約",
                        en: "Fill out an appointment",
                    },
                    click_time: {
                        'zh-tw': "點擊次數",
                        en: "Click Time",
                    },
                    visit_time: {
                        'zh-tw': "訪客人次",
                        en: " Visit Time",
                    },
                    show_more: {
                        'zh-tw': "查看更多",
                        en: " Show More",
                    },
                    block_show: {
                        'zh-tw': "編輯區塊顯示和順序",
                        en: "Edit Block display and Order",
                    },
                    block: {
                        'zh-tw': "編輯區塊",
                        en: "Edit Block",
                    },
                    show_or_not: {
                        'zh-tw': "是否顯示",
                        en: "Show/Not Show",
                    },
                    drag: {
                        'zh-tw': "請拖拉進行排序",
                        en: "Please drag item and order",
                    }
                }
            },
            News: {
                children: {
                    add_news: {
                        'zh-tw': "新增貼文",
                        en: "Add News",
                    },
                    edit_news: {
                        'zh-tw': "修改貼文",
                        en: "Edit News",
                    }
                },
            },
            ClassIntroduce: {
                children: {
                    classintroduce: {
                        'zh-tw': "課程分類",
                        en: "Lesson Category",
                    },
                }
            },
            Class: {
                children: {
                    add_class: {
                        'zh-tw': "新增花絮",
                        en: "Add Tidbits",
                    },
                    edit_class: {
                        'zh-tw': "修改花絮",
                        en: "Edit Tidbits",
                    }
                },
            },
            Environment: {
                children: {
                    add_environment: {
                        'zh-tw': "新增環境介紹",
                        en: "Add Environment Introduce",
                    }
                }
            },
            Lesson: {
                children: {
                    add_lesson: {
                        'zh-tw': "新增課程",
                        en: "Add Lesson",
                    },
                    edit_lesson: {
                        'zh-tw': "編輯課程",
                        en: "Edit Lesson",
                    }
                }
            },
            Route: {
                children: {
                    home: {
                        'zh-tw': "MERCY-形象網站",
                        en: "MERCY-Home",
                    },
                    news: {
                        'zh-tw': "MERCY-最新消息",
                        en: "MERCY-News",
                    },
                    class_introduce: {
                        'zh-tw': "MERCY-課程簡介",
                        en: "MERCY-Class Introduce",
                    },
                    class: {
                        'zh-tw': "MERCY-上課花絮",
                        en: "MERCY-Tidbits",
                    },
                    environment: {
                        'zh-tw': "MERCY-環境介紹",
                        en: "MERCY-Environemnt",
                    },
                    sharelearning: {
                        'zh-tw': "MERCY-學習見證分享",
                        en: "MERCY-Share Learning",
                    },
                    videowatch: {
                        'zh-tw': "MERCY-影片分享區",
                        en: "MERCY-Video Share",
                    },
                    teachers: {
                        'zh-tw': "MERCY-師資介紹",
                        en: "MERCY-Teachers Introduce",
                    },
                    aboutMercy: {
                        'zh-tw': "MERCY-關於Mercy",
                        en: "MERCY-About Mercy",
                    },
                    appointment: {
                        'zh-tw': "MERCY-填單預約",
                        en: "MERCY-Appointment",
                    },
                    enroll: {
                        'zh-tw': "MERCY-報名課程",
                        en: "MERCY-Enroll",
                    },
                    newcourse: {
                        'zh-tw': "MERCY-開課資訊",
                        en: "MERCY-New Course",
                    }
                }
            },
            Button: {
                children: {
                    home: {
                        'zh-tw': "形象網站",
                        en: "Home",
                    },
                    news: {
                        'zh-tw': "最新消息",
                        en: "News",
                    },
                    class_introduce: {
                        'zh-tw': "課程簡介",
                        en: "Class Introduce",
                    },
                    class: {
                        'zh-tw': "上課花絮",
                        en: "Tidbits",
                    },
                    environment: {
                        'zh-tw': "環境介紹",
                        en: "Environemnt",
                    },
                    sharelearning: {
                        'zh-tw': "學習見證分享",
                        en: "Share Learning",
                    },
                    videowatch: {
                        'zh-tw': "影片分享區",
                        en: "Video Share",
                    },
                    teachers: {
                        'zh-tw': "師資介紹",
                        en: "Teachers Introduce",
                    },
                    aboutMercy: {
                        'zh-tw': "關於Mercy",
                        en: "About Mercy",
                    },
                    appointment: {
                        'zh-tw': "填單預約",
                        en: "Appointment",
                    },
                    enroll: {
                        'zh-tw': "報名課程",
                        en: "Enroll",
                    },
                    newcourse: {
                        'zh-tw': "開課資訊",
                        en: "New Course",
                    },
                    copyright: {
                        'zh-tw': "Copyright ©2023 澄欣科技製作",
                        en: "Copyright ©2023 Orange Tec make",
                    },
                    change: {
                        'zh-tw': "切換為",
                        en: "Change to",
                    },
                    smartphone: {
                        'zh-tw': "手機版",
                        en: "Smartphone version",
                    },
                    computer: {
                        'zh-tw': "電腦版",
                        en: "Computer version",
                    }
                }
            },
            Common: {
                children: {
                    back: {
                        'zh-tw': "回到後台",
                        en: "Back to Admin",
                    },
                    learn_more: {
                        'zh-tw': "了解更多",
                        en: "Learn More",
                    },
                    appointment: {
                        'zh-tw': "填單預約",
                        en: "Appointment",
                    },
                    enrolling: {
                        'zh-tw': "招生中",
                        en: "Enrolling",
                    },
                    add: {
                        'zh-tw': "新增",
                        en: "Add",
                    },
                    edit: {
                        'zh-tw': "修改",
                        en: "Edit",
                    },
                    Cancel: {
                        'zh-tw': "取消",
                        en: "Cancel",
                    },
                    edit_success: {
                        'zh-tw': "修改成功",
                        en: "Edit Success",
                    },
                    edit_error: {
                        'zh-tw': "修改失敗",
                        en: "Edit Error",
                    },
                    add_success: {
                        'zh-tw': "新增成功",
                        en: "Add Success",
                    },
                    add_error: {
                        'zh-tw': "新增失敗",
                        en: "Add Error",
                    },
                    delete_error: {
                        'zh-tw': "刪除失敗",
                        en: "Delete Error",
                    },
                    delete_success: {
                        'zh-tw': "刪除成功",
                        en: "Delete Success",
                    },
                    old_new: {
                        'zh-tw': "由舊-新",
                        en: "From old to new",
                    },
                    new_old: {
                        'zh-tw': "由新-舊",
                        en: "From new to old",
                    },
                },
            }
        }

    },
    utility: {
        children: {
            RowCol : {
                'zh-tw': "未分類",
                en: "",
            },
            undefined: {
                'zh-tw': "未分類",
                en: "",
            },
            layout: {
                'zh-tw': "未分類",
                en: "",
                children: {
                    start_chat: {
                        'zh-tw': "開始聊天",
                        en: "",
                    },
                    function_description: {
                        'zh-tw': "功能說明",
                        en: "",
                    },
                    operation_description: {
                        'zh-tw': "操作說明",
                        en: "",
                    },
                    next_step: {
                        'zh-tw': "下一步",
                        en: "",
                    },
                    previos_step: {
                        'zh-tw': "上一步",
                        en: "",
                    },
                    chatroom: {
                        'zh-tw': "聊天室",
                        en: "",
                    },
                    feedback: {
                        'zh-tw': "意見回饋",
                        en: "",
                    },
                    start_chat: {
                        'zh-tw': "立即展開交流！",
                        en: "",
                    },
                    function_tour: {
                        'zh-tw': "功能導覽",
                        en: "",
                    },

                    import: {
                        'zh-tw': '匯入資料',
                        en: 'Import Data',
                        children: {
                            sample: {
                                'zh-tw': '下載範例',
                                en: 'Download Sample'
                            },
                            upload: {
                                'zh-tw': '上傳Excel檔案',
                                en: 'Upload Excel File'
                            },
                            preview: {
                                'zh-tw': '預覽檔案',
                                en: 'Preview File'
                            },
                            finish: {
                                'zh-tw': '確認匯入',
                                en: 'Confirm'
                            },
                            close: {
                                'zh-tw': '關閉',
                                en: 'Close'
                            },
                            table_column_name: {
                                'zh-tw': '名稱',
                                en: 'Name'
                            },
                        }
                    },
                }
            },
            report: {
                'zh-tw': "營運戰情室",
                en: "",
                children: {
                    generator: {
                        'zh-tw': "欄位指定分析(表格、圖表)",
                        en: "",
                    },
                    situation_room: {
                        'zh-tw': "戰情室",
                        en: "",
                    },
                    column: {
                        'zh-tw': "欄位指定分析(表格、圖表)",
                        en: "",
                    },
                    vague: {
                        'zh-tw': "模糊維度分析",
                        en: "",
                    },
                    association: {
                        'zh-tw': "關聯生成式分析",
                        en: "",
                    },
                }
            }
        }
    },
    offcial_web: {
        'zh-tw': "公司網頁預覽",
        en: "Production Management System",
        children: {
            meeting: {
                'zh-tw': "公司網頁預覽",
                en: "Production Management System",
                children: {
                    MeetMainPage: {
                        'zh-tw': "會議主頁",
                        en: "",
                    },
                    New_meeting: {
                        'zh-tw': "會議設定",
                        en: "",
                    },
                    Meeting_information: {
                        'zh-tw': "會議資訊",
                        en: "",
                    },
                    MeetEdit: {
                        'zh-tw': "會議編輯",
                        en: "",
                    },

                },
            },
            crm: {
                'zh-tw': "客戶關係管理",
                en: "Production Management System",
                children: {
                    Chat: {
                        'zh-tw': "聊天室",
                        en: "",
                    },
                    ChatForm: {
                        'zh-tw': "線上回饋表單",
                        en: "",
                    },
                }
            },
            accounting: {
                'zh-tw': "財務會計",
                en: "Production Management System",
                children: {
                    basic_data_maintain_management: {
                        'zh-tw': "財務",
                        en: "",
                    },
                }
            },
            projectManage: {
                'zh-tw': "公司網頁預覽",
                en: "Production Management System",
                children: {
                    MeetMainPage: {
                        'zh-tw': "會議主頁",
                        en: "",
                    },
                    New_meeting: {
                        'zh-tw': "會議設定",
                        en: "",
                    },
                    Meeting_information: {
                        'zh-tw': "會議資訊",
                        en: "",
                    },
                    MeetEdit: {
                        'zh-tw': "會議編輯",
                        en: "",
                    },

                },
            },
        }
    },
    component: {
        'zh-tw': "元件",
        en: "Component",
        children: {
            Customer: {
                'zh-tw': "客戶管理",
                en: "",
                children: {
                    name: {
                        'zh-tw': '客戶名稱',
                    },
                    gender: {
                        'zh-tw': '性別',
                    },
                    age: {
                        'zh-tw': '年齡區間',
                    },
                    city: {
                        'zh-tw': '城市',
                    },
                    revenue_count: {
                        'zh-tw': '消費次數',
                    },
                    revenue_amount: {
                        'zh-tw': '消費金額',
                    },
                    category: {
                        'zh-tw': '類別',
                    },
                    hashtags: {
                        'zh-tw': '標籤',
                    },
                    cellphone: {
                        'zh-tw': '手機',
                    },
                    send_coupon: {
                        'zh-tw': "點我發送",
                        en: "",
                        children: {
                        }
                    }
                }
            },
            Common: {
                children: {
                    back: {
                        'zh-tw': "回到後台",
                        en: "Back to Admin",
                    },
                    learn_more: {
                        'zh-tw': "了解更多",
                        en: "Learn More",
                    },
                    enrolling: {
                        'zh-tw': "招生中",
                        en: "Enrolling",
                    },
                },
            },
            schedule_timeline_adjustment: {
                'zh-tw': '排程調整',
                en: 'Schedule Timeline Adjustment',
                children: {
                    operation: {
                        "zh-tw": "操作",
                        en: "operation",
                        children: {
                            search: {
                                "zh-tw": "搜尋",
                                en: "search",
                                children: {
                                    select_searching_time: {
                                        "zh-tw": "選擇查詢時間",
                                        en: "Select Searching Time"
                                    },
                                    search_button: {
                                        "zh-tw": "查詢",
                                        en: "Search"
                                    }
                                }
                            }
                        }
                    },
                    calendar_timeline: {
                        "zh-tw": "排程時程表",
                        en: "Calendar Timeline",
                        children: {
                            pms_popconfirm: {
                                "zh-tw": "顯示框",
                                en: "Process Popconfirm",
                                children: {
                                    popconfirm_title: {
                                        "zh-tw": "製程資訊",
                                        en: "Process Information"
                                    },
                                    card_title: {
                                        "zh-tw": "製程名稱",
                                        en: "Process Name"
                                    },
                                    card_process_start_time: {
                                        "zh-tw": "製程開始時間",
                                        en: "Process Start Time"
                                    },
                                    card_process_end_time: {
                                        "zh-tw": "製程結束時間",
                                        en: "Process End Time"
                                    },
                                    card_selection: {
                                        "zh-tw": "選擇欲排入製程之機台",
                                        en: "Please select the machine that you willing to arrange process loading"
                                    },
                                    card_input_addonAfter: {
                                        "zh-tw": "小時",
                                        en: "hour(s)"
                                    },
                                    card_input_placeholder: {
                                        "zh-tw": "欲排入幾小時？",
                                        en: "Hour(s) willing to arrange for machine"
                                    },
                                    card_remark: {
                                        "zh-tw": "＊＊按下確認將製程排入所選機台",
                                        en: "＊＊Press confirm button to arrange process for machine"
                                    },
                                    ok_text: {
                                        "zh-tw": "確認",
                                        en: "Confirm"
                                    },
                                    cancel_text: {
                                        "zh-tw": "取消",
                                        en: "Cancel"
                                    }
                                }
                            }
                        }
                    },
                    schedule_timeline: {
                        "zh-tw": "排程總攬",
                        en: "Schedule Timeline",
                        children: {
                            pms_machine_carousel: {
                                "zh-tw": "機台資訊跑馬燈",
                                en: "Information Carousel For Machine",
                                children: {
                                    card_title: {
                                        "zh-tw": "機台派工",
                                        en: "Machine Dispatching"
                                    },
                                    card_descriptions_title_crew: {
                                        "zh-tw": "機台組員：",
                                        en: "Machine Crew："
                                    },
                                    card_descriptions_title_loading: {
                                        "zh-tw": "機台負載：",
                                        en: "Loading："
                                    },
                                    card_descriptions_title_team_leader: {
                                        "zh-tw": "組長名稱：",
                                        en: "Team Leader："
                                    },
                                    current_day: {
                                        "zh-tw": "當天",
                                        en: "Current Day"
                                    },
                                    three_day: {
                                        "zh-tw": "三天",
                                        en: "Three Day"
                                    },
                                    five_day: {
                                        "zh-tw": "五天",
                                        en: "Five Day"
                                    },
                                    a_week: {
                                        "zh-tw": "一週",
                                        en: "A Week"
                                    },
                                    loading_chart_time_display: {
                                        "zh-tw": "機台 Loading chart 時間呈現",
                                        en: "Time Display For Loading Chart"
                                    },
                                }
                            },
                            pms_notification: {
                                "zh-tw": "通知",
                                en: "Notification",
                                children: {
                                    message: {
                                        "zh-tw": "修改完成",
                                        en: "Update Finished"
                                    },
                                    description: {
                                        "zh-tw": "組長可進行機台派工或是重新排程！",
                                        en: "Team leader can dispatch or rearrange process for machine now！"
                                    }
                                }
                            },
                            timeline_dragging: {
                                "zh-tw": "當前拖曳時間點(方框之開始時間點)",
                                en: "Current Dragging Time (Item's Start Time)",
                                children: {
                                }
                            },
                            timeline_that_has_most_items_group: {
                                "zh-tw": "時間區段內擁有最多排程之組別",
                                en: "Group(s) that has(have) the most items in timeline",
                                children: {
                                }
                            },
                            timeline_that_has_most_items_group_description: {
                                "zh-tw": "總排程數",
                                en: "Total items amount",
                                children: {
                                }
                            },
                            confirm_update_button: {
                                "zh-tw": "確定完成排程",
                                en: "Confirm Finishing Process arrangement",
                                children: {
                                }
                            },
                            badge_ribbon: {
                                "zh-tw": "說明框",
                                en: "Explanation Card",
                                children: {
                                    manual: {
                                        "zh-tw": "使用說明",
                                        en: "Manual",
                                        children: {
                                            title: {
                                                "zh-tw": "使用說明",
                                                en: "Manual"
                                            },
                                            card_title: {
                                                "zh-tw": "排程工具",
                                                en: "Schedule Arrange Tool"
                                            },
                                            card_descriptions_item: {
                                                "zh-tw": "詳細說明",
                                                en: "Description Detail",
                                                children: {
                                                    time_zooming_label: {
                                                        "zh-tw": "-時間縮放",
                                                        en: "-Time Zooming"
                                                    },
                                                    time_zooming_content: {
                                                        "zh-tw": "滑鼠滾輪滑動以做縮放",
                                                        en: "Scroll the mouse for time zooming"
                                                    },
                                                    time_checking_label: {
                                                        "zh-tw": "-時間查看",
                                                        en: "-Time Checking"
                                                    },
                                                    time_checking_content: {
                                                        "zh-tw": "滑鼠按住空白處並且左右滑動",
                                                        en: "Click the empty space and slide left or right the mouse"
                                                    },
                                                    process_adjustment_label: {
                                                        "zh-tw": "-製程調整",
                                                        en: "-Process Adjustment"
                                                    },
                                                    process_adjustment_content: {
                                                        "zh-tw": "點擊製程，滑鼠按住製程方框右方邊界並左右滑動",
                                                        en: "Click the process item, and then click down item right side and slide left or right the mouse"
                                                    },
                                                    process_order_label: {
                                                        "zh-tw": "-製程順序",
                                                        en: "-Process Order"
                                                    },
                                                    process_order_content: {
                                                        "zh-tw": "點擊製程，滑鼠按住製程方框並左右滑動",
                                                        en: "Click the process item, and then click down item and slide left or right the mouse"
                                                    },
                                                    process_detail_label: {
                                                        "zh-tw": "-製程詳細資訊",
                                                        en: "-Process Detail"
                                                    },
                                                    process_detail_content: {
                                                        "zh-tw": "點擊製程名稱",
                                                        en: "Click the process item tilt"
                                                    },
                                                    machine_loading_searching_label: {
                                                        "zh-tw": "-機台 Loading 查詢",
                                                        en: "-Process Detail"
                                                    },
                                                    machine_loading_searching_content: {
                                                        "zh-tw": "雙擊製程方框",
                                                        en: "Double click the process item"
                                                    }
                                                }
                                            }
                                        }
                                    },
                                    team_leader_dispatching: {
                                        "zh-tw": "組長派工",
                                        en: "Team Leader Dispatching",
                                        children: {
                                            title: {
                                                "zh-tw": "組長派工",
                                                en: "Team Leader Dispatching"
                                            },
                                            card_title: {
                                                "zh-tw": "今日欲完成製程",
                                                en: "Today's processes waiting to finish"
                                            },
                                        }
                                    }
                                }
                            }
                        }
                    },
                    main_header: {
                        "zh-tw": "標頭",
                        en: "Main Header",
                        children: {
                            header_subtitle: {
                                "zh-tw": "時間排程設定使用流程",
                                en: "Timeline Arrangement Manual",
                            },
                            steps: {
                                "zh-tw": "使用流程",
                                en: "Manual Steps",
                                children: {
                                    total_timeline_arrangement_overview_title: {
                                        "zh-tw": "總覽所有時程安排",
                                        en: "Total Timeline Arrangement Overview"
                                    },
                                    total_timeline_arrangement_overview_subtitle: {
                                        "zh-tw": "以日曆形式呈現時程安排概況",
                                        en: "Using Calendar Form to Present Arrangement Overview"
                                    },
                                    timeline_adjustment: {
                                        "zh-tw": "時程調整",
                                        en: "Timeline Adjustment"
                                    },
                                    use_dragging_or_zooming_to_edit_timeline_in_calendar_timeline: {
                                        "zh-tw": "可在橫軸行事曆中拖拉以及縮放來修改時程",
                                        en: "Use Dragging Or Zooming To Edit Timeline In Calendar Timeline"
                                    }
                                }
                            },
                            operation_description: {
                                "zh-tw": "操作說明",
                                en: "Operation Description",
                                children: {
                                    step1: {
                                        "zh-tw": "步驟一",
                                        en: "Step 1"
                                    },
                                    step1_description: {
                                        "zh-tw": "選擇一個時間區間，並且按下查詢，能看到屬於該時間區間內的時程安排。",
                                        en: "Select a datetime range and click the search button, then you can view all the timeline arrangement inside that datetime range."
                                    },
                                    step2: {
                                        "zh-tw": "步驟二",
                                        en: "Step 2"
                                    },
                                    step2_description_1: {
                                        "zh-tw": "圖形介紹：透過日曆查看時程安排概況。",
                                        en: "Introduction for calendar：Overview timeline arrangement through calendar."
                                    },
                                    // step2_description_2: {
                                    //     "zh-tw": "選擇一個時間區間，並且按下查詢，能看到屬於該時間區間內的時程安排。",
                                    //     en: "Select a datetime range and click the search button, then you can view all the timeline arrangement inside that datetime range."
                                    // },
                                    // step2_description_3: {
                                    //     "zh-tw": "選擇一個時間區間，並且按下查詢，能看到屬於該時間區間內的時程安排。",
                                    //     en: "Select a datetime range and click the search button, then you can view all the timeline arrangement inside that datetime range."
                                    // },
                                    // step2_description_4: {
                                    //     "zh-tw": "選擇一個時間區間，並且按下查詢，能看到屬於該時間區間內的時程安排。",
                                    //     en: "Select a datetime range and click the search button, then you can view all the timeline arrangement inside that datetime range."
                                    // }
                                }
                            }
                        }
                    },
                }
            },
            login: {
                'zh-tw': "未分類",
                en: "",
                children: {

                    login: {
                        'zh-tw': "登入",
                        en: "login",
                    },
                    forgot_password: {
                        'zh-tw': "忘記密碼",
                        en: "forgot password",
                    },
                    "NKNU e-Learning Platform": {
                        'zh-tw': "國立高雄師範大學 數位教育平台",
                        en: "NKNU e-Learning Platform",
                    },
                    register: {
                        'zh-tw': "註冊",
                        en: "register",
                    },
                    forgot_account: {
                        'zh-tw': "忘記帳號",
                        en: "Forgot account",
                    },
                    reorganize: {
                        'zh-tw': "重新整理",
                        en: "reorganize",
                    },
                    QRcode_login_message: {
                        'zh-tw': "QRcode 登入",
                        en: "QRcode login",
                    },
                    need_bind_message: {
                        'zh-tw': "(須先進行綁定)",
                        en: "need bind first",
                    },
                    welcome: {
                        'zh-tw': "歡迎",
                        en: "welcome",
                    },
                    remember_me: {
                        'zh-tw': "記住我",
                        en: "remember me",
                    },

                }
            },
        }
    },
    imeeting: {
        'zh-tw': "會議系統",
        en: "iMeeting",
        children: {
            meeting_data_main_page: {
                'zh-tw': "會議即時總覽",
                en: "iMeeting",
            },
            current_meeting: {
                'zh-tw': "會議中",
                en: "iMeeting",
            },
            meeting_management: {
                'zh-tw': "會議管理",
                en: "iMeeting",
            },
        }
    },
    demosite: {
        'zh-tw': "Demo 展示系統",
        en: "Demosite",
        children: {
            SubSystem: {
                'zh-tw': "子系統列表",
                en: "Subsystem List ",
                children: {
                    sub_system: {
                        'zh-tw': "子系統",
                        en: "Subsystem",
                    },
                    add_sub_system: {
                        'zh-tw': "新增子系統",
                        en: "Add Subsystem",
                    },
                    add: {
                        'zh-tw': "新增",
                        en: "Add",
                    },
                    edit: {
                        'zh-tw': "編輯",
                        en: "Edit",
                    },
                    delete: {
                        "zh-tw": "刪除",
                        en: "Delete"
                    },
                    cancel: {
                        'zh-tw': "取消",
                        en: "Cancel",
                    },
                    sure: {
                        "zh-tw": "確定",
                        en: "Sure"
                    },
                    edit_success: {
                        'zh-tw': "修改成功",
                        en: "Edit Success",
                    },
                    edit_error: {
                        'zh-tw': "修改失敗",
                        en: "Edit Error",
                    },
                    add_success: {
                        'zh-tw': "新增成功",
                        en: "Add Success",
                    },
                    add_error: {
                        'zh-tw': "新增失敗",
                        en: "Add Error",
                    },
                    delete_error: {
                        'zh-tw': "刪除失敗",
                        en: "Delete Error",
                    },
                    delete_success: {
                        'zh-tw': "刪除成功",
                        en: "Delete Success",
                    },
                    write_complete: {
                        'zh-tw': "請完整填寫必填欄位",
                        en: "Please complete the required fields",
                    },
                    sure_delete: {
                        "zh-tw": "確定要刪除嗎",
                        en: "Sure to delete"
                    },
                    delete_sub_system: {
                        "zh-tw": "刪除子系統",
                        en: "Delete Subsystem"
                    },
                    sub_system_title: {
                        "zh-tw": "子系統標題",
                        en: "Subsystem Title"
                    },
                    sub_system_content: {
                        "zh-tw": "子系統內容",
                        en: "Subsystem Content"
                    },
                    function_name: {
                        "zh-tw": "請輸入功能名稱",
                        en: "Please enter function name"
                    },
                    add_function: {
                        "zh-tw": "新增功能",
                        en: "Add Function"
                    },
                    sub_system_url: {
                        "zh-tw": "子系統路徑",
                        en: "Subsystem Url"
                    },
                    require_title: {
                        "zh-tw": "請輸入子系統標題（必填）",
                        en: "Please enter a subsystem title (required)"
                    },
                    require_content: {
                        "zh-tw": "請輸入子系統內容",
                        en: "Please enter a subsystem contnet"
                    },
                    require_url: {
                        "zh-tw": "請輸入子系統路徑（必填）",
                        en: "Please enter the subsystem url (required)"
                    }
                }
            },
            Function: {
                'zh-tw': "功能列表",
                en: "Function List",
                children: {
                    function: {
                        "zh-tw": "功能",
                        en: "Function"
                    },
                    add_function: {
                        "zh-tw": "新增功能",
                        en: "Add Function"
                    },
                    edit_function: {
                        "zh-tw": "編輯功能",
                        en: "Edit Function"
                    },
                    delete_function: {
                        "zh-tw": "刪除功能",
                        en: "Delete Function"
                    },
                    add: {
                        'zh-tw': "新增",
                        en: "Add",
                    },
                    edit: {
                        'zh-tw': "編輯",
                        en: "Edit",
                    },
                    delete: {
                        "zh-tw": "刪除",
                        en: "Delete"
                    },
                    cancel: {
                        'zh-tw': "取消",
                        en: "Cancel",
                    },
                    sure: {
                        "zh-tw": "確定",
                        en: "Sure"
                    },
                    edit_success: {
                        'zh-tw': "修改成功",
                        en: "Edit Success",
                    },
                    edit_error: {
                        'zh-tw': "修改失敗",
                        en: "Edit Error",
                    },
                    add_success: {
                        'zh-tw': "新增成功",
                        en: "Add Success",
                    },
                    add_error: {
                        'zh-tw': "新增失敗",
                        en: "Add Error",
                    },
                    delete_error: {
                        'zh-tw': "刪除失敗",
                        en: "Delete Error",
                    },
                    delete_success: {
                        'zh-tw': "刪除成功",
                        en: "Delete Success",
                    },
                    write_complete: {
                        'zh-tw': "請完整填寫必填欄位",
                        en: "Please complete the required fields",
                    },
                    sure_delete: {
                        "zh-tw": "確定要刪除嗎",
                        en: "Sure to delete"
                    },
                    add_component: {
                        "zh-tw": "新增元件",
                        en: "Add Component"
                    },
                    edit_component: {
                        "zh-tw": "編輯元件",
                        en: "Edit Component"
                    },
                    show_more: {
                        "zh-tw": "查看更多",
                        en: "Show More"
                    },
                    enter_component_name: {
                        "zh-tw": "請輸入元件名稱",
                        en: "Please enter component name"
                    },
                    enter_function_title: {
                        "zh-tw": "請輸入功能標題（必填）",
                        en: "Please enter function title (required)"
                    },
                    function_title: {
                        "zh-tw": "功能標題",
                        en: "Function Title"
                    },
                    function_content: {
                        "zh-tw": "功能內容",
                        en: "Function Content"
                    },
                    enter_function_conetent: {
                        "zh-tw": "請輸入功能內容",
                        en: "Please enter function content"
                    },
                    enter_component_name: {
                        "zh-tw": "請輸入元件名稱",
                        en: "Please enter component name"
                    },
                    function_url: {
                        "zh-tw": "功能路徑",
                        en: "Function Url"
                    },
                    enter_function_url: {
                        "zh-tw": "請輸入功能路徑（必填）",
                        en: "Please enter function url"
                    },
                },
            },
            Component: {
                'zh-tw': "元件列表",
                en: "Component List",
                children: {
                    component_description: {
                        "zh-tw": "元件說明",
                        en: "Component Description",
                    },
                    add: {
                        'zh-tw': "新增",
                        en: "Add",
                    },
                    edit: {
                        'zh-tw': "編輯",
                        en: "Edit",
                    },
                    update: {
                        'zh-tw': "修改",
                        en: "Update",
                    },
                    send: {
                        'zh-tw': "送出",
                        en: "Send",
                    },
                    delete: {
                        "zh-tw": "刪除",
                        en: "Delete"
                    },
                    cancel: {
                        'zh-tw': "取消",
                        en: "Cancel",
                    },
                    sure: {
                        "zh-tw": "確定",
                        en: "Sure"
                    },
                    edit_success: {
                        'zh-tw': "修改成功",
                        en: "Edit Success",
                    },
                    edit_error: {
                        'zh-tw': "修改失敗",
                        en: "Edit Error",
                    },
                    add_success: {
                        'zh-tw': "新增成功",
                        en: "Add Success",
                    },
                    add_error: {
                        'zh-tw': "新增失敗",
                        en: "Add Error",
                    },
                    delete_error: {
                        'zh-tw': "刪除失敗",
                        en: "Delete Error",
                    },
                    delete_success: {
                        'zh-tw': "刪除成功",
                        en: "Delete Success",
                    },
                    write_complete: {
                        'zh-tw': "請完整填寫必填欄位",
                        en: "Please complete the required fields",
                    },
                    show_more: {
                        "zh-tw": "查看更多",
                        en: "Show More"
                    },
                    sure_delete: {
                        "zh-tw": "確定要刪除嗎",
                        en: "Sure to delete"
                    },
                    add_component: {
                        "zh-tw": "新增元件",
                        en: "Add Component"
                    },
                    edit_component: {
                        "zh-tw": "編輯元件",
                        en: "Edit Component"
                    },
                    delete_component: {
                        "zh-tw": "刪除元件",
                        en: "Delete Component"
                    },
                    attention_file: {
                        "zh-tw": "＊請注意圖片大小，限制在2MB以內",
                        en: "＊Please pay attention to the size of the picture, it is limited within 2MB"
                    },
                    upload_pic: {
                        "zh-tw": "上傳圖片",
                        en: "Upload Picture"
                    },
                    sure_delete_pic: {
                        "zh-tw": "確認要刪除此張圖片嗎？",
                        en: "Are you sure you want to delete this picture?"
                    },
                    delete_component: {
                        "zh-tw": "刪除元件",
                        en: "Delete Component"
                    },
                    component_title: {
                        "zh-tw": "元件標題",
                        en: "Component Name"
                    },
                    enter_component_title: {
                        "zh-tw": "請輸入元件標題（必填）",
                        en: "Please enter the component title (required)"
                    },
                    enter_component_content: {
                        "zh-tw": "請輸入元件內容",
                        en: "Please enter component content"
                    },
                    component_content: {
                        "zh-tw": "元件內容",
                        en: "Component Content"
                    },
                    get_start: {
                        "zh-tw": "請由此開始進行操作",
                        en: "Get started here"
                    },
                    upload_video: {
                        "zh-tw": "上傳影片",
                        en: "Upload Video"
                    },
                    add_video: {
                        "zh-tw": "新增影片",
                        en: "Add Video"
                    },
                    edit_video: {
                        "zh-tw": "編輯影片",
                        en: "Edit Video"
                    },
                    add_graph_component: {
                        "zh-tw": "新增圖文元件",
                        en: "Add Graphic Component"
                    },
                    graph_component: {
                        "zh-tw": "圖文元件",
                        en: "Graphic Component"
                    },
                    add_word: {
                        "zh-tw": "新增文字",
                        en: "Add Word"
                    },
                    edit_word: {
                        "zh-tw": "編輯文字",
                        en: "Edit Word"
                    },
                    add_word_component: {
                        "zh-tw": "新增文字元件",
                        en: "Add Word Component"
                    },
                    add_video: {
                        "zh-tw": "新增影片",
                        en: "Add Video"
                    },
                    edit_video: {
                        "zh-tw": "編輯影片",
                        en: "Edit Video"
                    },
                    add_video_component: {
                        "zh-tw": "新增影片元件",
                        en: "Add Video Component"
                    },
                    add_picture: {
                        "zh-tw": "新增照片",
                        en: "Add Picture"
                    },
                    edit_picture: {
                        "zh-tw": "編輯照片",
                        en: "Edit Picture"
                    },
                    add_picture_component: {
                        "zh-tw": "新增照片元件",
                        en: "Add Picture Component"
                    },
                    pic_carousel: {
                        "zh-tw": "照片跑馬燈",
                        en: "Picture Carousel"
                    },
                    word_block: {
                        "zh-tw": "文字區塊",
                        en: "Word Block"
                    },
                    video_block: {
                        "zh-tw": "影片區塊",
                        en: "Video Block"
                    },
                    word_pic_block: {
                        "zh-tw": "文字及圖片區",
                        en: "Word And Picture Block"
                    },
                    edit_block: {
                        "zh-tw": "編輯區塊",
                        en: "Edit Block"
                    },
                    show_notshow: {
                        "zh-tw": "Show/Nor Show",
                        en: "Video Block"
                    },
                    drag_order: {
                        "zh-tw": "請拖拉進行排序",
                        en: "Please drag and drop to sort"
                    },
                    back_page: {
                        "zh-tw": "上一頁",
                        en: "Back"
                    },
                    click_to_show: {
                        "zh-tw": "點我體驗",
                        en: "Click to show"
                    },
                    description: {
                        "zh-tw": "說明",
                        en: "Description"
                    },
                    show_more:{
                        "zh-tw": "查看更多",
                        en: "Show More"
                    }
                }
            },
        }
    },
    ui:{
        'zh-tw': "ui 組件",
        en: "ui components", 
        children:{
            RowCol:{
                'zh-tw': "RowCol",
                en: "RowCol", 
            },
            ProTableOt:{
                'zh-tw': "ProTableOt",
                en: "ProTableOt", 
            },
        }
    }
}
export default Language
